"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Backend API
 * This is the API to communicate from the device to the backend.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.InstallApiFp = exports.InstallApiAxiosParamCreator = exports.HosApi = exports.HosApiFactory = exports.HosApiFp = exports.HosApiAxiosParamCreator = exports.EventApi = exports.EventApiFactory = exports.EventApiFp = exports.EventApiAxiosParamCreator = exports.ControlApi = exports.ControlApiFactory = exports.ControlApiFp = exports.ControlApiAxiosParamCreator = exports.ApiApi = exports.ApiApiFactory = exports.ApiApiFp = exports.ApiApiAxiosParamCreator = exports.AgencyApi = exports.AgencyApiFactory = exports.AgencyApiFp = exports.AgencyApiAxiosParamCreator = exports.VideoPreviewRequestStatusEnum = exports.UserRole = exports.TripDetailsDriverAssignmentMethodEnum = exports.RequestStatus = exports.PolicyV2CustomerTypeEnum = exports.PolicyV2VehicleTypeEnum = exports.OverrideStop = exports.OverrideDriving = exports.MalfunctionPolicyCustomerTypeEnum = exports.MalfunctionTypeEnum = exports.InstallationCommandResultStatusEnum = exports.HosTransferRequestMethodEnum = exports.ExperimentDeviceRequestActionEnum = exports.EventTagActionEnum = exports.EventOverlayRequestLanguageEnum = exports.DeviceHardware = exports.DeviceConfigStatusStatusEnum = exports.CoachingMetadataMetadataMethodEnum = exports.CoachingMetadataMetadataActionEnum = exports.CoachWellnessDetailsActionEnum = exports.CoachMetricsAdditionalDataEnum = exports.CoachMetricsTimeFrameEnum = exports.CoachMetricsScoreTypeEnum = exports.CoachEventDetailsActionEnum = exports.CloneEventDetailsLevelEnum = exports.BrowserStreamMessagesResponseMessagesTypeEnum = exports.BackendResultStatusEnum = exports.ArtifactActionActionEnum = void 0;
exports.InstallApi = exports.InstallApiFactory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var ArtifactActionActionEnum;
(function (ArtifactActionActionEnum) {
    ArtifactActionActionEnum["Mail"] = "mail";
    ArtifactActionActionEnum["Edit"] = "edit";
    ArtifactActionActionEnum["Delete"] = "delete";
})(ArtifactActionActionEnum = exports.ArtifactActionActionEnum || (exports.ArtifactActionActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BackendResultStatusEnum;
(function (BackendResultStatusEnum) {
    BackendResultStatusEnum["Success"] = "success";
    BackendResultStatusEnum["Failure"] = "failure";
})(BackendResultStatusEnum = exports.BackendResultStatusEnum || (exports.BackendResultStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BrowserStreamMessagesResponseMessagesTypeEnum;
(function (BrowserStreamMessagesResponseMessagesTypeEnum) {
    BrowserStreamMessagesResponseMessagesTypeEnum["Offer"] = "offer";
    BrowserStreamMessagesResponseMessagesTypeEnum["Answer"] = "answer";
    BrowserStreamMessagesResponseMessagesTypeEnum["Ice"] = "ice";
    BrowserStreamMessagesResponseMessagesTypeEnum["Terminate"] = "terminate";
})(BrowserStreamMessagesResponseMessagesTypeEnum = exports.BrowserStreamMessagesResponseMessagesTypeEnum || (exports.BrowserStreamMessagesResponseMessagesTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CloneEventDetailsLevelEnum;
(function (CloneEventDetailsLevelEnum) {
    CloneEventDetailsLevelEnum["Info"] = "INFO";
    CloneEventDetailsLevelEnum["Warning"] = "WARNING";
    CloneEventDetailsLevelEnum["Alert"] = "ALERT";
})(CloneEventDetailsLevelEnum = exports.CloneEventDetailsLevelEnum || (exports.CloneEventDetailsLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CoachEventDetailsActionEnum;
(function (CoachEventDetailsActionEnum) {
    CoachEventDetailsActionEnum["Add"] = "ADD";
    CoachEventDetailsActionEnum["Remove"] = "REMOVE";
})(CoachEventDetailsActionEnum = exports.CoachEventDetailsActionEnum || (exports.CoachEventDetailsActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CoachMetricsScoreTypeEnum;
(function (CoachMetricsScoreTypeEnum) {
    CoachMetricsScoreTypeEnum["Safety"] = "safety";
    CoachMetricsScoreTypeEnum["Wellness"] = "wellness";
})(CoachMetricsScoreTypeEnum = exports.CoachMetricsScoreTypeEnum || (exports.CoachMetricsScoreTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CoachMetricsTimeFrameEnum;
(function (CoachMetricsTimeFrameEnum) {
    CoachMetricsTimeFrameEnum["Current"] = "current";
    CoachMetricsTimeFrameEnum["Week"] = "week";
    CoachMetricsTimeFrameEnum["Month"] = "month";
    CoachMetricsTimeFrameEnum["Quarter"] = "quarter";
})(CoachMetricsTimeFrameEnum = exports.CoachMetricsTimeFrameEnum || (exports.CoachMetricsTimeFrameEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CoachMetricsAdditionalDataEnum;
(function (CoachMetricsAdditionalDataEnum) {
    CoachMetricsAdditionalDataEnum["None"] = "none";
    CoachMetricsAdditionalDataEnum["SubFleet"] = "sub_fleet";
    CoachMetricsAdditionalDataEnum["Fleet"] = "fleet";
})(CoachMetricsAdditionalDataEnum = exports.CoachMetricsAdditionalDataEnum || (exports.CoachMetricsAdditionalDataEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CoachWellnessDetailsActionEnum;
(function (CoachWellnessDetailsActionEnum) {
    CoachWellnessDetailsActionEnum["Add"] = "ADD";
    CoachWellnessDetailsActionEnum["Remove"] = "REMOVE";
})(CoachWellnessDetailsActionEnum = exports.CoachWellnessDetailsActionEnum || (exports.CoachWellnessDetailsActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CoachingMetadataMetadataActionEnum;
(function (CoachingMetadataMetadataActionEnum) {
    CoachingMetadataMetadataActionEnum["Create"] = "create";
    CoachingMetadataMetadataActionEnum["Send"] = "send";
    CoachingMetadataMetadataActionEnum["Open"] = "open";
    CoachingMetadataMetadataActionEnum["Complete"] = "complete";
    CoachingMetadataMetadataActionEnum["Generate"] = "generate";
    CoachingMetadataMetadataActionEnum["Watch"] = "watch";
    CoachingMetadataMetadataActionEnum["Reopen"] = "reopen";
})(CoachingMetadataMetadataActionEnum = exports.CoachingMetadataMetadataActionEnum || (exports.CoachingMetadataMetadataActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CoachingMetadataMetadataMethodEnum;
(function (CoachingMetadataMetadataMethodEnum) {
    CoachingMetadataMetadataMethodEnum["Onsite"] = "onsite";
    CoachingMetadataMetadataMethodEnum["Remote"] = "remote";
})(CoachingMetadataMetadataMethodEnum = exports.CoachingMetadataMetadataMethodEnum || (exports.CoachingMetadataMetadataMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DeviceConfigStatusStatusEnum;
(function (DeviceConfigStatusStatusEnum) {
    DeviceConfigStatusStatusEnum["Created"] = "CREATED";
    DeviceConfigStatusStatusEnum["Pending"] = "PENDING";
    DeviceConfigStatusStatusEnum["Downloaded"] = "DOWNLOADED";
    DeviceConfigStatusStatusEnum["Aligned"] = "ALIGNED";
    DeviceConfigStatusStatusEnum["NoOverlay"] = "NO_OVERLAY";
    DeviceConfigStatusStatusEnum["AlignedObsolete"] = "ALIGNED_OBSOLETE";
})(DeviceConfigStatusStatusEnum = exports.DeviceConfigStatusStatusEnum || (exports.DeviceConfigStatusStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DeviceHardware;
(function (DeviceHardware) {
    DeviceHardware["ReachengR1"] = "Reacheng_R1";
    DeviceHardware["MitacK220"] = "Mitac_K220";
    DeviceHardware["MitacSprint"] = "Mitac_Sprint";
})(DeviceHardware = exports.DeviceHardware || (exports.DeviceHardware = {}));
/**
    * @export
    * @enum {string}
    */
var EventOverlayRequestLanguageEnum;
(function (EventOverlayRequestLanguageEnum) {
    EventOverlayRequestLanguageEnum["EnglishF"] = "english_f";
    EventOverlayRequestLanguageEnum["EnglishM"] = "english_m";
    EventOverlayRequestLanguageEnum["HebrewM"] = "hebrew_m";
    EventOverlayRequestLanguageEnum["SpanishM"] = "spanish_m";
})(EventOverlayRequestLanguageEnum = exports.EventOverlayRequestLanguageEnum || (exports.EventOverlayRequestLanguageEnum = {}));
/**
    * @export
    * @enum {string}
    */
var EventTagActionEnum;
(function (EventTagActionEnum) {
    EventTagActionEnum["Add"] = "ADD";
    EventTagActionEnum["Remove"] = "REMOVE";
})(EventTagActionEnum = exports.EventTagActionEnum || (exports.EventTagActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ExperimentDeviceRequestActionEnum;
(function (ExperimentDeviceRequestActionEnum) {
    ExperimentDeviceRequestActionEnum["Add"] = "add";
    ExperimentDeviceRequestActionEnum["Remove"] = "remove";
    ExperimentDeviceRequestActionEnum["Sample"] = "sample";
})(ExperimentDeviceRequestActionEnum = exports.ExperimentDeviceRequestActionEnum || (exports.ExperimentDeviceRequestActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var HosTransferRequestMethodEnum;
(function (HosTransferRequestMethodEnum) {
    HosTransferRequestMethodEnum["Mail"] = "mail";
    HosTransferRequestMethodEnum["WebService"] = "web_service";
})(HosTransferRequestMethodEnum = exports.HosTransferRequestMethodEnum || (exports.HosTransferRequestMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InstallationCommandResultStatusEnum;
(function (InstallationCommandResultStatusEnum) {
    InstallationCommandResultStatusEnum["Pending"] = "pending";
    InstallationCommandResultStatusEnum["Started"] = "started";
    InstallationCommandResultStatusEnum["Streaming"] = "streaming";
    InstallationCommandResultStatusEnum["Success"] = "success";
    InstallationCommandResultStatusEnum["Failure"] = "failure";
    InstallationCommandResultStatusEnum["NoSupport"] = "no_support";
})(InstallationCommandResultStatusEnum = exports.InstallationCommandResultStatusEnum || (exports.InstallationCommandResultStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MalfunctionTypeEnum;
(function (MalfunctionTypeEnum) {
    MalfunctionTypeEnum["InCabinV1"] = "IN_CABIN_V1";
    MalfunctionTypeEnum["FrontFacing"] = "FRONT_FACING";
    MalfunctionTypeEnum["DeviceWellness"] = "DEVICE_WELLNESS";
    MalfunctionTypeEnum["MultipleButtonPresses"] = "MULTIPLE_BUTTON_PRESSES";
    MalfunctionTypeEnum["SystemConstantlyOn"] = "SYSTEM_CONSTANTLY_ON";
    MalfunctionTypeEnum["WrongInstallation"] = "WRONG_INSTALLATION";
    MalfunctionTypeEnum["PendingInstallation"] = "PENDING_INSTALLATION";
    MalfunctionTypeEnum["PendingRemoval"] = "PENDING_REMOVAL";
    MalfunctionTypeEnum["WrongLicensePlate"] = "WRONG_LICENSE_PLATE";
    MalfunctionTypeEnum["InactiveDevice"] = "INACTIVE_DEVICE";
    MalfunctionTypeEnum["MultipleImproperShutdownsHw"] = "MULTIPLE_IMPROPER_SHUTDOWNS_HW";
    MalfunctionTypeEnum["SdWellness"] = "SD_WELLNESS";
})(MalfunctionTypeEnum = exports.MalfunctionTypeEnum || (exports.MalfunctionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MalfunctionPolicyCustomerTypeEnum;
(function (MalfunctionPolicyCustomerTypeEnum) {
    MalfunctionPolicyCustomerTypeEnum["Insured"] = "insured";
    MalfunctionPolicyCustomerTypeEnum["Saas"] = "saas";
    MalfunctionPolicyCustomerTypeEnum["ClaimsHandling"] = "claims_handling";
    MalfunctionPolicyCustomerTypeEnum["Pilot"] = "pilot";
    MalfunctionPolicyCustomerTypeEnum["Pending"] = "pending";
})(MalfunctionPolicyCustomerTypeEnum = exports.MalfunctionPolicyCustomerTypeEnum || (exports.MalfunctionPolicyCustomerTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var OverrideDriving;
(function (OverrideDriving) {
    OverrideDriving["D"] = "D";
    OverrideDriving["Ym"] = "YM";
    OverrideDriving["Pc"] = "PC";
})(OverrideDriving = exports.OverrideDriving || (exports.OverrideDriving = {}));
/**
 *
 * @export
 * @enum {string}
 */
var OverrideStop;
(function (OverrideStop) {
    OverrideStop["On"] = "ON";
    OverrideStop["Off"] = "OFF";
})(OverrideStop = exports.OverrideStop || (exports.OverrideStop = {}));
/**
    * @export
    * @enum {string}
    */
var PolicyV2VehicleTypeEnum;
(function (PolicyV2VehicleTypeEnum) {
    PolicyV2VehicleTypeEnum["Truck"] = "truck";
    PolicyV2VehicleTypeEnum["Ptb"] = "ptb";
    PolicyV2VehicleTypeEnum["Bus"] = "bus";
    PolicyV2VehicleTypeEnum["Midibus"] = "midibus";
    PolicyV2VehicleTypeEnum["Minibus"] = "minibus";
    PolicyV2VehicleTypeEnum["Other"] = "other";
})(PolicyV2VehicleTypeEnum = exports.PolicyV2VehicleTypeEnum || (exports.PolicyV2VehicleTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PolicyV2CustomerTypeEnum;
(function (PolicyV2CustomerTypeEnum) {
    PolicyV2CustomerTypeEnum["Insured"] = "insured";
    PolicyV2CustomerTypeEnum["Saas"] = "saas";
    PolicyV2CustomerTypeEnum["ClaimsHandling"] = "claims_handling";
    PolicyV2CustomerTypeEnum["Pilot"] = "pilot";
    PolicyV2CustomerTypeEnum["Pending"] = "pending";
})(PolicyV2CustomerTypeEnum = exports.PolicyV2CustomerTypeEnum || (exports.PolicyV2CustomerTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["Pending"] = "pending";
    RequestStatus["Approved"] = "approved";
    RequestStatus["Rejected"] = "rejected";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
/**
    * @export
    * @enum {string}
    */
var TripDetailsDriverAssignmentMethodEnum;
(function (TripDetailsDriverAssignmentMethodEnum) {
    TripDetailsDriverAssignmentMethodEnum["Null"] = "NULL";
    TripDetailsDriverAssignmentMethodEnum["Default"] = "DEFAULT";
    TripDetailsDriverAssignmentMethodEnum["Manual"] = "MANUAL";
    TripDetailsDriverAssignmentMethodEnum["DriverQr"] = "DRIVER_QR";
})(TripDetailsDriverAssignmentMethodEnum = exports.TripDetailsDriverAssignmentMethodEnum || (exports.TripDetailsDriverAssignmentMethodEnum = {}));
/**
 * role name - new permission scheme
 * @export
 * @enum {string}
 */
var UserRole;
(function (UserRole) {
    UserRole["OeAdmin"] = "oe_admin";
    UserRole["OeInsuranceOperator"] = "oe_insurance_operator";
    UserRole["OeDev"] = "oe_dev";
    UserRole["FleetAdmin"] = "fleet_admin";
    UserRole["FleetInsuranceOperator"] = "fleet_insurance_operator";
    UserRole["FleetSafetyManager"] = "fleet_safety_manager";
    UserRole["FleetExecutive"] = "fleet_executive";
    UserRole["FleetOperationsControl"] = "fleet_operations_control";
    UserRole["Driver"] = "driver";
    UserRole["CarShop"] = "car_shop";
    UserRole["Technician"] = "technician";
    UserRole["GuestTechnician"] = "guest_technician";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
/**
    * @export
    * @enum {string}
    */
var VideoPreviewRequestStatusEnum;
(function (VideoPreviewRequestStatusEnum) {
    VideoPreviewRequestStatusEnum["Pending"] = "pending";
    VideoPreviewRequestStatusEnum["Success"] = "success";
    VideoPreviewRequestStatusEnum["Failure"] = "failure";
})(VideoPreviewRequestStatusEnum = exports.VideoPreviewRequestStatusEnum || (exports.VideoPreviewRequestStatusEnum = {}));
/**
 * AgencyApi - axios parameter creator
 * @export
 */
var AgencyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get list of claims
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimGet: function (date, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v0/claim";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update claim assigned to accident
         * @param {Array<UpdateClaimRequest>} [updateClaimRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPatch: function (updateClaimRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v0/claim";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateClaimRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Load claim data
         * @param {LoadClaimsRequest} [loadClaimsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPost: function (loadClaimsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v0/claim";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loadClaimsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get upload url for claim file
         * @param {ClaimFileRequest} [claimFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimUploadPost: function (claimFileRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v0/claim/upload";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(claimFileRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV0EventEventIdGet', 'eventId', eventId);
                    localVarPath = "/agency/v0/event/{eventId}"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdImageGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV0EventEventIdImageGet', 'eventId', eventId);
                    localVarPath = "/agency/v0/event/{eventId}/image"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of insurance periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v0/period";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update insurance period
         * @param {number} periodId
         * @param {InsurancePeriod} [insurancePeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPeriodIdPatch: function (periodId, insurancePeriod, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'periodId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV0PeriodPeriodIdPatch', 'periodId', periodId);
                    localVarPath = "/agency/v0/period/{periodId}"
                        .replace("{".concat("periodId", "}"), encodeURIComponent(String(periodId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(insurancePeriod, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new insurance period
         * @param {InsurancePeriod} [insurancePeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPost: function (insurancePeriod, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v0/period";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(insurancePeriod, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Do action on artifact
         * @summary Do action on artifact
         * @param {number} accidentId
         * @param {number} artifactId
         * @param {ArtifactAction} [artifactAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdActionPost: function (accidentId, artifactId, artifactAction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdArtifactArtifactIdActionPost', 'accidentId', accidentId);
                    // verify required parameter 'artifactId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdArtifactArtifactIdActionPost', 'artifactId', artifactId);
                    localVarPath = "/agency/v1/accident/{accidentId}/artifact/{artifactId}/action"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("artifactId", "}"), encodeURIComponent(String(artifactId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(artifactAction, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get signed url for artifact
         * @summary Get signed url for artifact
         * @param {number} accidentId
         * @param {number} artifactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdGet: function (accidentId, artifactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdArtifactArtifactIdGet', 'accidentId', accidentId);
                    // verify required parameter 'artifactId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdArtifactArtifactIdGet', 'artifactId', artifactId);
                    localVarPath = "/agency/v1/accident/{accidentId}/artifact/{artifactId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("artifactId", "}"), encodeURIComponent(String(artifactId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get upload url for artifact
         * @summary Get upload url for artifact
         * @param {number} accidentId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPost: function (accidentId, fileData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdArtifactPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/artifact"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId
         * @param {ArtifactRequest} [artifactRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPut: function (accidentId, artifactRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdArtifactPut', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/artifact"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(artifactRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update comment
         * @summary Update comment
         * @param {number} accidentId
         * @param {number} commentId
         * @param {Comment} [comment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentCommentIdPatch: function (accidentId, commentId, comment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdCommentCommentIdPatch', 'accidentId', accidentId);
                    // verify required parameter 'commentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdCommentCommentIdPatch', 'commentId', commentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/comment/{commentId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("commentId", "}"), encodeURIComponent(String(commentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(comment, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new comment
         * @summary Create new comment
         * @param {number} accidentId
         * @param {Comment} [comment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentPost: function (accidentId, comment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdCommentPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/comment"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(comment, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get damage details
         * @summary Get damage details
         * @param {number} accidentId
         * @param {number} damageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdGet: function (accidentId, damageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdGet', 'accidentId', accidentId);
                    // verify required parameter 'damageId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdGet', 'damageId', damageId);
                    localVarPath = "/agency/v1/accident/{accidentId}/damage/{damageId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("damageId", "}"), encodeURIComponent(String(damageId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update damage details
         * @summary Update damage details
         * @param {number} accidentId
         * @param {number} damageId
         * @param {Damage} [damage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPatch: function (accidentId, damageId, damage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPatch', 'accidentId', accidentId);
                    // verify required parameter 'damageId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPatch', 'damageId', damageId);
                    localVarPath = "/agency/v1/accident/{accidentId}/damage/{damageId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("damageId", "}"), encodeURIComponent(String(damageId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(damage, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Delete payment
         * @summary Delete payment
         * @param {number} accidentId
         * @param {number} damageId
         * @param {number} paymentId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete: function (accidentId, damageId, paymentId, payment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete', 'accidentId', accidentId);
                    // verify required parameter 'damageId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete', 'damageId', damageId);
                    // verify required parameter 'paymentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete', 'paymentId', paymentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/damage/{damageId}/payment/{paymentId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("damageId", "}"), encodeURIComponent(String(damageId)))
                        .replace("{".concat("paymentId", "}"), encodeURIComponent(String(paymentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payment, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Change payment status
         * @summary Change payment status
         * @param {number} accidentId
         * @param {number} damageId
         * @param {number} paymentId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch: function (accidentId, damageId, paymentId, payment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch', 'accidentId', accidentId);
                    // verify required parameter 'damageId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch', 'damageId', damageId);
                    // verify required parameter 'paymentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch', 'paymentId', paymentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/damage/{damageId}/payment/{paymentId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("damageId", "}"), encodeURIComponent(String(damageId)))
                        .replace("{".concat("paymentId", "}"), encodeURIComponent(String(paymentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payment, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new payment
         * @summary Create new payment
         * @param {number} accidentId
         * @param {number} damageId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPost: function (accidentId, damageId, payment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPost', 'accidentId', accidentId);
                    // verify required parameter 'damageId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamageDamageIdPaymentPost', 'damageId', damageId);
                    localVarPath = "/agency/v1/accident/{accidentId}/damage/{damageId}/payment"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("damageId", "}"), encodeURIComponent(String(damageId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payment, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create damage
         * @summary Create damage
         * @param {number} accidentId
         * @param {Damage} [damage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamagePost: function (accidentId, damage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDamagePost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/damage"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(damage, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create or update driver details
         * @summary Create or update driver details
         * @param {number} accidentId
         * @param {Driver} [driver]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDriverPost: function (accidentId, driver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdDriverPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/driver"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driver, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get accident details
         * @summary Get accident details
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdGet: function (accidentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdGet', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create accident notice form
         * @param {number} accidentId
         * @param {NoticeRequest} [noticeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNoticePost: function (accidentId, noticeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdNoticePost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/notice"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(noticeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationDelete: function (accidentId, notificationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdNotificationDelete', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/notification"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get notifications list for accident
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationGet: function (accidentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdNotificationGet', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/notification"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPatch: function (accidentId, notificationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdNotificationPatch', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/notification"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPost: function (accidentId, notificationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdNotificationPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/notification"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {number} accidentId
         * @param {ExtendedAccident} extendedAccident Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdPatch: function (accidentId, extendedAccident, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdPatch', 'accidentId', accidentId);
                    // verify required parameter 'extendedAccident' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdPatch', 'extendedAccident', extendedAccident);
                    localVarPath = "/agency/v1/accident/{accidentId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(extendedAccident, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send accident to users
         * @param {number} accidentId
         * @param {SendAccidentRequest} [sendAccidentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdSendPost: function (accidentId, sendAccidentRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdSendPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/send"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendAccidentRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTags} [accidentTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPatch: function (accidentId, accidentTags, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsPatch', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accidentTags, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTags} [accidentTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPost: function (accidentId, accidentTags, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accidentTags, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Get: function (accidentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsV1Get', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags/v1"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV1} [accidentTagsV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Patch: function (accidentId, accidentTagsV1, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsV1Patch', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags/v1"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accidentTagsV1, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV1} [accidentTagsV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Post: function (accidentId, accidentTagsV1, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsV1Post', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags/v1"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accidentTagsV1, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Get: function (accidentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsV2Get', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags/v2"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV2} [accidentTagsV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Patch: function (accidentId, accidentTagsV2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsV2Patch', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags/v2"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accidentTagsV2, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV2} [accidentTagsV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Post: function (accidentId, accidentTagsV2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdTagsV2Post', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/tags/v2"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accidentTagsV2, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new witness statement
         * @summary Create new witness statement
         * @param {number} accidentId
         * @param {Witness} [witness]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessPost: function (accidentId, witness, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdWitnessPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/accident/{accidentId}/witness"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(witness, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update witness statement
         * @summary Update witness statement
         * @param {number} accidentId
         * @param {number} witnessId
         * @param {Witness} [witness]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessWitnessIdPatch: function (accidentId, witnessId, witness, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdWitnessWitnessIdPatch', 'accidentId', accidentId);
                    // verify required parameter 'witnessId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentAccidentIdWitnessWitnessIdPatch', 'witnessId', witnessId);
                    localVarPath = "/agency/v1/accident/{accidentId}/witness/{witnessId}"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)))
                        .replace("{".concat("witnessId", "}"), encodeURIComponent(String(witnessId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(witness, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get list of customer\'s articat tags
         * @summary Get list of customer\'s articat tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentArtifactTagsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v1/accident/artifact/tags";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate]
         * @param {string} [normLicensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {boolean} [isClosed]
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {number} [createdFrom]
         * @param {number} [createdTo]
         * @param {number} [lastId]
         * @param {number} [csv]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentGet: function (licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, csv, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v1/accident";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (normLicensePlate !== undefined) {
                        localVarQueryParameter['norm_license_plate'] = normLicensePlate;
                    }
                    if (driverName !== undefined) {
                        localVarQueryParameter['driver_name'] = driverName;
                    }
                    if (licensePlateContains !== undefined) {
                        localVarQueryParameter['license_plate_contains'] = licensePlateContains;
                    }
                    if (driverNameContains !== undefined) {
                        localVarQueryParameter['driver_name_contains'] = driverNameContains;
                    }
                    if (subFleet !== undefined) {
                        localVarQueryParameter['sub_fleet'] = subFleet;
                    }
                    if (isClosed !== undefined) {
                        localVarQueryParameter['is_closed'] = isClosed;
                    }
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (createdFrom !== undefined) {
                        localVarQueryParameter['created_from'] = createdFrom;
                    }
                    if (createdTo !== undefined) {
                        localVarQueryParameter['created_to'] = createdTo;
                    }
                    if (lastId !== undefined) {
                        localVarQueryParameter['last_id'] = lastId;
                    }
                    if (csv !== undefined) {
                        localVarQueryParameter['csv'] = csv;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create accident
         * @summary Create accident
         * @param {ExtendedAccident} extendedAccident Accident to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentPost: function (extendedAccident, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'extendedAccident' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1AccidentPost', 'extendedAccident', extendedAccident);
                    localVarPath = "/agency/v1/accident";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(extendedAccident, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v1/customer/data";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new customer data
         * @param {CustomerHandlingStatus} [customerHandlingStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataPost: function (customerHandlingStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v1/customer/data";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerHandlingStatus, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create disposal letter for damage
         * @param {string} damageId
         * @param {DisposalLetterRequest} [disposalLetterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DamageDamageIdDisposalPost: function (damageId, disposalLetterRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'damageId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1DamageDamageIdDisposalPost', 'damageId', damageId);
                    localVarPath = "/agency/v1/damage/{damageId}/disposal"
                        .replace("{".concat("damageId", "}"), encodeURIComponent(String(damageId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(disposalLetterRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Upload file for accident from driver form
         * @param {number} accidentId
         * @param {ExtendedFileData} [extendedFileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePost: function (accidentId, extendedFileData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1DriverFormAccidentIdFilePost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/driver/form/{accidentId}/file"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(extendedFileData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId
         * @param {ExtendedArtifact} [extendedArtifact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePut: function (accidentId, extendedArtifact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1DriverFormAccidentIdFilePut', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/driver/form/{accidentId}/file"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(extendedArtifact, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get app review from driver form
         * @param {number} accidentId
         * @param {DriverFormReview} [driverFormReview]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdReviewPost: function (accidentId, driverFormReview, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1DriverFormAccidentIdReviewPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v1/driver/form/{accidentId}/review"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driverFormReview, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create accident from driver form
         * @param {DriverForm} [driverForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormPost: function (driverForm, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v1/driver/form";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driverForm, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get policy list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v1/policy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update policy
         * @param {number} policyId
         * @param {PolicyV1Request} [policyV1Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPolicyIdPatch: function (policyId, policyV1Request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV1PolicyPolicyIdPatch', 'policyId', policyId);
                    localVarPath = "/agency/v1/policy/{policyId}"
                        .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyV1Request, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new policy
         * @param {PolicyV1Request} [policyV1Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPost: function (policyV1Request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v1/policy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyV1Request, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new notification for accident (UI only)
         * @param {number} accidentId
         * @param {NotificationRequestV2} [notificationRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentAccidentIdNotificationPost: function (accidentId, notificationRequestV2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accidentId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV2AccidentAccidentIdNotificationPost', 'accidentId', accidentId);
                    localVarPath = "/agency/v2/accident/{accidentId}/notification"
                        .replace("{".concat("accidentId", "}"), encodeURIComponent(String(accidentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationRequestV2, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate]
         * @param {string} [normLicensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {boolean} [isClosed]
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {number} [createdFrom]
         * @param {number} [createdTo]
         * @param {number} [lastId]
         * @param {number} [limit]
         * @param {number} [csv]
         * @param {string} [damageCause]
         * @param {string} [speed]
         * @param {string} [fault]
         * @param {string} [pointOfImpact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentGet: function (licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, limit, csv, damageCause, speed, fault, pointOfImpact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v2/accident";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (normLicensePlate !== undefined) {
                        localVarQueryParameter['norm_license_plate'] = normLicensePlate;
                    }
                    if (driverName !== undefined) {
                        localVarQueryParameter['driver_name'] = driverName;
                    }
                    if (licensePlateContains !== undefined) {
                        localVarQueryParameter['license_plate_contains'] = licensePlateContains;
                    }
                    if (driverNameContains !== undefined) {
                        localVarQueryParameter['driver_name_contains'] = driverNameContains;
                    }
                    if (subFleet !== undefined) {
                        localVarQueryParameter['sub_fleet'] = subFleet;
                    }
                    if (isClosed !== undefined) {
                        localVarQueryParameter['is_closed'] = isClosed;
                    }
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (createdFrom !== undefined) {
                        localVarQueryParameter['created_from'] = createdFrom;
                    }
                    if (createdTo !== undefined) {
                        localVarQueryParameter['created_to'] = createdTo;
                    }
                    if (lastId !== undefined) {
                        localVarQueryParameter['last_id'] = lastId;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (csv !== undefined) {
                        localVarQueryParameter['csv'] = csv;
                    }
                    if (damageCause !== undefined) {
                        localVarQueryParameter['damage_cause'] = damageCause;
                    }
                    if (speed !== undefined) {
                        localVarQueryParameter['speed'] = speed;
                    }
                    if (fault !== undefined) {
                        localVarQueryParameter['fault'] = fault;
                    }
                    if (pointOfImpact !== undefined) {
                        localVarQueryParameter['point_of_impact'] = pointOfImpact;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get report with vehicles to charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyChargeGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v2/policy/charge";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a policy by IDs
         * @param {PolicyDeleteRequest} policyDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyDelete: function (policyDeleteRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyDeleteRequest' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV2PolicyDelete', 'policyDeleteRequest', policyDeleteRequest);
                    localVarPath = "/agency/v2/policy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyDeleteRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve all customer\'s policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/agency/v2/policy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a policy by ID
         * @param {number} policyId ID of the policy to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdDelete: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV2PolicyPolicyIdDelete', 'policyId', policyId);
                    localVarPath = "/agency/v2/policy/{policyId}"
                        .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve a policy by ID
         * @param {number} policyId ID of the policy to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdGet: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV2PolicyPolicyIdGet', 'policyId', policyId);
                    localVarPath = "/agency/v2/policy/{policyId}"
                        .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create or update a policy
         * @param {number} policyId ID of the policy to update (optional)
         * @param {Array<PolicyV2>} policyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdPost: function (policyId, policyV2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyId' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV2PolicyPolicyIdPost', 'policyId', policyId);
                    // verify required parameter 'policyV2' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV2PolicyPolicyIdPost', 'policyV2', policyV2);
                    localVarPath = "/agency/v2/policy/{policyId}"
                        .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyV2, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create or update list of policies
         * @param {Array<PolicyV2>} policyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPost: function (policyV2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyV2' is not null or undefined
                    (0, common_1.assertParamExists)('agencyV2PolicyPost', 'policyV2', policyV2);
                    localVarPath = "/agency/v2/policy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyV2, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/otp";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(oTPUserCredentials, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCredentials, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokenRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        }
    };
};
exports.AgencyApiAxiosParamCreator = AgencyApiAxiosParamCreator;
/**
 * AgencyApi - functional programming interface
 * @export
 */
var AgencyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AgencyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get list of claims
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimGet: function (date, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0ClaimGet(date, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update claim assigned to accident
         * @param {Array<UpdateClaimRequest>} [updateClaimRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPatch: function (updateClaimRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0ClaimPatch(updateClaimRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Load claim data
         * @param {LoadClaimsRequest} [loadClaimsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPost: function (loadClaimsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0ClaimPost(loadClaimsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get upload url for claim file
         * @param {ClaimFileRequest} [claimFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimUploadPost: function (claimFileRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0ClaimUploadPost(claimFileRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0EventEventIdGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdImageGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0EventEventIdImageGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of insurance periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0PeriodGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update insurance period
         * @param {number} periodId
         * @param {InsurancePeriod} [insurancePeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPeriodIdPatch: function (periodId, insurancePeriod, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0PeriodPeriodIdPatch(periodId, insurancePeriod, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new insurance period
         * @param {InsurancePeriod} [insurancePeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPost: function (insurancePeriod, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV0PeriodPost(insurancePeriod, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Do action on artifact
         * @summary Do action on artifact
         * @param {number} accidentId
         * @param {number} artifactId
         * @param {ArtifactAction} [artifactAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdActionPost: function (accidentId, artifactId, artifactAction, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(accidentId, artifactId, artifactAction, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get signed url for artifact
         * @summary Get signed url for artifact
         * @param {number} accidentId
         * @param {number} artifactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdGet: function (accidentId, artifactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactArtifactIdGet(accidentId, artifactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get upload url for artifact
         * @summary Get upload url for artifact
         * @param {number} accidentId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPost: function (accidentId, fileData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactPost(accidentId, fileData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId
         * @param {ArtifactRequest} [artifactRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPut: function (accidentId, artifactRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactPut(accidentId, artifactRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update comment
         * @summary Update comment
         * @param {number} accidentId
         * @param {number} commentId
         * @param {Comment} [comment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentCommentIdPatch: function (accidentId, commentId, comment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdCommentCommentIdPatch(accidentId, commentId, comment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new comment
         * @summary Create new comment
         * @param {number} accidentId
         * @param {Comment} [comment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentPost: function (accidentId, comment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdCommentPost(accidentId, comment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get damage details
         * @summary Get damage details
         * @param {number} accidentId
         * @param {number} damageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdGet: function (accidentId, damageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdGet(accidentId, damageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update damage details
         * @summary Update damage details
         * @param {number} accidentId
         * @param {number} damageId
         * @param {Damage} [damage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPatch: function (accidentId, damageId, damage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPatch(accidentId, damageId, damage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete payment
         * @summary Delete payment
         * @param {number} accidentId
         * @param {number} damageId
         * @param {number} paymentId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete: function (accidentId, damageId, paymentId, payment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(accidentId, damageId, paymentId, payment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Change payment status
         * @summary Change payment status
         * @param {number} accidentId
         * @param {number} damageId
         * @param {number} paymentId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch: function (accidentId, damageId, paymentId, payment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(accidentId, damageId, paymentId, payment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new payment
         * @summary Create new payment
         * @param {number} accidentId
         * @param {number} damageId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPost: function (accidentId, damageId, payment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(accidentId, damageId, payment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create damage
         * @summary Create damage
         * @param {number} accidentId
         * @param {Damage} [damage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamagePost: function (accidentId, damage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamagePost(accidentId, damage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create or update driver details
         * @summary Create or update driver details
         * @param {number} accidentId
         * @param {Driver} [driver]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDriverPost: function (accidentId, driver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdDriverPost(accidentId, driver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get accident details
         * @summary Get accident details
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdGet: function (accidentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdGet(accidentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create accident notice form
         * @param {number} accidentId
         * @param {NoticeRequest} [noticeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNoticePost: function (accidentId, noticeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdNoticePost(accidentId, noticeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationDelete: function (accidentId, notificationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationDelete(accidentId, notificationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get notifications list for accident
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationGet: function (accidentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationGet(accidentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPatch: function (accidentId, notificationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationPatch(accidentId, notificationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPost: function (accidentId, notificationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationPost(accidentId, notificationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {number} accidentId
         * @param {ExtendedAccident} extendedAccident Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdPatch: function (accidentId, extendedAccident, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdPatch(accidentId, extendedAccident, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send accident to users
         * @param {number} accidentId
         * @param {SendAccidentRequest} [sendAccidentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdSendPost: function (accidentId, sendAccidentRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdSendPost(accidentId, sendAccidentRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTags} [accidentTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPatch: function (accidentId, accidentTags, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsPatch(accidentId, accidentTags, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTags} [accidentTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPost: function (accidentId, accidentTags, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsPost(accidentId, accidentTags, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Get: function (accidentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV1Get(accidentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV1} [accidentTagsV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Patch: function (accidentId, accidentTagsV1, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV1Patch(accidentId, accidentTagsV1, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV1} [accidentTagsV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Post: function (accidentId, accidentTagsV1, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV1Post(accidentId, accidentTagsV1, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Get: function (accidentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV2Get(accidentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV2} [accidentTagsV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Patch: function (accidentId, accidentTagsV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV2Patch(accidentId, accidentTagsV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV2} [accidentTagsV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Post: function (accidentId, accidentTagsV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV2Post(accidentId, accidentTagsV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new witness statement
         * @summary Create new witness statement
         * @param {number} accidentId
         * @param {Witness} [witness]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessPost: function (accidentId, witness, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdWitnessPost(accidentId, witness, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update witness statement
         * @summary Update witness statement
         * @param {number} accidentId
         * @param {number} witnessId
         * @param {Witness} [witness]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessWitnessIdPatch: function (accidentId, witnessId, witness, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentAccidentIdWitnessWitnessIdPatch(accidentId, witnessId, witness, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get list of customer\'s articat tags
         * @summary Get list of customer\'s articat tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentArtifactTagsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentArtifactTagsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate]
         * @param {string} [normLicensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {boolean} [isClosed]
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {number} [createdFrom]
         * @param {number} [createdTo]
         * @param {number} [lastId]
         * @param {number} [csv]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentGet: function (licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, csv, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, csv, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create accident
         * @summary Create accident
         * @param {ExtendedAccident} extendedAccident Accident to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentPost: function (extendedAccident, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1AccidentPost(extendedAccident, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1CustomerDataGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new customer data
         * @param {CustomerHandlingStatus} [customerHandlingStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataPost: function (customerHandlingStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1CustomerDataPost(customerHandlingStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create disposal letter for damage
         * @param {string} damageId
         * @param {DisposalLetterRequest} [disposalLetterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DamageDamageIdDisposalPost: function (damageId, disposalLetterRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1DamageDamageIdDisposalPost(damageId, disposalLetterRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload file for accident from driver form
         * @param {number} accidentId
         * @param {ExtendedFileData} [extendedFileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePost: function (accidentId, extendedFileData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1DriverFormAccidentIdFilePost(accidentId, extendedFileData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId
         * @param {ExtendedArtifact} [extendedArtifact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePut: function (accidentId, extendedArtifact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1DriverFormAccidentIdFilePut(accidentId, extendedArtifact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get app review from driver form
         * @param {number} accidentId
         * @param {DriverFormReview} [driverFormReview]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdReviewPost: function (accidentId, driverFormReview, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1DriverFormAccidentIdReviewPost(accidentId, driverFormReview, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create accident from driver form
         * @param {DriverForm} [driverForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormPost: function (driverForm, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1DriverFormPost(driverForm, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get policy list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1PolicyGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update policy
         * @param {number} policyId
         * @param {PolicyV1Request} [policyV1Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPolicyIdPatch: function (policyId, policyV1Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1PolicyPolicyIdPatch(policyId, policyV1Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new policy
         * @param {PolicyV1Request} [policyV1Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPost: function (policyV1Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV1PolicyPost(policyV1Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new notification for accident (UI only)
         * @param {number} accidentId
         * @param {NotificationRequestV2} [notificationRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentAccidentIdNotificationPost: function (accidentId, notificationRequestV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2AccidentAccidentIdNotificationPost(accidentId, notificationRequestV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate]
         * @param {string} [normLicensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {boolean} [isClosed]
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {number} [createdFrom]
         * @param {number} [createdTo]
         * @param {number} [lastId]
         * @param {number} [limit]
         * @param {number} [csv]
         * @param {string} [damageCause]
         * @param {string} [speed]
         * @param {string} [fault]
         * @param {string} [pointOfImpact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentGet: function (licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, limit, csv, damageCause, speed, fault, pointOfImpact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, limit, csv, damageCause, speed, fault, pointOfImpact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get report with vehicles to charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyChargeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2PolicyChargeGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a policy by IDs
         * @param {PolicyDeleteRequest} policyDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyDelete: function (policyDeleteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2PolicyDelete(policyDeleteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve all customer\'s policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2PolicyGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a policy by ID
         * @param {number} policyId ID of the policy to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdDelete: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2PolicyPolicyIdDelete(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a policy by ID
         * @param {number} policyId ID of the policy to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdGet: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2PolicyPolicyIdGet(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create or update a policy
         * @param {number} policyId ID of the policy to update (optional)
         * @param {Array<PolicyV2>} policyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdPost: function (policyId, policyV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2PolicyPolicyIdPost(policyId, policyV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create or update list of policies
         * @param {Array<PolicyV2>} policyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPost: function (policyV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.agencyV2PolicyPost(policyV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthOtpPost(oTPUserCredentials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthPost(userCredentials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthRefreshPost(refreshTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
exports.AgencyApiFp = AgencyApiFp;
/**
 * AgencyApi - factory interface
 * @export
 */
var AgencyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AgencyApiFp)(configuration);
    return {
        /**
         *
         * @summary Get list of claims
         * @param {string} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimGet: function (date, options) {
            return localVarFp.agencyV0ClaimGet(date, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update claim assigned to accident
         * @param {Array<UpdateClaimRequest>} [updateClaimRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPatch: function (updateClaimRequest, options) {
            return localVarFp.agencyV0ClaimPatch(updateClaimRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Load claim data
         * @param {LoadClaimsRequest} [loadClaimsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPost: function (loadClaimsRequest, options) {
            return localVarFp.agencyV0ClaimPost(loadClaimsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get upload url for claim file
         * @param {ClaimFileRequest} [claimFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimUploadPost: function (claimFileRequest, options) {
            return localVarFp.agencyV0ClaimUploadPost(claimFileRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdGet: function (eventId, options) {
            return localVarFp.agencyV0EventEventIdGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdImageGet: function (eventId, options) {
            return localVarFp.agencyV0EventEventIdImageGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of insurance periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodGet: function (options) {
            return localVarFp.agencyV0PeriodGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update insurance period
         * @param {number} periodId
         * @param {InsurancePeriod} [insurancePeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPeriodIdPatch: function (periodId, insurancePeriod, options) {
            return localVarFp.agencyV0PeriodPeriodIdPatch(periodId, insurancePeriod, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new insurance period
         * @param {InsurancePeriod} [insurancePeriod]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPost: function (insurancePeriod, options) {
            return localVarFp.agencyV0PeriodPost(insurancePeriod, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Do action on artifact
         * @summary Do action on artifact
         * @param {number} accidentId
         * @param {number} artifactId
         * @param {ArtifactAction} [artifactAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdActionPost: function (accidentId, artifactId, artifactAction, options) {
            return localVarFp.agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(accidentId, artifactId, artifactAction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get signed url for artifact
         * @summary Get signed url for artifact
         * @param {number} accidentId
         * @param {number} artifactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdGet: function (accidentId, artifactId, options) {
            return localVarFp.agencyV1AccidentAccidentIdArtifactArtifactIdGet(accidentId, artifactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get upload url for artifact
         * @summary Get upload url for artifact
         * @param {number} accidentId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPost: function (accidentId, fileData, options) {
            return localVarFp.agencyV1AccidentAccidentIdArtifactPost(accidentId, fileData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId
         * @param {ArtifactRequest} [artifactRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPut: function (accidentId, artifactRequest, options) {
            return localVarFp.agencyV1AccidentAccidentIdArtifactPut(accidentId, artifactRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update comment
         * @summary Update comment
         * @param {number} accidentId
         * @param {number} commentId
         * @param {Comment} [comment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentCommentIdPatch: function (accidentId, commentId, comment, options) {
            return localVarFp.agencyV1AccidentAccidentIdCommentCommentIdPatch(accidentId, commentId, comment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new comment
         * @summary Create new comment
         * @param {number} accidentId
         * @param {Comment} [comment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentPost: function (accidentId, comment, options) {
            return localVarFp.agencyV1AccidentAccidentIdCommentPost(accidentId, comment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get damage details
         * @summary Get damage details
         * @param {number} accidentId
         * @param {number} damageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdGet: function (accidentId, damageId, options) {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdGet(accidentId, damageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update damage details
         * @summary Update damage details
         * @param {number} accidentId
         * @param {number} damageId
         * @param {Damage} [damage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPatch: function (accidentId, damageId, damage, options) {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPatch(accidentId, damageId, damage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete payment
         * @summary Delete payment
         * @param {number} accidentId
         * @param {number} damageId
         * @param {number} paymentId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete: function (accidentId, damageId, paymentId, payment, options) {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(accidentId, damageId, paymentId, payment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change payment status
         * @summary Change payment status
         * @param {number} accidentId
         * @param {number} damageId
         * @param {number} paymentId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch: function (accidentId, damageId, paymentId, payment, options) {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(accidentId, damageId, paymentId, payment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new payment
         * @summary Create new payment
         * @param {number} accidentId
         * @param {number} damageId
         * @param {Payment} [payment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPost: function (accidentId, damageId, payment, options) {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(accidentId, damageId, payment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create damage
         * @summary Create damage
         * @param {number} accidentId
         * @param {Damage} [damage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamagePost: function (accidentId, damage, options) {
            return localVarFp.agencyV1AccidentAccidentIdDamagePost(accidentId, damage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create or update driver details
         * @summary Create or update driver details
         * @param {number} accidentId
         * @param {Driver} [driver]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDriverPost: function (accidentId, driver, options) {
            return localVarFp.agencyV1AccidentAccidentIdDriverPost(accidentId, driver, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get accident details
         * @summary Get accident details
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdGet: function (accidentId, options) {
            return localVarFp.agencyV1AccidentAccidentIdGet(accidentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create accident notice form
         * @param {number} accidentId
         * @param {NoticeRequest} [noticeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNoticePost: function (accidentId, noticeRequest, options) {
            return localVarFp.agencyV1AccidentAccidentIdNoticePost(accidentId, noticeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationDelete: function (accidentId, notificationRequest, options) {
            return localVarFp.agencyV1AccidentAccidentIdNotificationDelete(accidentId, notificationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get notifications list for accident
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationGet: function (accidentId, options) {
            return localVarFp.agencyV1AccidentAccidentIdNotificationGet(accidentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPatch: function (accidentId, notificationRequest, options) {
            return localVarFp.agencyV1AccidentAccidentIdNotificationPatch(accidentId, notificationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new notification for accident
         * @param {number} accidentId
         * @param {NotificationRequest} [notificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPost: function (accidentId, notificationRequest, options) {
            return localVarFp.agencyV1AccidentAccidentIdNotificationPost(accidentId, notificationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {number} accidentId
         * @param {ExtendedAccident} extendedAccident Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdPatch: function (accidentId, extendedAccident, options) {
            return localVarFp.agencyV1AccidentAccidentIdPatch(accidentId, extendedAccident, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send accident to users
         * @param {number} accidentId
         * @param {SendAccidentRequest} [sendAccidentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdSendPost: function (accidentId, sendAccidentRequest, options) {
            return localVarFp.agencyV1AccidentAccidentIdSendPost(accidentId, sendAccidentRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTags} [accidentTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPatch: function (accidentId, accidentTags, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsPatch(accidentId, accidentTags, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTags} [accidentTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPost: function (accidentId, accidentTags, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsPost(accidentId, accidentTags, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Get: function (accidentId, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsV1Get(accidentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV1} [accidentTagsV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Patch: function (accidentId, accidentTagsV1, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsV1Patch(accidentId, accidentTagsV1, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV1} [accidentTagsV1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Post: function (accidentId, accidentTagsV1, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsV1Post(accidentId, accidentTagsV1, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Get: function (accidentId, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsV2Get(accidentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV2} [accidentTagsV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Patch: function (accidentId, accidentTagsV2, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsV2Patch(accidentId, accidentTagsV2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId
         * @param {AccidentTagsV2} [accidentTagsV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Post: function (accidentId, accidentTagsV2, options) {
            return localVarFp.agencyV1AccidentAccidentIdTagsV2Post(accidentId, accidentTagsV2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new witness statement
         * @summary Create new witness statement
         * @param {number} accidentId
         * @param {Witness} [witness]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessPost: function (accidentId, witness, options) {
            return localVarFp.agencyV1AccidentAccidentIdWitnessPost(accidentId, witness, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update witness statement
         * @summary Update witness statement
         * @param {number} accidentId
         * @param {number} witnessId
         * @param {Witness} [witness]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessWitnessIdPatch: function (accidentId, witnessId, witness, options) {
            return localVarFp.agencyV1AccidentAccidentIdWitnessWitnessIdPatch(accidentId, witnessId, witness, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of customer\'s articat tags
         * @summary Get list of customer\'s articat tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentArtifactTagsGet: function (options) {
            return localVarFp.agencyV1AccidentArtifactTagsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate]
         * @param {string} [normLicensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {boolean} [isClosed]
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {number} [createdFrom]
         * @param {number} [createdTo]
         * @param {number} [lastId]
         * @param {number} [csv]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentGet: function (licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, csv, options) {
            return localVarFp.agencyV1AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, csv, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create accident
         * @summary Create accident
         * @param {ExtendedAccident} extendedAccident Accident to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentPost: function (extendedAccident, options) {
            return localVarFp.agencyV1AccidentPost(extendedAccident, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataGet: function (options) {
            return localVarFp.agencyV1CustomerDataGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new customer data
         * @param {CustomerHandlingStatus} [customerHandlingStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataPost: function (customerHandlingStatus, options) {
            return localVarFp.agencyV1CustomerDataPost(customerHandlingStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create disposal letter for damage
         * @param {string} damageId
         * @param {DisposalLetterRequest} [disposalLetterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DamageDamageIdDisposalPost: function (damageId, disposalLetterRequest, options) {
            return localVarFp.agencyV1DamageDamageIdDisposalPost(damageId, disposalLetterRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload file for accident from driver form
         * @param {number} accidentId
         * @param {ExtendedFileData} [extendedFileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePost: function (accidentId, extendedFileData, options) {
            return localVarFp.agencyV1DriverFormAccidentIdFilePost(accidentId, extendedFileData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId
         * @param {ExtendedArtifact} [extendedArtifact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePut: function (accidentId, extendedArtifact, options) {
            return localVarFp.agencyV1DriverFormAccidentIdFilePut(accidentId, extendedArtifact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get app review from driver form
         * @param {number} accidentId
         * @param {DriverFormReview} [driverFormReview]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdReviewPost: function (accidentId, driverFormReview, options) {
            return localVarFp.agencyV1DriverFormAccidentIdReviewPost(accidentId, driverFormReview, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create accident from driver form
         * @param {DriverForm} [driverForm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormPost: function (driverForm, options) {
            return localVarFp.agencyV1DriverFormPost(driverForm, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get policy list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyGet: function (options) {
            return localVarFp.agencyV1PolicyGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update policy
         * @param {number} policyId
         * @param {PolicyV1Request} [policyV1Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPolicyIdPatch: function (policyId, policyV1Request, options) {
            return localVarFp.agencyV1PolicyPolicyIdPatch(policyId, policyV1Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new policy
         * @param {PolicyV1Request} [policyV1Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPost: function (policyV1Request, options) {
            return localVarFp.agencyV1PolicyPost(policyV1Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new notification for accident (UI only)
         * @param {number} accidentId
         * @param {NotificationRequestV2} [notificationRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentAccidentIdNotificationPost: function (accidentId, notificationRequestV2, options) {
            return localVarFp.agencyV2AccidentAccidentIdNotificationPost(accidentId, notificationRequestV2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate]
         * @param {string} [normLicensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {boolean} [isClosed]
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {number} [createdFrom]
         * @param {number} [createdTo]
         * @param {number} [lastId]
         * @param {number} [limit]
         * @param {number} [csv]
         * @param {string} [damageCause]
         * @param {string} [speed]
         * @param {string} [fault]
         * @param {string} [pointOfImpact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentGet: function (licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, limit, csv, damageCause, speed, fault, pointOfImpact, options) {
            return localVarFp.agencyV2AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, limit, csv, damageCause, speed, fault, pointOfImpact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get report with vehicles to charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyChargeGet: function (options) {
            return localVarFp.agencyV2PolicyChargeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a policy by IDs
         * @param {PolicyDeleteRequest} policyDeleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyDelete: function (policyDeleteRequest, options) {
            return localVarFp.agencyV2PolicyDelete(policyDeleteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve all customer\'s policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyGet: function (options) {
            return localVarFp.agencyV2PolicyGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a policy by ID
         * @param {number} policyId ID of the policy to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdDelete: function (policyId, options) {
            return localVarFp.agencyV2PolicyPolicyIdDelete(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a policy by ID
         * @param {number} policyId ID of the policy to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdGet: function (policyId, options) {
            return localVarFp.agencyV2PolicyPolicyIdGet(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create or update a policy
         * @param {number} policyId ID of the policy to update (optional)
         * @param {Array<PolicyV2>} policyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdPost: function (policyId, policyV2, options) {
            return localVarFp.agencyV2PolicyPolicyIdPost(policyId, policyV2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create or update list of policies
         * @param {Array<PolicyV2>} policyV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPost: function (policyV2, options) {
            return localVarFp.agencyV2PolicyPost(policyV2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            return localVarFp.apiAuthOtpPost(oTPUserCredentials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            return localVarFp.apiAuthPost(userCredentials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            return localVarFp.apiAuthRefreshPost(refreshTokenRequest, options).then(function (request) { return request(axios, basePath); });
        }
    };
};
exports.AgencyApiFactory = AgencyApiFactory;
/**
 * AgencyApi - object-oriented interface
 * @export
 * @class AgencyApi
 * @extends {BaseAPI}
 */
var AgencyApi = /** @class */ (function (_super) {
    __extends(AgencyApi, _super);
    function AgencyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get list of claims
     * @param {AgencyApiAgencyV0ClaimGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0ClaimGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0ClaimGet(requestParameters.date, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update claim assigned to accident
     * @param {AgencyApiAgencyV0ClaimPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0ClaimPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0ClaimPatch(requestParameters.updateClaimRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Load claim data
     * @param {AgencyApiAgencyV0ClaimPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0ClaimPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0ClaimPost(requestParameters.loadClaimsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get upload url for claim file
     * @param {AgencyApiAgencyV0ClaimUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0ClaimUploadPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0ClaimUploadPost(requestParameters.claimFileRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get event details
     * @summary Get event details
     * @param {AgencyApiAgencyV0EventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0EventEventIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0EventEventIdGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get event image
     * @param {AgencyApiAgencyV0EventEventIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0EventEventIdImageGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0EventEventIdImageGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of insurance periods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0PeriodGet = function (options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0PeriodGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update insurance period
     * @param {AgencyApiAgencyV0PeriodPeriodIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0PeriodPeriodIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0PeriodPeriodIdPatch(requestParameters.periodId, requestParameters.insurancePeriod, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new insurance period
     * @param {AgencyApiAgencyV0PeriodPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV0PeriodPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV0PeriodPost(requestParameters.insurancePeriod, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Do action on artifact
     * @summary Do action on artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdArtifactArtifactIdActionPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(requestParameters.accidentId, requestParameters.artifactId, requestParameters.artifactAction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get signed url for artifact
     * @summary Get signed url for artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdArtifactArtifactIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdArtifactArtifactIdGet(requestParameters.accidentId, requestParameters.artifactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get upload url for artifact
     * @summary Get upload url for artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdArtifactPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdArtifactPost(requestParameters.accidentId, requestParameters.fileData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new artifact
     * @summary Create new artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdArtifactPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdArtifactPut(requestParameters.accidentId, requestParameters.artifactRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update comment
     * @summary Update comment
     * @param {AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdCommentCommentIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdCommentCommentIdPatch(requestParameters.accidentId, requestParameters.commentId, requestParameters.comment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new comment
     * @summary Create new comment
     * @param {AgencyApiAgencyV1AccidentAccidentIdCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdCommentPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdCommentPost(requestParameters.accidentId, requestParameters.comment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get damage details
     * @summary Get damage details
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdDamageDamageIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdGet(requestParameters.accidentId, requestParameters.damageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update damage details
     * @summary Update damage details
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdDamageDamageIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPatch(requestParameters.accidentId, requestParameters.damageId, requestParameters.damage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete payment
     * @summary Delete payment
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(requestParameters.accidentId, requestParameters.damageId, requestParameters.paymentId, requestParameters.payment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change payment status
     * @summary Change payment status
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(requestParameters.accidentId, requestParameters.damageId, requestParameters.paymentId, requestParameters.payment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new payment
     * @summary Create new payment
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdDamageDamageIdPaymentPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(requestParameters.accidentId, requestParameters.damageId, requestParameters.payment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create damage
     * @summary Create damage
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdDamagePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdDamagePost(requestParameters.accidentId, requestParameters.damage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create or update driver details
     * @summary Create or update driver details
     * @param {AgencyApiAgencyV1AccidentAccidentIdDriverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdDriverPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdDriverPost(requestParameters.accidentId, requestParameters.driver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get accident details
     * @summary Get accident details
     * @param {AgencyApiAgencyV1AccidentAccidentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdGet(requestParameters.accidentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create accident notice form
     * @param {AgencyApiAgencyV1AccidentAccidentIdNoticePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdNoticePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdNoticePost(requestParameters.accidentId, requestParameters.noticeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete notification for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdNotificationDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdNotificationDelete(requestParameters.accidentId, requestParameters.notificationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get notifications list for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdNotificationGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdNotificationGet(requestParameters.accidentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update notification for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdNotificationPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdNotificationPatch(requestParameters.accidentId, requestParameters.notificationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new notification for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdNotificationPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdNotificationPost(requestParameters.accidentId, requestParameters.notificationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of accidents
     * @summary Get list of accidents
     * @param {AgencyApiAgencyV1AccidentAccidentIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdPatch(requestParameters.accidentId, requestParameters.extendedAccident, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send accident to users
     * @param {AgencyApiAgencyV1AccidentAccidentIdSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdSendPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdSendPost(requestParameters.accidentId, requestParameters.sendAccidentRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update accident tags
     * @summary Update accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsPatch(requestParameters.accidentId, requestParameters.accidentTags, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new accident tags
     * @summary Create new accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsPost(requestParameters.accidentId, requestParameters.accidentTags, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get accident tags
     * @summary get accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsV1Get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsV1Get(requestParameters.accidentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update accident tags
     * @summary Update accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV1PatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsV1Patch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsV1Patch(requestParameters.accidentId, requestParameters.accidentTagsV1, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new accident tags
     * @summary Create new accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV1PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsV1Post = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsV1Post(requestParameters.accidentId, requestParameters.accidentTagsV1, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get accident tags
     * @summary get accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV2GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsV2Get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsV2Get(requestParameters.accidentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update accident tags
     * @summary Update accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV2PatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsV2Patch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsV2Patch(requestParameters.accidentId, requestParameters.accidentTagsV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new accident tags
     * @summary Create new accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV2PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdTagsV2Post = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdTagsV2Post(requestParameters.accidentId, requestParameters.accidentTagsV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new witness statement
     * @summary Create new witness statement
     * @param {AgencyApiAgencyV1AccidentAccidentIdWitnessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdWitnessPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdWitnessPost(requestParameters.accidentId, requestParameters.witness, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update witness statement
     * @summary Update witness statement
     * @param {AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentAccidentIdWitnessWitnessIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentAccidentIdWitnessWitnessIdPatch(requestParameters.accidentId, requestParameters.witnessId, requestParameters.witness, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of customer\'s articat tags
     * @summary Get list of customer\'s articat tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentArtifactTagsGet = function (options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentArtifactTagsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of accidents
     * @summary Get list of accidents
     * @param {AgencyApiAgencyV1AccidentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentGet(requestParameters.licensePlate, requestParameters.normLicensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.subFleet, requestParameters.isClosed, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.lastId, requestParameters.csv, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create accident
     * @summary Create accident
     * @param {AgencyApiAgencyV1AccidentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1AccidentPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1AccidentPost(requestParameters.extendedAccident, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get customer data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1CustomerDataGet = function (options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1CustomerDataGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new customer data
     * @param {AgencyApiAgencyV1CustomerDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1CustomerDataPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1CustomerDataPost(requestParameters.customerHandlingStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create disposal letter for damage
     * @param {AgencyApiAgencyV1DamageDamageIdDisposalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1DamageDamageIdDisposalPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1DamageDamageIdDisposalPost(requestParameters.damageId, requestParameters.disposalLetterRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload file for accident from driver form
     * @param {AgencyApiAgencyV1DriverFormAccidentIdFilePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1DriverFormAccidentIdFilePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1DriverFormAccidentIdFilePost(requestParameters.accidentId, requestParameters.extendedFileData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new artifact
     * @summary Create new artifact
     * @param {AgencyApiAgencyV1DriverFormAccidentIdFilePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1DriverFormAccidentIdFilePut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1DriverFormAccidentIdFilePut(requestParameters.accidentId, requestParameters.extendedArtifact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get app review from driver form
     * @param {AgencyApiAgencyV1DriverFormAccidentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1DriverFormAccidentIdReviewPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1DriverFormAccidentIdReviewPost(requestParameters.accidentId, requestParameters.driverFormReview, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create accident from driver form
     * @param {AgencyApiAgencyV1DriverFormPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1DriverFormPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1DriverFormPost(requestParameters.driverForm, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get policy list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1PolicyGet = function (options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1PolicyGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update policy
     * @param {AgencyApiAgencyV1PolicyPolicyIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1PolicyPolicyIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1PolicyPolicyIdPatch(requestParameters.policyId, requestParameters.policyV1Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new policy
     * @param {AgencyApiAgencyV1PolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV1PolicyPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV1PolicyPost(requestParameters.policyV1Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new notification for accident (UI only)
     * @param {AgencyApiAgencyV2AccidentAccidentIdNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2AccidentAccidentIdNotificationPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2AccidentAccidentIdNotificationPost(requestParameters.accidentId, requestParameters.notificationRequestV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of accidents
     * @summary Get list of accidents
     * @param {AgencyApiAgencyV2AccidentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2AccidentGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2AccidentGet(requestParameters.licensePlate, requestParameters.normLicensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.subFleet, requestParameters.isClosed, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.lastId, requestParameters.limit, requestParameters.csv, requestParameters.damageCause, requestParameters.speed, requestParameters.fault, requestParameters.pointOfImpact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get report with vehicles to charge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2PolicyChargeGet = function (options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2PolicyChargeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a policy by IDs
     * @param {AgencyApiAgencyV2PolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2PolicyDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2PolicyDelete(requestParameters.policyDeleteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve all customer\'s policies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2PolicyGet = function (options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2PolicyGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a policy by ID
     * @param {AgencyApiAgencyV2PolicyPolicyIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2PolicyPolicyIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2PolicyPolicyIdDelete(requestParameters.policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a policy by ID
     * @param {AgencyApiAgencyV2PolicyPolicyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2PolicyPolicyIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2PolicyPolicyIdGet(requestParameters.policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create or update a policy
     * @param {AgencyApiAgencyV2PolicyPolicyIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2PolicyPolicyIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2PolicyPolicyIdPost(requestParameters.policyId, requestParameters.policyV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create or update list of policies
     * @param {AgencyApiAgencyV2PolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.agencyV2PolicyPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AgencyApiFp)(this.configuration).agencyV2PolicyPost(requestParameters.policyV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {AgencyApiApiAuthOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.apiAuthOtpPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).apiAuthOtpPost(requestParameters.oTPUserCredentials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {AgencyApiApiAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.apiAuthPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).apiAuthPost(requestParameters.userCredentials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {AgencyApiApiAuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    AgencyApi.prototype.apiAuthRefreshPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AgencyApiFp)(this.configuration).apiAuthRefreshPost(requestParameters.refreshTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AgencyApi;
}(base_1.BaseAPI));
exports.AgencyApi = AgencyApi;
/**
 * ApiApi - axios parameter creator
 * @export
 */
var ApiApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get device details
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [status]
         * @param {string} [versionName]
         * @param {number} [cache]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [country]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, page, pageSize, country, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/admin/device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (driverName !== undefined) {
                        localVarQueryParameter['driver_name'] = driverName;
                    }
                    if (licensePlateContains !== undefined) {
                        localVarQueryParameter['license_plate_contains'] = licensePlateContains;
                    }
                    if (driverNameContains !== undefined) {
                        localVarQueryParameter['driver_name_contains'] = driverNameContains;
                    }
                    if (deviceId !== undefined) {
                        localVarQueryParameter['device_id'] = deviceId;
                    }
                    if (deviceIdContains !== undefined) {
                        localVarQueryParameter['device_id_contains'] = deviceIdContains;
                    }
                    if (subFleet !== undefined) {
                        localVarQueryParameter['sub_fleet'] = subFleet;
                    }
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    if (dateFrom !== undefined) {
                        localVarQueryParameter['date_from'] = dateFrom;
                    }
                    if (dateTo !== undefined) {
                        localVarQueryParameter['date_to'] = dateTo;
                    }
                    if (version !== undefined) {
                        localVarQueryParameter['version'] = version;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (versionName !== undefined) {
                        localVarQueryParameter['version_name'] = versionName;
                    }
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page_size'] = pageSize;
                    }
                    if (country !== undefined) {
                        localVarQueryParameter['country'] = country;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get device operation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/admin/device_operation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new device operation details
         * @param {DeviceOperationData} [deviceOperationData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationPost: function (deviceOperationData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/admin/device_operation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deviceOperationData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create overlay on event video
         * @param {EventOverlayRequest} [eventOverlayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOverlayPost: function (eventOverlayRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/admin/overlay";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventOverlayRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary get list of all wellness details
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [country]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessGet: function (page, pageSize, country, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/admin/wellness";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['page_size'] = pageSize;
                    }
                    if (country !== undefined) {
                        localVarQueryParameter['country'] = country;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new wellness details
         * @param {WellnessUpdate} [wellnessUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessPost: function (wellnessUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/admin/wellness";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wellnessUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/otp";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(oTPUserCredentials, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCredentials, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokenRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get accident overview data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/accident_overview";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get accident overview data
         * @param {number} timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewTimestampGet: function (timestamp, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'timestamp' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0AccidentOverviewTimestampGet', 'timestamp', timestamp);
                    localVarPath = "/api/v0/accident_overview/{timestamp}"
                        .replace("{".concat("timestamp", "}"), encodeURIComponent(String(timestamp)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send ICE candidate from browser to device
         * @param {number} sessionId
         * @param {BrowserStreamIceRequest} browserStreamIceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdIcePost: function (sessionId, browserStreamIceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0BrowserStreamSessionIdIcePost', 'sessionId', sessionId);
                    // verify required parameter 'browserStreamIceRequest' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0BrowserStreamSessionIdIcePost', 'browserStreamIceRequest', browserStreamIceRequest);
                    localVarPath = "/api/v0/browser_stream/{session_id}/ice"
                        .replace("{".concat("session_id", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(browserStreamIceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Poll for messages from device to browser (keep-alive)
         * @param {number} sessionId
         * @param {number} [after] Message ID to fetch messages after (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdMessagesGet: function (sessionId, after, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0BrowserStreamSessionIdMessagesGet', 'sessionId', sessionId);
                    localVarPath = "/api/v0/browser_stream/{session_id}/messages"
                        .replace("{".concat("session_id", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (after !== undefined) {
                        localVarQueryParameter['after'] = after;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send WebRTC offer (SDP) from browser to device
         * @param {number} sessionId
         * @param {BrowserStreamOfferRequest} browserStreamOfferRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdOfferPost: function (sessionId, browserStreamOfferRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0BrowserStreamSessionIdOfferPost', 'sessionId', sessionId);
                    // verify required parameter 'browserStreamOfferRequest' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0BrowserStreamSessionIdOfferPost', 'browserStreamOfferRequest', browserStreamOfferRequest);
                    localVarPath = "/api/v0/browser_stream/{session_id}/offer"
                        .replace("{".concat("session_id", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(browserStreamOfferRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachEventEventIdGet', 'eventId', eventId);
                    localVarPath = "/api/v0/coach/event/{eventId}"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get coaching event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdImageGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachEventEventIdImageGet', 'eventId', eventId);
                    localVarPath = "/api/v0/coach/event/{eventId}/image"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get event coaching status
         * @param {CoachEventStatus} [coachEventStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventPost: function (coachEventStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/coach/event";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachEventStatus, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get metrics data
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsGet: function (driverToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverToken' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachMetricsGet', 'driverToken', driverToken);
                    localVarPath = "/api/v0/coach/metrics";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (driverToken !== undefined) {
                        localVarQueryParameter['driver_token'] = driverToken;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new coaching metrics by driver token
         * @param {CoachMetricsSaveRequest} [coachMetricsSaveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsPost: function (coachMetricsSaveRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/coach/metrics";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachMetricsSaveRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete event from coaching session
         * @param {number} sessionId
         * @param {number} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdDelete: function (sessionId, itemId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdEventItemIdDelete', 'sessionId', sessionId);
                    // verify required parameter 'itemId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdEventItemIdDelete', 'itemId', itemId);
                    localVarPath = "/api/v0/coach/{sessionId}/event/{itemId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("itemId", "}"), encodeURIComponent(String(itemId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update event in coaching session
         * @param {number} sessionId
         * @param {number} itemId
         * @param {UpdateCoachEvent} [updateCoachEvent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdPatch: function (sessionId, itemId, updateCoachEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdEventItemIdPatch', 'sessionId', sessionId);
                    // verify required parameter 'itemId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdEventItemIdPatch', 'itemId', itemId);
                    localVarPath = "/api/v0/coach/{sessionId}/event/{itemId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("itemId", "}"), encodeURIComponent(String(itemId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoachEvent, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get coaching session details
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdGet: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdGet', 'sessionId', sessionId);
                    localVarPath = "/api/v0/coach/{sessionId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get coaching session image
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdImageGet: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdImageGet', 'sessionId', sessionId);
                    localVarPath = "/api/v0/coach/{sessionId}/image"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete coach media file
         * @param {number} sessionId
         * @param {number} coachMediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete: function (sessionId, coachMediaFileId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete', 'sessionId', sessionId);
                    // verify required parameter 'coachMediaFileId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete', 'coachMediaFileId', coachMediaFileId);
                    localVarPath = "/api/v0/coach/{sessionId}/media_file/{coachMediaFileId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("coachMediaFileId", "}"), encodeURIComponent(String(coachMediaFileId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update coach media file
         * @param {number} sessionId
         * @param {number} coachMediaFileId
         * @param {CoachMediaFileRequest} [coachMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch: function (sessionId, coachMediaFileId, coachMediaFileRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch', 'sessionId', sessionId);
                    // verify required parameter 'coachMediaFileId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch', 'coachMediaFileId', coachMediaFileId);
                    localVarPath = "/api/v0/coach/{sessionId}/media_file/{coachMediaFileId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("coachMediaFileId", "}"), encodeURIComponent(String(coachMediaFileId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachMediaFileRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new coach media file
         * @param {number} sessionId
         * @param {CoachMediaFileRequest} [coachMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFilePost: function (sessionId, coachMediaFileRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMediaFilePost', 'sessionId', sessionId);
                    localVarPath = "/api/v0/coach/{sessionId}/media_file"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachMediaFileRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete coach metrics
         * @param {number} sessionId
         * @param {number} metricsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdDelete: function (sessionId, metricsId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMetricsMetricsIdDelete', 'sessionId', sessionId);
                    // verify required parameter 'metricsId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMetricsMetricsIdDelete', 'metricsId', metricsId);
                    localVarPath = "/api/v0/coach/{sessionId}/metrics/{metricsId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("metricsId", "}"), encodeURIComponent(String(metricsId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update coach metrics
         * @param {number} sessionId
         * @param {number} metricsId
         * @param {CoachMetrics} [coachMetrics]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdPatch: function (sessionId, metricsId, coachMetrics, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMetricsMetricsIdPatch', 'sessionId', sessionId);
                    // verify required parameter 'metricsId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMetricsMetricsIdPatch', 'metricsId', metricsId);
                    localVarPath = "/api/v0/coach/{sessionId}/metrics/{metricsId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("metricsId", "}"), encodeURIComponent(String(metricsId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachMetrics, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new coaching metrics
         * @param {number} sessionId
         * @param {CoachMetricsRequest} [coachMetricsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsPost: function (sessionId, coachMetricsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdMetricsPost', 'sessionId', sessionId);
                    localVarPath = "/api/v0/coach/{sessionId}/metrics"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachMetricsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete manager notes
         * @param {number} sessionId
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdDelete: function (sessionId, noteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdNotesNoteIdDelete', 'sessionId', sessionId);
                    // verify required parameter 'noteId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdNotesNoteIdDelete', 'noteId', noteId);
                    localVarPath = "/api/v0/coach/{sessionId}/notes/{noteId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("noteId", "}"), encodeURIComponent(String(noteId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update manager notes
         * @param {number} sessionId
         * @param {number} noteId
         * @param {CoachManagerNotes} [coachManagerNotes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdPatch: function (sessionId, noteId, coachManagerNotes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdNotesNoteIdPatch', 'sessionId', sessionId);
                    // verify required parameter 'noteId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdNotesNoteIdPatch', 'noteId', noteId);
                    localVarPath = "/api/v0/coach/{sessionId}/notes/{noteId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("noteId", "}"), encodeURIComponent(String(noteId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachManagerNotes, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new manager notes
         * @param {number} sessionId
         * @param {ManagerNotesRequest} [managerNotesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesPost: function (sessionId, managerNotesRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdNotesPost', 'sessionId', sessionId);
                    localVarPath = "/api/v0/coach/{sessionId}/notes"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(managerNotesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} sessionId
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdPost: function (sessionId, updateCoachSession, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdPost', 'sessionId', sessionId);
                    localVarPath = "/api/v0/coach/{sessionId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoachSession, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new driver response
         * @param {number} sessionId
         * @param {DriverResponseRequest} [driverResponseRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponsePost: function (sessionId, driverResponseRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdResponsePost', 'sessionId', sessionId);
                    localVarPath = "/api/v0/coach/{sessionId}/response"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driverResponseRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete driver response
         * @param {number} sessionId
         * @param {number} responseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdDelete: function (sessionId, responseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdResponseResponseIdDelete', 'sessionId', sessionId);
                    // verify required parameter 'responseId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdResponseResponseIdDelete', 'responseId', responseId);
                    localVarPath = "/api/v0/coach/{sessionId}/response/{responseId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("responseId", "}"), encodeURIComponent(String(responseId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update driver response
         * @param {number} sessionId
         * @param {number} responseId
         * @param {CoachDriverResponse} [coachDriverResponse]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdPatch: function (sessionId, responseId, coachDriverResponse, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdResponseResponseIdPatch', 'sessionId', sessionId);
                    // verify required parameter 'responseId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdResponseResponseIdPatch', 'responseId', responseId);
                    localVarPath = "/api/v0/coach/{sessionId}/response/{responseId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("responseId", "}"), encodeURIComponent(String(responseId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachDriverResponse, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Remove wellness status from driver coaching session
         * @param {number} sessionId
         * @param {number} wellnessId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdDelete: function (sessionId, wellnessId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdWellnessStatusWellnessIdDelete', 'sessionId', sessionId);
                    // verify required parameter 'wellnessId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdWellnessStatusWellnessIdDelete', 'wellnessId', wellnessId);
                    localVarPath = "/api/v0/coach/{sessionId}/wellness_status/{wellnessId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("wellnessId", "}"), encodeURIComponent(String(wellnessId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update wellness status from driver coaching session
         * @param {number} sessionId
         * @param {number} wellnessId
         * @param {UpdateCoachWellnessStatus} [updateCoachWellnessStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdPatch: function (sessionId, wellnessId, updateCoachWellnessStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdWellnessStatusWellnessIdPatch', 'sessionId', sessionId);
                    // verify required parameter 'wellnessId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CoachSessionIdWellnessStatusWellnessIdPatch', 'wellnessId', wellnessId);
                    localVarPath = "/api/v0/coach/{sessionId}/wellness_status/{wellnessId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)))
                        .replace("{".concat("wellnessId", "}"), encodeURIComponent(String(wellnessId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoachWellnessStatus, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {number} commandId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdGet: function (commandId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'commandId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CommandCommandIdGet', 'commandId', commandId);
                    localVarPath = "/api/v0/command/{commandId}"
                        .replace("{".concat("commandId", "}"), encodeURIComponent(String(commandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update remote command description
         * @summary Update remote command
         * @param {number} commandId
         * @param {Body} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPatch: function (commandId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'commandId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CommandCommandIdPatch', 'commandId', commandId);
                    localVarPath = "/api/v0/command/{commandId}"
                        .replace("{".concat("commandId", "}"), encodeURIComponent(String(commandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create remote command
         * @summary Create remote command
         * @param {number} commandId
         * @param {RemoteCommand} [remoteCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPost: function (commandId, remoteCommand, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'commandId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CommandCommandIdPost', 'commandId', commandId);
                    localVarPath = "/api/v0/command/{commandId}"
                        .replace("{".concat("commandId", "}"), encodeURIComponent(String(commandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(remoteCommand, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get list of remote commands (defaults to get_clip)
         * @summary Get list of remote commands
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {string} [command] Filter by command type(s). Comma-separated allowlist. If missing or invalid, defaults to get_clip. Allowed: get_clip, format_sd_card, installation_cleanup. Example: command&#x3D;get_clip,format_sd_card
         * @param {number} [accident]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandGet: function (timeFrom, timeTo, command, accident, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/command";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (command !== undefined) {
                        localVarQueryParameter['command'] = command;
                    }
                    if (accident !== undefined) {
                        localVarQueryParameter['accident'] = accident;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {Command} [command]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandPost: function (command, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/command";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(command, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Remove customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerDelete: function (customerSubFleetData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerSubFleetData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get customer details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerPost: function (customerSubFleetData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerSubFleetData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns S3 object keys directly under the authenticated customer prefix in the uniform-wellness export bucket (non-recursive). Requires get_clip permissions; customer must be in SSM allowlist UNIFORM_WELLNESS_IMAGES_CUSTOMERS (else 403).
         * @summary List uniform wellness image keys under the customer prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerUniformWellnessImagesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/customer/uniform_wellness_images";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Lists objects under {customer_name}/{since} in the export bucket and returns presigned download URLs. Same access rules as GET /api/v0/customer/uniform_wellness_images.
         * @summary List presigned URLs for uniform wellness images under a sub-prefix
         * @param {string} since Path segment(s) under the customer prefix (e.g. UTC folder from the copy job)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerUniformWellnessImagesSinceGet: function (since, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'since' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0CustomerUniformWellnessImagesSinceGet', 'since', since);
                    localVarPath = "/api/v0/customer/uniform_wellness_images/{since}"
                        .replace("{".concat("since", "}"), encodeURIComponent(String(since)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get daily dashboard issues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DailyDashboardGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/daily_dashboard";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get device snapshot
         * @param {string} deviceId
         * @param {number} [timestamp]
         * @param {number} [since]
         * @param {number} [exact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceDeviceIdSnapshotGet: function (deviceId, timestamp, since, exact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0DeviceDeviceIdSnapshotGet', 'deviceId', deviceId);
                    localVarPath = "/api/v0/device/{deviceId}/snapshot"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timestamp !== undefined) {
                        localVarQueryParameter['timestamp'] = timestamp;
                    }
                    if (since !== undefined) {
                        localVarQueryParameter['since'] = since;
                    }
                    if (exact !== undefined) {
                        localVarQueryParameter['exact'] = exact;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get device location
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {number} [latitude]
         * @param {number} [longitude]
         * @param {number} [radius]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceLocateGet: function (timeFrom, timeTo, latitude, longitude, radius, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/device/locate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (latitude !== undefined) {
                        localVarQueryParameter['latitude'] = latitude;
                    }
                    if (longitude !== undefined) {
                        localVarQueryParameter['longitude'] = longitude;
                    }
                    if (radius !== undefined) {
                        localVarQueryParameter['radius'] = radius;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update device details
         * @param {Array<DeviceRequest>} [deviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceUpdatePatch: function (deviceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/device/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deviceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get driver badge
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgeDriverTokenGet: function (driverToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverToken' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0DriverBadgeDriverTokenGet', 'driverToken', driverToken);
                    localVarPath = "/api/v0/driver/badge/{driverToken}"
                        .replace("{".concat("driverToken", "}"), encodeURIComponent(String(driverToken)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get driver badges
         * @param {DriverBadgeRequest} [driverBadgeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgePost: function (driverBadgeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/driver/badge";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driverBadgeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get driver details
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenGet: function (driverToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverToken' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0DriverDriverTokenGet', 'driverToken', driverToken);
                    localVarPath = "/api/v0/driver/{driverToken}"
                        .replace("{".concat("driverToken", "}"), encodeURIComponent(String(driverToken)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update driver details
         * @param {number} driverToken
         * @param {FleetDriverRequest} [fleetDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenPatch: function (driverToken, fleetDriverRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverToken' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0DriverDriverTokenPatch', 'driverToken', driverToken);
                    localVarPath = "/api/v0/driver/{driverToken}"
                        .replace("{".concat("driverToken", "}"), encodeURIComponent(String(driverToken)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fleetDriverRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/driver";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update multiple drivers
         * @param {FleetDriverList} [fleetDriverList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPatch: function (fleetDriverList, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/driver";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fleetDriverList, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new driver
         * @param {FleetDriverRequest} [fleetDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPost: function (fleetDriverRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/driver";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fleetDriverRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * recalculate driver score
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenCalculatePatch: function (driverToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverToken' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0DriverScoresDriverTokenCalculatePatch', 'driverToken', driverToken);
                    localVarPath = "/api/v0/driver_scores/{driverToken}/calculate"
                        .replace("{".concat("driverToken", "}"), encodeURIComponent(String(driverToken)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get driver score with relevant events
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenGet: function (driverToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverToken' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0DriverScoresDriverTokenGet', 'driverToken', driverToken);
                    localVarPath = "/api/v0/driver_scores/{driverToken}"
                        .replace("{".concat("driverToken", "}"), encodeURIComponent(String(driverToken)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get driver scores
         * @param {number} [allDrivers]
         * @param {number} [page]
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresGet: function (allDrivers, page, cache, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/driver_scores";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (allDrivers !== undefined) {
                        localVarQueryParameter['all_drivers'] = allDrivers;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Create new event from existing one
         * @param {number} eventId
         * @param {CloneEventDetails} [cloneEventDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdClonePost: function (eventId, cloneEventDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdClonePost', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/clone"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cloneEventDetails, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get event coaching data
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdCoachGet', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/coach"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Add or dismiss event from driver coaching session
         * @param {number} eventId
         * @param {CoachEventDetails} [coachEventDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachPost: function (eventId, coachEventDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdCoachPost', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/coach"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachEventDetails, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Download event video request
         * @param {number} eventId
         * @param {DownloadVideoEventRequest} [downloadVideoEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdDownloadPost: function (eventId, downloadVideoEventRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdDownloadPost', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/download"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(downloadVideoEventRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {string} [bucket]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdGet: function (eventId, bucket, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdGet', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (bucket !== undefined) {
                        localVarQueryParameter['bucket'] = bucket;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdImageGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdImageGet', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/image"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update event details
         * @param {number} eventId
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdPatch: function (eventId, inlineObject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdPatch', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get related events
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdRelatedGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdRelatedGet', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/related"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send event
         * @param {number} eventId
         * @param {SendEventRequest} [sendEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdSendPost: function (eventId, sendEventRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdSendPost', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/send"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendEventRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Change event tags
         * @summary Change event tags
         * @param {number} eventId
         * @param {EventTag} [eventTag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdTagPost: function (eventId, eventTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0EventEventIdTagPost', 'eventId', eventId);
                    localVarPath = "/api/v0/event/{eventId}/tag"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventTag, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Add comment to feed event
         * @summary Add comment
         * @param {number} eventId
         * @param {FeedCommentRequest} [feedCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdCommentPost: function (eventId, feedCommentRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0FeedEventIdCommentPost', 'eventId', eventId);
                    localVarPath = "/api/v0/feed/{eventId}/comment"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(feedCommentRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Add or remove dislike from event
         * @summary Dislike event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdDislikePost: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0FeedEventIdDislikePost', 'eventId', eventId);
                    localVarPath = "/api/v0/feed/{eventId}/dislike"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get feed event
         * @summary Get feed event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdGet: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0FeedEventIdGet', 'eventId', eventId);
                    localVarPath = "/api/v0/feed/{eventId}"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Add or remove like from event
         * @summary Like event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdLikePost: function (eventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0FeedEventIdLikePost', 'eventId', eventId);
                    localVarPath = "/api/v0/feed/{eventId}/like"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update percent watched
         * @summary Update percent watched
         * @param {number} eventId
         * @param {EventWatchedRequest} [eventWatchedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdWatchedPost: function (eventId, eventWatchedRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0FeedEventIdWatchedPost', 'eventId', eventId);
                    localVarPath = "/api/v0/feed/{eventId}/watched"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventWatchedRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get events
         * @summary Get user feed
         * @param {number} [generatedAt]
         * @param {number} [size]
         * @param {number} [fromEvent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedGet: function (generatedAt, size, fromEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/feed";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (generatedAt !== undefined) {
                        localVarQueryParameter['generated_at'] = generatedAt;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (fromEvent !== undefined) {
                        localVarQueryParameter['from_event'] = fromEvent;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get sms with link to feed page
         * @summary Get sms with link to feed page
         * @param {FeedLinkRequest} [feedLinkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedLinkPost: function (feedLinkRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/feed/link";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(feedLinkRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get fleet safety scores
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetSafetyScoresGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/fleet_safety_scores";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get fleet score and fleet metric data
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreGet: function (cache, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/fleet_score";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get fleet scores and score distribution over time
         * @param {number} [cache]
         * @param {number} [endDate]
         * @param {number} [daysCount]
         * @param {number} [daysInterval]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreTrendGet: function (cache, endDate, daysCount, daysInterval, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/fleet_score_trend";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    if (endDate !== undefined) {
                        localVarQueryParameter['end_date'] = endDate;
                    }
                    if (daysCount !== undefined) {
                        localVarQueryParameter['days_count'] = daysCount;
                    }
                    if (daysInterval !== undefined) {
                        localVarQueryParameter['days_interval'] = daysInterval;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get top and bottom drivers for the latest timestamp for each fleet
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetTopBottomDriversGet: function (cache, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/fleet_top_bottom_drivers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Delete a geofence
         * @param {number} geofenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdDelete: function (geofenceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'geofenceId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0GeofenceGeofenceIdDelete', 'geofenceId', geofenceId);
                    localVarPath = "/api/v0/geofence/{geofenceId}"
                        .replace("{".concat("geofenceId", "}"), encodeURIComponent(String(geofenceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update a geofence
         * @param {number} geofenceId
         * @param {Geofence} [geofence]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdPatch: function (geofenceId, geofence, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'geofenceId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0GeofenceGeofenceIdPatch', 'geofenceId', geofenceId);
                    localVarPath = "/api/v0/geofence/{geofenceId}"
                        .replace("{".concat("geofenceId", "}"), encodeURIComponent(String(geofenceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(geofence, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get geofence details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/geofence";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new geofence
         * @param {Geofence} [geofence]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofencePost: function (geofence, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/geofence";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(geofence, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get help videos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HelpGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/help";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get aggregated data of malfunctions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionAggregatedGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/malfunction/aggregated";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get malfunction list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/malfunction";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create guest technician
         * @param {GuestTechnicianRequest} [guestTechnicianRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGuestPost: function (guestTechnicianRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/malfunction/guest";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(guestTechnicianRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get malfunction comments
         * @param {number} malfunctionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentGet: function (malfunctionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'malfunctionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0MalfunctionMalfunctionIdCommentGet', 'malfunctionId', malfunctionId);
                    localVarPath = "/api/v0/malfunction/{malfunctionId}/comment"
                        .replace("{".concat("malfunctionId", "}"), encodeURIComponent(String(malfunctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Add new comment to malfunction
         * @param {number} malfunctionId
         * @param {MalfunctionCommentRequest} [malfunctionCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentPost: function (malfunctionId, malfunctionCommentRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'malfunctionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0MalfunctionMalfunctionIdCommentPost', 'malfunctionId', malfunctionId);
                    localVarPath = "/api/v0/malfunction/{malfunctionId}/comment"
                        .replace("{".concat("malfunctionId", "}"), encodeURIComponent(String(malfunctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(malfunctionCommentRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get malfunction image
         * @param {number} malfunctionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdImageGet: function (malfunctionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'malfunctionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0MalfunctionMalfunctionIdImageGet', 'malfunctionId', malfunctionId);
                    localVarPath = "/api/v0/malfunction/{malfunctionId}/image"
                        .replace("{".concat("malfunctionId", "}"), encodeURIComponent(String(malfunctionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update malfunction assignee
         * @param {MalfunctionAssigneeRequest} [malfunctionAssigneeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionPatch: function (malfunctionAssigneeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/malfunction";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(malfunctionAssigneeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Sync malfunctions with policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionUpdateGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/malfunction/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get media file library
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/media_files";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete media file
         * @param {number} mediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdDelete: function (mediaFileId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'mediaFileId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0MediaFilesMediaFileIdDelete', 'mediaFileId', mediaFileId);
                    localVarPath = "/api/v0/media_files/{mediaFileId}"
                        .replace("{".concat("mediaFileId", "}"), encodeURIComponent(String(mediaFileId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get signed url for media file
         * @summary Get signed url for media file
         * @param {number} mediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdGet: function (mediaFileId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'mediaFileId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0MediaFilesMediaFileIdGet', 'mediaFileId', mediaFileId);
                    localVarPath = "/api/v0/media_files/{mediaFileId}"
                        .replace("{".concat("mediaFileId", "}"), encodeURIComponent(String(mediaFileId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update media file
         * @param {number} mediaFileId
         * @param {MediaFile} [mediaFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdPatch: function (mediaFileId, mediaFile, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'mediaFileId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0MediaFilesMediaFileIdPatch', 'mediaFileId', mediaFileId);
                    localVarPath = "/api/v0/media_files/{mediaFileId}"
                        .replace("{".concat("mediaFileId", "}"), encodeURIComponent(String(mediaFileId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaFile, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get file upload url
         * @param {UploadMediaFileRequest} [uploadMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPost: function (uploadMediaFileRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/media_files";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(uploadMediaFileRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Add media file to database
         * @param {MediaFileRequest} [mediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPut: function (mediaFileRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/media_files";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaFileRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new NPS
         * @param {Nps} [nps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0NpsPost: function (nps, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/nps";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(nps, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Remove package to device list
         * @param {PackageTrackerData} [packageTrackerData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackageDelete: function (packageTrackerData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/package";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(packageTrackerData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Remove file from package
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdDelete: function (packageId, fileData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'packageId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0PackagePackageIdDelete', 'packageId', packageId);
                    localVarPath = "/api/v0/package/{packageId}"
                        .replace("{".concat("packageId", "}"), encodeURIComponent(String(packageId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get file upload data
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPost: function (packageId, fileData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'packageId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0PackagePackageIdPost', 'packageId', packageId);
                    localVarPath = "/api/v0/package/{packageId}"
                        .replace("{".concat("packageId", "}"), encodeURIComponent(String(packageId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Add file to existing package
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPut: function (packageId, fileData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'packageId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0PackagePackageIdPut', 'packageId', packageId);
                    localVarPath = "/api/v0/package/{packageId}"
                        .replace("{".concat("packageId", "}"), encodeURIComponent(String(packageId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new package
         * @param {PackageName} [packageName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePost: function (packageName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/package";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(packageName, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Attach package to device list
         * @param {PackageTrackerData} [packageTrackerData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePut: function (packageTrackerData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/package";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(packageTrackerData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get premium optimization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/premium_optimization";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new premium optimization details
         * @param {PremiumOptimizationRequest} [premiumOptimizationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationPost: function (premiumOptimizationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/premium_optimization";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(premiumOptimizationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send reminder
         * @param {PremiumOptimizationReminderRequest} [premiumOptimizationReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationReminderPost: function (premiumOptimizationReminderRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/premium_optimization/reminder";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(premiumOptimizationReminderRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get release notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReleaseNotesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/release_notes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of reports and alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/report";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary create new report or alert
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportPost: function (alertOrReport, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/report";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertOrReport, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary create new report or alert
         * @param {number} reportId
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdDelete: function (reportId, alertOrReport, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reportId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0ReportReportIdDelete', 'reportId', reportId);
                    localVarPath = "/api/v0/report/{reportId}"
                        .replace("{".concat("reportId", "}"), encodeURIComponent(String(reportId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertOrReport, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update report or alert
         * @param {number} reportId
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdPatch: function (reportId, alertOrReport, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reportId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0ReportReportIdPatch', 'reportId', reportId);
                    localVarPath = "/api/v0/report/{reportId}"
                        .replace("{".concat("reportId", "}"), encodeURIComponent(String(reportId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertOrReport, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of report instances
         * @param {string} [reportType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunGet: function (reportType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/report/run";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (reportType !== undefined) {
                        localVarQueryParameter['report_type'] = reportType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get report instance
         * @param {number} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdGet: function (instanceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'instanceId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0ReportRunInstanceIdGet', 'instanceId', instanceId);
                    localVarPath = "/api/v0/report/run/{instanceId}"
                        .replace("{".concat("instanceId", "}"), encodeURIComponent(String(instanceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update report instance
         * @param {number} instanceId
         * @param {ReportInstanceUpdate} [reportInstanceUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdPatch: function (instanceId, reportInstanceUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'instanceId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0ReportRunInstanceIdPatch', 'instanceId', instanceId);
                    localVarPath = "/api/v0/report/run/{instanceId}"
                        .replace("{".concat("instanceId", "}"), encodeURIComponent(String(instanceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportInstanceUpdate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send report
         * @param {number} instanceId
         * @param {SendReportRequest} [sendReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdSendPost: function (instanceId, sendReportRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'instanceId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0ReportRunInstanceIdSendPost', 'instanceId', instanceId);
                    localVarPath = "/api/v0/report/run/{instanceId}/send"
                        .replace("{".concat("instanceId", "}"), encodeURIComponent(String(instanceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendReportRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Generate report
         * @param {ReportInstanceRequest} [reportInstanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunPost: function (reportInstanceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/report/run";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportInstanceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update customer settings
         * @param {CustomerSettingsRequest} [customerSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerPatch: function (customerSettingsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerSettingsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get customer accident sticker
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerStickerPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/customer/sticker";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Change user\'s email
         * @param {ChangeEmailRequest} [changeEmailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserEmailPatch: function (changeEmailRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/email";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeEmailRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Remove users
         * @param {Array<UserDetails>} [userDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementDelete: function (userDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userDetails, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get users\' permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update users\' permissions
         * @param {Array<UserDetails>} [userDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPatch: function (userDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userDetails, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new user
         * @param {Array<UserCreationData>} [userCreationData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPost: function (userCreationData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCreationData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Change user\'s password
         * @param {ChangePasswordRequest} [changePasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPasswordPatch: function (changePasswordRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changePasswordRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Request permission change
         * @param {ChangePermissionsRequest} [changePermissionsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPermissionPost: function (changePermissionsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/permission";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changePermissionsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Request password reset
         * @param {ResetPasswordRequest} [resetPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserResetPasswordPost: function (resetPasswordRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/settings/user/reset_password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPasswordRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of existing tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TagGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/tag";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user notifications
         * @param {number} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationGet: function (from, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/user_notification";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = from;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update user notification
         * @param {number} notificationId
         * @param {UserNotificationRequest} [userNotificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationNotificationIdPatch: function (notificationId, userNotificationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'notificationId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0UserNotificationNotificationIdPatch', 'notificationId', notificationId);
                    localVarPath = "/api/v0/user_notification/{notificationId}"
                        .replace("{".concat("notificationId", "}"), encodeURIComponent(String(notificationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNotificationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update last seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationPatch: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/user_notification";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Save video preview as an event
         * @param {number} previewRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestEventPreviewRequestIdPost: function (previewRequestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'previewRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0VideoPreviewRequestEventPreviewRequestIdPost', 'previewRequestId', previewRequestId);
                    localVarPath = "/api/v0/video_preview_request/event/{previewRequestId}"
                        .replace("{".concat("previewRequestId", "}"), encodeURIComponent(String(previewRequestId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get video preview request details
         * @param {number} tripId
         * @param {number} [driverTripId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestGet: function (tripId, driverTripId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'tripId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0VideoPreviewRequestGet', 'tripId', tripId);
                    localVarPath = "/api/v0/video_preview_request";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tripId !== undefined) {
                        localVarQueryParameter['trip_id'] = tripId;
                    }
                    if (driverTripId !== undefined) {
                        localVarQueryParameter['driver_trip_id'] = driverTripId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new video preview request
         * @param {VideoPreviewRequestBody} [videoPreviewRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestPost: function (videoPreviewRequestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/video_preview_request";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(videoPreviewRequestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get wellness score list
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresGet: function (cache, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v0/wellness_scores";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * get wellness score details
         * @param {string} licensePlate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresLicensePlateGet: function (licensePlate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'licensePlate' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0WellnessScoresLicensePlateGet', 'licensePlate', licensePlate);
                    localVarPath = "/api/v0/wellness_scores/{licensePlate}"
                        .replace("{".concat("licensePlate", "}"), encodeURIComponent(String(licensePlate)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Add or dismiss wellness status from driver coaching session
         * @param {number} wellnessId
         * @param {CoachWellnessDetails} [coachWellnessDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessStatusWellnessIdCoachPost: function (wellnessId, coachWellnessDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'wellnessId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV0WellnessStatusWellnessIdCoachPost', 'wellnessId', wellnessId);
                    localVarPath = "/api/v0/wellness_status/{wellnessId}/coach"
                        .replace("{".concat("wellnessId", "}"), encodeURIComponent(String(wellnessId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachWellnessDetails, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get driver coaching session
         * @param {string} token
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverGet: function (token, code, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachDriverGet', 'token', token);
                    localVarPath = "/api/v1/coach/driver";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update session metadata
         * @param {string} token
         * @param {string} [code]
         * @param {CoachSessionMetadata} [coachSessionMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPatch: function (token, code, coachSessionMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachDriverPatch', 'token', token);
                    localVarPath = "/api/v1/coach/driver";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachSessionMetadata, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Complete driver coaching session
         * @param {string} token
         * @param {string} [code]
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPost: function (token, code, updateCoachSession, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'token' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachDriverPost', 'token', token);
                    localVarPath = "/api/v1/coach/driver";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoachSession, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} [driverToken]
         * @param {number} [completedFrom]
         * @param {number} [completedTo]
         * @param {number} [additionalInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachGet: function (driverToken, completedFrom, completedTo, additionalInfo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/coach";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (driverToken !== undefined) {
                        localVarQueryParameter['driver_token'] = driverToken;
                    }
                    if (completedFrom !== undefined) {
                        localVarQueryParameter['completed_from'] = completedFrom;
                    }
                    if (completedTo !== undefined) {
                        localVarQueryParameter['completed_to'] = completedTo;
                    }
                    if (additionalInfo !== undefined) {
                        localVarQueryParameter['additional_info'] = additionalInfo;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send coaching session link by sms
         * @param {CoachSessionMessageRequest} coachSessionMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSendPost: function (coachSessionMessageRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'coachSessionMessageRequest' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachSendPost', 'coachSessionMessageRequest', coachSessionMessageRequest);
                    localVarPath = "/api/v1/coach/send";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachSessionMessageRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete coaching session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdDelete: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachSessionIdDelete', 'sessionId', sessionId);
                    localVarPath = "/api/v1/coach/{sessionId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get coaching session details
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdGet: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachSessionIdGet', 'sessionId', sessionId);
                    localVarPath = "/api/v1/coach/{sessionId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Change coaching session assignee or agenda
         * @param {number} sessionId
         * @param {CoachSession} [coachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPatch: function (sessionId, coachSession, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachSessionIdPatch', 'sessionId', sessionId);
                    localVarPath = "/api/v1/coach/{sessionId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coachSession, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} sessionId
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPost: function (sessionId, updateCoachSession, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachSessionIdPost', 'sessionId', sessionId);
                    localVarPath = "/api/v1/coach/{sessionId}"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoachSession, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send the driver a reminder to complete session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdRemindPost: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachSessionIdRemindPost', 'sessionId', sessionId);
                    localVarPath = "/api/v1/coach/{sessionId}/remind"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Save auto-generated coaching session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdSavePost: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sessionId' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1CoachSessionIdSavePost', 'sessionId', sessionId);
                    localVarPath = "/api/v1/coach/{sessionId}/save"
                        .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get coaching overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachingOverviewGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/coaching_overview";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate]
         * @param {string} [licensePlateList]
         * @param {string} [licensePlateContains]
         * @param {string} [subFleet]
         * @param {string} [subFleetList]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {string} [tripId]
         * @param {number} [lastTrip]
         * @param {string} [tripObjIn]
         * @param {string} [severity]
         * @param {string} [eventType]
         * @param {string} [eventTypeList]
         * @param {number} [lastEvent]
         * @param {string} [tag]
         * @param {string} [level]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventGet: function (licensePlate, licensePlateList, licensePlateContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, lastTrip, tripObjIn, severity, eventType, eventTypeList, lastEvent, tag, level, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/event";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (licensePlateList !== undefined) {
                        localVarQueryParameter['license_plate_list'] = licensePlateList;
                    }
                    if (licensePlateContains !== undefined) {
                        localVarQueryParameter['license_plate_contains'] = licensePlateContains;
                    }
                    if (subFleet !== undefined) {
                        localVarQueryParameter['sub_fleet'] = subFleet;
                    }
                    if (subFleetList !== undefined) {
                        localVarQueryParameter['sub_fleet_list'] = subFleetList;
                    }
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    if (dateFrom !== undefined) {
                        localVarQueryParameter['date_from'] = dateFrom;
                    }
                    if (dateTo !== undefined) {
                        localVarQueryParameter['date_to'] = dateTo;
                    }
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (tripId !== undefined) {
                        localVarQueryParameter['trip_id'] = tripId;
                    }
                    if (lastTrip !== undefined) {
                        localVarQueryParameter['last_trip'] = lastTrip;
                    }
                    if (tripObjIn !== undefined) {
                        localVarQueryParameter['trip_obj__in'] = tripObjIn;
                    }
                    if (severity !== undefined) {
                        localVarQueryParameter['severity'] = severity;
                    }
                    if (eventType !== undefined) {
                        localVarQueryParameter['event_type'] = eventType;
                    }
                    if (eventTypeList !== undefined) {
                        localVarQueryParameter['event_type_list'] = eventTypeList;
                    }
                    if (lastEvent !== undefined) {
                        localVarQueryParameter['last_event'] = lastEvent;
                    }
                    if (tag !== undefined) {
                        localVarQueryParameter['tag'] = tag;
                    }
                    if (level !== undefined) {
                        localVarQueryParameter['level'] = level;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of policies
         * @param {string} [dateFrom]
         * @param {string} [date]
         * @param {string} [csv]
         * @param {string} [_long]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyGet: function (dateFrom, date, csv, _long, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/policy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (dateFrom !== undefined) {
                        localVarQueryParameter['date_from'] = dateFrom;
                    }
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    if (csv !== undefined) {
                        localVarQueryParameter['csv'] = csv;
                    }
                    if (_long !== undefined) {
                        localVarQueryParameter['long'] = _long;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Send list of policies
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/policy";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/octet-stream';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get array of trips for a vehicle
         * @param {string} licensePlate
         * @param {number} from
         * @param {number} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripGet: function (licensePlate, from, to, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'licensePlate' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1TripGet', 'licensePlate', licensePlate);
                    // verify required parameter 'from' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1TripGet', 'from', from);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1TripGet', 'to', to);
                    localVarPath = "/api/v1/trip";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = from;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = to;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get trip location data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {boolean} [csv]
         * @param {string} [tripId]
         * @param {number} [snapshots]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateGet: function (licensePlate, timeFrom, timeTo, csv, tripId, snapshots, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'licensePlate' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1TripLicensePlateGet', 'licensePlate', licensePlate);
                    localVarPath = "/api/v1/trip/{licensePlate}"
                        .replace("{".concat("licensePlate", "}"), encodeURIComponent(String(licensePlate)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (csv !== undefined) {
                        localVarQueryParameter['csv'] = csv;
                    }
                    if (tripId !== undefined) {
                        localVarQueryParameter['trip_id'] = tripId;
                    }
                    if (snapshots !== undefined) {
                        localVarQueryParameter['snapshots'] = snapshots;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get trip wellness data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateWellnessGet: function (licensePlate, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'licensePlate' is not null or undefined
                    (0, common_1.assertParamExists)('apiV1TripLicensePlateWellnessGet', 'licensePlate', licensePlate);
                    localVarPath = "/api/v1/trip/{licensePlate}/wellness"
                        .replace("{".concat("licensePlate", "}"), encodeURIComponent(String(licensePlate)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get users\' settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update user\'s settings
         * @param {UserProfile} [userProfile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPatch: function (userProfile, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userProfile, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get device details
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [status]
         * @param {string} [versionName]
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (driverName !== undefined) {
                        localVarQueryParameter['driver_name'] = driverName;
                    }
                    if (licensePlateContains !== undefined) {
                        localVarQueryParameter['license_plate_contains'] = licensePlateContains;
                    }
                    if (driverNameContains !== undefined) {
                        localVarQueryParameter['driver_name_contains'] = driverNameContains;
                    }
                    if (deviceId !== undefined) {
                        localVarQueryParameter['device_id'] = deviceId;
                    }
                    if (deviceIdContains !== undefined) {
                        localVarQueryParameter['device_id_contains'] = deviceIdContains;
                    }
                    if (subFleet !== undefined) {
                        localVarQueryParameter['sub_fleet'] = subFleet;
                    }
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    if (dateFrom !== undefined) {
                        localVarQueryParameter['date_from'] = dateFrom;
                    }
                    if (dateTo !== undefined) {
                        localVarQueryParameter['date_to'] = dateTo;
                    }
                    if (version !== undefined) {
                        localVarQueryParameter['version'] = version;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (versionName !== undefined) {
                        localVarQueryParameter['version_name'] = versionName;
                    }
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get device location
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [versionName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceLocationGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, versionName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/device/location";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (driverName !== undefined) {
                        localVarQueryParameter['driver_name'] = driverName;
                    }
                    if (licensePlateContains !== undefined) {
                        localVarQueryParameter['license_plate_contains'] = licensePlateContains;
                    }
                    if (driverNameContains !== undefined) {
                        localVarQueryParameter['driver_name_contains'] = driverNameContains;
                    }
                    if (deviceId !== undefined) {
                        localVarQueryParameter['device_id'] = deviceId;
                    }
                    if (deviceIdContains !== undefined) {
                        localVarQueryParameter['device_id_contains'] = deviceIdContains;
                    }
                    if (subFleet !== undefined) {
                        localVarQueryParameter['sub_fleet'] = subFleet;
                    }
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    if (dateFrom !== undefined) {
                        localVarQueryParameter['date_from'] = dateFrom;
                    }
                    if (dateTo !== undefined) {
                        localVarQueryParameter['date_to'] = dateTo;
                    }
                    if (version !== undefined) {
                        localVarQueryParameter['version'] = version;
                    }
                    if (versionName !== undefined) {
                        localVarQueryParameter['version_name'] = versionName;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate]
         * @param {string} [licensePlateList]
         * @param {string} [driverName]
         * @param {string} [driverNameList]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {string} [subFleetList]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {string} [tripId]
         * @param {string} [tripObjIn]
         * @param {string} [eventType]
         * @param {string} [eventTypeList]
         * @param {number} [severityFrom]
         * @param {number} [severityTo]
         * @param {string} [tag]
         * @param {string} [level]
         * @param {number} [limit]
         * @param {number} [searchAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EventGet: function (licensePlate, licensePlateList, driverName, driverNameList, licensePlateContains, driverNameContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, tripObjIn, eventType, eventTypeList, severityFrom, severityTo, tag, level, limit, searchAfter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/event";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    if (licensePlateList !== undefined) {
                        localVarQueryParameter['license_plate_list'] = licensePlateList;
                    }
                    if (driverName !== undefined) {
                        localVarQueryParameter['driver_name'] = driverName;
                    }
                    if (driverNameList !== undefined) {
                        localVarQueryParameter['driver_name_list'] = driverNameList;
                    }
                    if (licensePlateContains !== undefined) {
                        localVarQueryParameter['license_plate_contains'] = licensePlateContains;
                    }
                    if (driverNameContains !== undefined) {
                        localVarQueryParameter['driver_name_contains'] = driverNameContains;
                    }
                    if (subFleet !== undefined) {
                        localVarQueryParameter['sub_fleet'] = subFleet;
                    }
                    if (subFleetList !== undefined) {
                        localVarQueryParameter['sub_fleet_list'] = subFleetList;
                    }
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    if (dateFrom !== undefined) {
                        localVarQueryParameter['date_from'] = dateFrom;
                    }
                    if (dateTo !== undefined) {
                        localVarQueryParameter['date_to'] = dateTo;
                    }
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (tripId !== undefined) {
                        localVarQueryParameter['trip_id'] = tripId;
                    }
                    if (tripObjIn !== undefined) {
                        localVarQueryParameter['trip_obj__in'] = tripObjIn;
                    }
                    if (eventType !== undefined) {
                        localVarQueryParameter['event_type'] = eventType;
                    }
                    if (eventTypeList !== undefined) {
                        localVarQueryParameter['event_type_list'] = eventTypeList;
                    }
                    if (severityFrom !== undefined) {
                        localVarQueryParameter['severity_from'] = severityFrom;
                    }
                    if (severityTo !== undefined) {
                        localVarQueryParameter['severity_to'] = severityTo;
                    }
                    if (tag !== undefined) {
                        localVarQueryParameter['tag'] = tag;
                    }
                    if (level !== undefined) {
                        localVarQueryParameter['level'] = level;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (searchAfter !== undefined) {
                        localVarQueryParameter['search_after'] = searchAfter;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get trip location data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {boolean} [csv]
         * @param {string} [tripId]
         * @param {number} [driverTripId]
         * @param {number} [snapshots]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlateGet: function (licensePlate, timeFrom, timeTo, csv, tripId, driverTripId, snapshots, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'licensePlate' is not null or undefined
                    (0, common_1.assertParamExists)('apiV2TripLicensePlateGet', 'licensePlate', licensePlate);
                    localVarPath = "/api/v2/trip/{licensePlate}"
                        .replace("{".concat("licensePlate", "}"), encodeURIComponent(String(licensePlate)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timeFrom !== undefined) {
                        localVarQueryParameter['time_from'] = timeFrom;
                    }
                    if (timeTo !== undefined) {
                        localVarQueryParameter['time_to'] = timeTo;
                    }
                    if (csv !== undefined) {
                        localVarQueryParameter['csv'] = csv;
                    }
                    if (tripId !== undefined) {
                        localVarQueryParameter['trip_id'] = tripId;
                    }
                    if (driverTripId !== undefined) {
                        localVarQueryParameter['driver_trip_id'] = driverTripId;
                    }
                    if (snapshots !== undefined) {
                        localVarQueryParameter['snapshots'] = snapshots;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update trip details
         * @param {string} licensePlate
         * @param {TripUpdateRequest} [tripUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlatePost: function (licensePlate, tripUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'licensePlate' is not null or undefined
                    (0, common_1.assertParamExists)('apiV2TripLicensePlatePost', 'licensePlate', licensePlate);
                    localVarPath = "/api/v2/trip/{licensePlate}"
                        .replace("{".concat("licensePlate", "}"), encodeURIComponent(String(licensePlate)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tripUpdateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get wellness image
         * @param {string} wellnessType
         * @param {string} [wellnessId]
         * @param {number} [timestamp]
         * @param {string} [licensePlate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessImageWellnessTypeGet: function (wellnessType, wellnessId, timestamp, licensePlate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'wellnessType' is not null or undefined
                    (0, common_1.assertParamExists)('apiV2WellnessImageWellnessTypeGet', 'wellnessType', wellnessType);
                    localVarPath = "/api/v2/wellness_image/{wellnessType}"
                        .replace("{".concat("wellnessType", "}"), encodeURIComponent(String(wellnessType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (wellnessId !== undefined) {
                        localVarQueryParameter['wellness_id'] = wellnessId;
                    }
                    if (timestamp !== undefined) {
                        localVarQueryParameter['timestamp'] = timestamp;
                    }
                    if (licensePlate !== undefined) {
                        localVarQueryParameter['license_plate'] = licensePlate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Run wellness check
         * @param {RunWellnessRequest} [runWellnessRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessRunTaskPost: function (runWellnessRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v2/wellness/run_task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(runWellnessRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get device details
         * @param {number} [cache]
         * @param {number} [timestamp]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3DeviceGet: function (cache, timestamp, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v3/device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cache !== undefined) {
                        localVarQueryParameter['cache'] = cache;
                    }
                    if (timestamp !== undefined) {
                        localVarQueryParameter['timestamp'] = timestamp;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get customer drivers and home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsCustomerGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Remove hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementDelete: function (hosDriverRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/driver/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hosDriverRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get hos drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/driver/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPatch: function (hosDriverRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/driver/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hosDriverRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new hos driver
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPost: function (hosDriverRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/driver/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hosDriverRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Remove home terminals
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementDelete: function (homeTerminal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/terminal/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(homeTerminal, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/terminal/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Update home terminals
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPatch: function (homeTerminal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/terminal/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(homeTerminal, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create new home terminal
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPost: function (homeTerminal, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/settings/terminal/management";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(homeTerminal, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        }
    };
};
exports.ApiApiAxiosParamCreator = ApiApiAxiosParamCreator;
/**
 * ApiApi - functional programming interface
 * @export
 */
var ApiApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApiApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get device details
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [status]
         * @param {string} [versionName]
         * @param {number} [cache]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [country]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, page, pageSize, country, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAdminDeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, page, pageSize, country, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get device operation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAdminDeviceOperationGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new device operation details
         * @param {DeviceOperationData} [deviceOperationData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationPost: function (deviceOperationData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAdminDeviceOperationPost(deviceOperationData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create overlay on event video
         * @param {EventOverlayRequest} [eventOverlayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOverlayPost: function (eventOverlayRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAdminOverlayPost(eventOverlayRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary get list of all wellness details
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [country]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessGet: function (page, pageSize, country, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAdminWellnessGet(page, pageSize, country, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new wellness details
         * @param {WellnessUpdate} [wellnessUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessPost: function (wellnessUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAdminWellnessPost(wellnessUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthOtpPost(oTPUserCredentials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthPost(userCredentials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthRefreshPost(refreshTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get accident overview data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0AccidentOverviewGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get accident overview data
         * @param {number} timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewTimestampGet: function (timestamp, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0AccidentOverviewTimestampGet(timestamp, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send ICE candidate from browser to device
         * @param {number} sessionId
         * @param {BrowserStreamIceRequest} browserStreamIceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdIcePost: function (sessionId, browserStreamIceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0BrowserStreamSessionIdIcePost(sessionId, browserStreamIceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Poll for messages from device to browser (keep-alive)
         * @param {number} sessionId
         * @param {number} [after] Message ID to fetch messages after (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdMessagesGet: function (sessionId, after, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0BrowserStreamSessionIdMessagesGet(sessionId, after, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send WebRTC offer (SDP) from browser to device
         * @param {number} sessionId
         * @param {BrowserStreamOfferRequest} browserStreamOfferRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdOfferPost: function (sessionId, browserStreamOfferRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0BrowserStreamSessionIdOfferPost(sessionId, browserStreamOfferRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachEventEventIdGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get coaching event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdImageGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachEventEventIdImageGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get event coaching status
         * @param {CoachEventStatus} [coachEventStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventPost: function (coachEventStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachEventPost(coachEventStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metrics data
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsGet: function (driverToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachMetricsGet(driverToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new coaching metrics by driver token
         * @param {CoachMetricsSaveRequest} [coachMetricsSaveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsPost: function (coachMetricsSaveRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachMetricsPost(coachMetricsSaveRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete event from coaching session
         * @param {number} sessionId
         * @param {number} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdDelete: function (sessionId, itemId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdEventItemIdDelete(sessionId, itemId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update event in coaching session
         * @param {number} sessionId
         * @param {number} itemId
         * @param {UpdateCoachEvent} [updateCoachEvent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdPatch: function (sessionId, itemId, updateCoachEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdEventItemIdPatch(sessionId, itemId, updateCoachEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get coaching session details
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdGet: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdGet(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get coaching session image
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdImageGet: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdImageGet(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete coach media file
         * @param {number} sessionId
         * @param {number} coachMediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete: function (sessionId, coachMediaFileId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(sessionId, coachMediaFileId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update coach media file
         * @param {number} sessionId
         * @param {number} coachMediaFileId
         * @param {CoachMediaFileRequest} [coachMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch: function (sessionId, coachMediaFileId, coachMediaFileRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(sessionId, coachMediaFileId, coachMediaFileRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new coach media file
         * @param {number} sessionId
         * @param {CoachMediaFileRequest} [coachMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFilePost: function (sessionId, coachMediaFileRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdMediaFilePost(sessionId, coachMediaFileRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete coach metrics
         * @param {number} sessionId
         * @param {number} metricsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdDelete: function (sessionId, metricsId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdMetricsMetricsIdDelete(sessionId, metricsId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update coach metrics
         * @param {number} sessionId
         * @param {number} metricsId
         * @param {CoachMetrics} [coachMetrics]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdPatch: function (sessionId, metricsId, coachMetrics, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdMetricsMetricsIdPatch(sessionId, metricsId, coachMetrics, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new coaching metrics
         * @param {number} sessionId
         * @param {CoachMetricsRequest} [coachMetricsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsPost: function (sessionId, coachMetricsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdMetricsPost(sessionId, coachMetricsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete manager notes
         * @param {number} sessionId
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdDelete: function (sessionId, noteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdNotesNoteIdDelete(sessionId, noteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update manager notes
         * @param {number} sessionId
         * @param {number} noteId
         * @param {CoachManagerNotes} [coachManagerNotes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdPatch: function (sessionId, noteId, coachManagerNotes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdNotesNoteIdPatch(sessionId, noteId, coachManagerNotes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new manager notes
         * @param {number} sessionId
         * @param {ManagerNotesRequest} [managerNotesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesPost: function (sessionId, managerNotesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdNotesPost(sessionId, managerNotesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} sessionId
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdPost: function (sessionId, updateCoachSession, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdPost(sessionId, updateCoachSession, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new driver response
         * @param {number} sessionId
         * @param {DriverResponseRequest} [driverResponseRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponsePost: function (sessionId, driverResponseRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdResponsePost(sessionId, driverResponseRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete driver response
         * @param {number} sessionId
         * @param {number} responseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdDelete: function (sessionId, responseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdResponseResponseIdDelete(sessionId, responseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update driver response
         * @param {number} sessionId
         * @param {number} responseId
         * @param {CoachDriverResponse} [coachDriverResponse]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdPatch: function (sessionId, responseId, coachDriverResponse, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdResponseResponseIdPatch(sessionId, responseId, coachDriverResponse, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Remove wellness status from driver coaching session
         * @param {number} sessionId
         * @param {number} wellnessId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdDelete: function (sessionId, wellnessId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdWellnessStatusWellnessIdDelete(sessionId, wellnessId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update wellness status from driver coaching session
         * @param {number} sessionId
         * @param {number} wellnessId
         * @param {UpdateCoachWellnessStatus} [updateCoachWellnessStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdPatch: function (sessionId, wellnessId, updateCoachWellnessStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CoachSessionIdWellnessStatusWellnessIdPatch(sessionId, wellnessId, updateCoachWellnessStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {number} commandId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdGet: function (commandId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CommandCommandIdGet(commandId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update remote command description
         * @summary Update remote command
         * @param {number} commandId
         * @param {Body} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPatch: function (commandId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CommandCommandIdPatch(commandId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create remote command
         * @summary Create remote command
         * @param {number} commandId
         * @param {RemoteCommand} [remoteCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPost: function (commandId, remoteCommand, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CommandCommandIdPost(commandId, remoteCommand, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get list of remote commands (defaults to get_clip)
         * @summary Get list of remote commands
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {string} [command] Filter by command type(s). Comma-separated allowlist. If missing or invalid, defaults to get_clip. Allowed: get_clip, format_sd_card, installation_cleanup. Example: command&#x3D;get_clip,format_sd_card
         * @param {number} [accident]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandGet: function (timeFrom, timeTo, command, accident, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CommandGet(timeFrom, timeTo, command, accident, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {Command} [command]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandPost: function (command, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CommandPost(command, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerDelete: function (customerSubFleetData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CustomerDelete(customerSubFleetData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get customer details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CustomerGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerPost: function (customerSubFleetData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CustomerPost(customerSubFleetData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns S3 object keys directly under the authenticated customer prefix in the uniform-wellness export bucket (non-recursive). Requires get_clip permissions; customer must be in SSM allowlist UNIFORM_WELLNESS_IMAGES_CUSTOMERS (else 403).
         * @summary List uniform wellness image keys under the customer prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerUniformWellnessImagesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CustomerUniformWellnessImagesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists objects under {customer_name}/{since} in the export bucket and returns presigned download URLs. Same access rules as GET /api/v0/customer/uniform_wellness_images.
         * @summary List presigned URLs for uniform wellness images under a sub-prefix
         * @param {string} since Path segment(s) under the customer prefix (e.g. UTC folder from the copy job)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerUniformWellnessImagesSinceGet: function (since, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0CustomerUniformWellnessImagesSinceGet(since, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get daily dashboard issues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DailyDashboardGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DailyDashboardGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get device snapshot
         * @param {string} deviceId
         * @param {number} [timestamp]
         * @param {number} [since]
         * @param {number} [exact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceDeviceIdSnapshotGet: function (deviceId, timestamp, since, exact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DeviceDeviceIdSnapshotGet(deviceId, timestamp, since, exact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get device location
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {number} [latitude]
         * @param {number} [longitude]
         * @param {number} [radius]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceLocateGet: function (timeFrom, timeTo, latitude, longitude, radius, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DeviceLocateGet(timeFrom, timeTo, latitude, longitude, radius, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update device details
         * @param {Array<DeviceRequest>} [deviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceUpdatePatch: function (deviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DeviceUpdatePatch(deviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get driver badge
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgeDriverTokenGet: function (driverToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverBadgeDriverTokenGet(driverToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get driver badges
         * @param {DriverBadgeRequest} [driverBadgeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgePost: function (driverBadgeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverBadgePost(driverBadgeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get driver details
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenGet: function (driverToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverDriverTokenGet(driverToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update driver details
         * @param {number} driverToken
         * @param {FleetDriverRequest} [fleetDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenPatch: function (driverToken, fleetDriverRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverDriverTokenPatch(driverToken, fleetDriverRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update multiple drivers
         * @param {FleetDriverList} [fleetDriverList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPatch: function (fleetDriverList, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverPatch(fleetDriverList, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new driver
         * @param {FleetDriverRequest} [fleetDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPost: function (fleetDriverRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverPost(fleetDriverRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * recalculate driver score
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenCalculatePatch: function (driverToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverScoresDriverTokenCalculatePatch(driverToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get driver score with relevant events
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenGet: function (driverToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverScoresDriverTokenGet(driverToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get driver scores
         * @param {number} [allDrivers]
         * @param {number} [page]
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresGet: function (allDrivers, page, cache, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0DriverScoresGet(allDrivers, page, cache, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new event from existing one
         * @param {number} eventId
         * @param {CloneEventDetails} [cloneEventDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdClonePost: function (eventId, cloneEventDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdClonePost(eventId, cloneEventDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get event coaching data
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdCoachGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add or dismiss event from driver coaching session
         * @param {number} eventId
         * @param {CoachEventDetails} [coachEventDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachPost: function (eventId, coachEventDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdCoachPost(eventId, coachEventDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Download event video request
         * @param {number} eventId
         * @param {DownloadVideoEventRequest} [downloadVideoEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdDownloadPost: function (eventId, downloadVideoEventRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdDownloadPost(eventId, downloadVideoEventRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {string} [bucket]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdGet: function (eventId, bucket, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdGet(eventId, bucket, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdImageGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdImageGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update event details
         * @param {number} eventId
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdPatch: function (eventId, inlineObject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdPatch(eventId, inlineObject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get related events
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdRelatedGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdRelatedGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send event
         * @param {number} eventId
         * @param {SendEventRequest} [sendEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdSendPost: function (eventId, sendEventRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdSendPost(eventId, sendEventRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Change event tags
         * @summary Change event tags
         * @param {number} eventId
         * @param {EventTag} [eventTag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdTagPost: function (eventId, eventTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0EventEventIdTagPost(eventId, eventTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add comment to feed event
         * @summary Add comment
         * @param {number} eventId
         * @param {FeedCommentRequest} [feedCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdCommentPost: function (eventId, feedCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FeedEventIdCommentPost(eventId, feedCommentRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add or remove dislike from event
         * @summary Dislike event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdDislikePost: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FeedEventIdDislikePost(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get feed event
         * @summary Get feed event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdGet: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FeedEventIdGet(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add or remove like from event
         * @summary Like event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdLikePost: function (eventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FeedEventIdLikePost(eventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update percent watched
         * @summary Update percent watched
         * @param {number} eventId
         * @param {EventWatchedRequest} [eventWatchedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdWatchedPost: function (eventId, eventWatchedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FeedEventIdWatchedPost(eventId, eventWatchedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get events
         * @summary Get user feed
         * @param {number} [generatedAt]
         * @param {number} [size]
         * @param {number} [fromEvent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedGet: function (generatedAt, size, fromEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FeedGet(generatedAt, size, fromEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get sms with link to feed page
         * @summary Get sms with link to feed page
         * @param {FeedLinkRequest} [feedLinkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedLinkPost: function (feedLinkRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FeedLinkPost(feedLinkRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get fleet safety scores
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetSafetyScoresGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FleetSafetyScoresGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get fleet score and fleet metric data
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreGet: function (cache, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FleetScoreGet(cache, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get fleet scores and score distribution over time
         * @param {number} [cache]
         * @param {number} [endDate]
         * @param {number} [daysCount]
         * @param {number} [daysInterval]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreTrendGet: function (cache, endDate, daysCount, daysInterval, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FleetScoreTrendGet(cache, endDate, daysCount, daysInterval, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get top and bottom drivers for the latest timestamp for each fleet
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetTopBottomDriversGet: function (cache, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0FleetTopBottomDriversGet(cache, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a geofence
         * @param {number} geofenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdDelete: function (geofenceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0GeofenceGeofenceIdDelete(geofenceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a geofence
         * @param {number} geofenceId
         * @param {Geofence} [geofence]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdPatch: function (geofenceId, geofence, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0GeofenceGeofenceIdPatch(geofenceId, geofence, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get geofence details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0GeofenceGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new geofence
         * @param {Geofence} [geofence]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofencePost: function (geofence, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0GeofencePost(geofence, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get help videos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HelpGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0HelpGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get aggregated data of malfunctions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionAggregatedGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionAggregatedGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get malfunction list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create guest technician
         * @param {GuestTechnicianRequest} [guestTechnicianRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGuestPost: function (guestTechnicianRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionGuestPost(guestTechnicianRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get malfunction comments
         * @param {number} malfunctionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentGet: function (malfunctionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionMalfunctionIdCommentGet(malfunctionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add new comment to malfunction
         * @param {number} malfunctionId
         * @param {MalfunctionCommentRequest} [malfunctionCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentPost: function (malfunctionId, malfunctionCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionMalfunctionIdCommentPost(malfunctionId, malfunctionCommentRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get malfunction image
         * @param {number} malfunctionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdImageGet: function (malfunctionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionMalfunctionIdImageGet(malfunctionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update malfunction assignee
         * @param {MalfunctionAssigneeRequest} [malfunctionAssigneeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionPatch: function (malfunctionAssigneeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionPatch(malfunctionAssigneeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Sync malfunctions with policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionUpdateGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MalfunctionUpdateGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get media file library
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MediaFilesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete media file
         * @param {number} mediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdDelete: function (mediaFileId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MediaFilesMediaFileIdDelete(mediaFileId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get signed url for media file
         * @summary Get signed url for media file
         * @param {number} mediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdGet: function (mediaFileId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MediaFilesMediaFileIdGet(mediaFileId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update media file
         * @param {number} mediaFileId
         * @param {MediaFile} [mediaFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdPatch: function (mediaFileId, mediaFile, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MediaFilesMediaFileIdPatch(mediaFileId, mediaFile, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get file upload url
         * @param {UploadMediaFileRequest} [uploadMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPost: function (uploadMediaFileRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MediaFilesPost(uploadMediaFileRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add media file to database
         * @param {MediaFileRequest} [mediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPut: function (mediaFileRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0MediaFilesPut(mediaFileRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new NPS
         * @param {Nps} [nps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0NpsPost: function (nps, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0NpsPost(nps, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove package to device list
         * @param {PackageTrackerData} [packageTrackerData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackageDelete: function (packageTrackerData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PackageDelete(packageTrackerData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove file from package
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdDelete: function (packageId, fileData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PackagePackageIdDelete(packageId, fileData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get file upload data
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPost: function (packageId, fileData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PackagePackageIdPost(packageId, fileData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add file to existing package
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPut: function (packageId, fileData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PackagePackageIdPut(packageId, fileData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new package
         * @param {PackageName} [packageName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePost: function (packageName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PackagePost(packageName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Attach package to device list
         * @param {PackageTrackerData} [packageTrackerData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePut: function (packageTrackerData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PackagePut(packageTrackerData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get premium optimization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PremiumOptimizationGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new premium optimization details
         * @param {PremiumOptimizationRequest} [premiumOptimizationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationPost: function (premiumOptimizationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PremiumOptimizationPost(premiumOptimizationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send reminder
         * @param {PremiumOptimizationReminderRequest} [premiumOptimizationReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationReminderPost: function (premiumOptimizationReminderRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0PremiumOptimizationReminderPost(premiumOptimizationReminderRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get release notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReleaseNotesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReleaseNotesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of reports and alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary create new report or alert
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportPost: function (alertOrReport, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportPost(alertOrReport, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary create new report or alert
         * @param {number} reportId
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdDelete: function (reportId, alertOrReport, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportReportIdDelete(reportId, alertOrReport, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update report or alert
         * @param {number} reportId
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdPatch: function (reportId, alertOrReport, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportReportIdPatch(reportId, alertOrReport, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of report instances
         * @param {string} [reportType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunGet: function (reportType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportRunGet(reportType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get report instance
         * @param {number} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdGet: function (instanceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportRunInstanceIdGet(instanceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update report instance
         * @param {number} instanceId
         * @param {ReportInstanceUpdate} [reportInstanceUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdPatch: function (instanceId, reportInstanceUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportRunInstanceIdPatch(instanceId, reportInstanceUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send report
         * @param {number} instanceId
         * @param {SendReportRequest} [sendReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdSendPost: function (instanceId, sendReportRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportRunInstanceIdSendPost(instanceId, sendReportRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate report
         * @param {ReportInstanceRequest} [reportInstanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunPost: function (reportInstanceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0ReportRunPost(reportInstanceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update customer settings
         * @param {CustomerSettingsRequest} [customerSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerPatch: function (customerSettingsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsCustomerPatch(customerSettingsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get customer accident sticker
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerStickerPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsCustomerStickerPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Change user\'s email
         * @param {ChangeEmailRequest} [changeEmailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserEmailPatch: function (changeEmailRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserEmailPatch(changeEmailRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove users
         * @param {Array<UserDetails>} [userDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementDelete: function (userDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserManagementDelete(userDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get users\' permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserManagementGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update users\' permissions
         * @param {Array<UserDetails>} [userDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPatch: function (userDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserManagementPatch(userDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new user
         * @param {Array<UserCreationData>} [userCreationData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPost: function (userCreationData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserManagementPost(userCreationData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Change user\'s password
         * @param {ChangePasswordRequest} [changePasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPasswordPatch: function (changePasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserPasswordPatch(changePasswordRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Request permission change
         * @param {ChangePermissionsRequest} [changePermissionsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPermissionPost: function (changePermissionsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserPermissionPost(changePermissionsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Request password reset
         * @param {ResetPasswordRequest} [resetPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserResetPasswordPost: function (resetPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0SettingsUserResetPasswordPost(resetPasswordRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of existing tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TagGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0TagGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user notifications
         * @param {number} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationGet: function (from, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0UserNotificationGet(from, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update user notification
         * @param {number} notificationId
         * @param {UserNotificationRequest} [userNotificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationNotificationIdPatch: function (notificationId, userNotificationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0UserNotificationNotificationIdPatch(notificationId, userNotificationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update last seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationPatch: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0UserNotificationPatch(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Save video preview as an event
         * @param {number} previewRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestEventPreviewRequestIdPost: function (previewRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0VideoPreviewRequestEventPreviewRequestIdPost(previewRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get video preview request details
         * @param {number} tripId
         * @param {number} [driverTripId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestGet: function (tripId, driverTripId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0VideoPreviewRequestGet(tripId, driverTripId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new video preview request
         * @param {VideoPreviewRequestBody} [videoPreviewRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestPost: function (videoPreviewRequestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0VideoPreviewRequestPost(videoPreviewRequestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get wellness score list
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresGet: function (cache, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0WellnessScoresGet(cache, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * get wellness score details
         * @param {string} licensePlate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresLicensePlateGet: function (licensePlate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0WellnessScoresLicensePlateGet(licensePlate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add or dismiss wellness status from driver coaching session
         * @param {number} wellnessId
         * @param {CoachWellnessDetails} [coachWellnessDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessStatusWellnessIdCoachPost: function (wellnessId, coachWellnessDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV0WellnessStatusWellnessIdCoachPost(wellnessId, coachWellnessDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get driver coaching session
         * @param {string} token
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverGet: function (token, code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachDriverGet(token, code, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update session metadata
         * @param {string} token
         * @param {string} [code]
         * @param {CoachSessionMetadata} [coachSessionMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPatch: function (token, code, coachSessionMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachDriverPatch(token, code, coachSessionMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Complete driver coaching session
         * @param {string} token
         * @param {string} [code]
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPost: function (token, code, updateCoachSession, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachDriverPost(token, code, updateCoachSession, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} [driverToken]
         * @param {number} [completedFrom]
         * @param {number} [completedTo]
         * @param {number} [additionalInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachGet: function (driverToken, completedFrom, completedTo, additionalInfo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachGet(driverToken, completedFrom, completedTo, additionalInfo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send coaching session link by sms
         * @param {CoachSessionMessageRequest} coachSessionMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSendPost: function (coachSessionMessageRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachSendPost(coachSessionMessageRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete coaching session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdDelete: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachSessionIdDelete(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get coaching session details
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdGet: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachSessionIdGet(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Change coaching session assignee or agenda
         * @param {number} sessionId
         * @param {CoachSession} [coachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPatch: function (sessionId, coachSession, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachSessionIdPatch(sessionId, coachSession, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} sessionId
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPost: function (sessionId, updateCoachSession, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachSessionIdPost(sessionId, updateCoachSession, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send the driver a reminder to complete session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdRemindPost: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachSessionIdRemindPost(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Save auto-generated coaching session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdSavePost: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachSessionIdSavePost(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get coaching overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachingOverviewGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CoachingOverviewGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate]
         * @param {string} [licensePlateList]
         * @param {string} [licensePlateContains]
         * @param {string} [subFleet]
         * @param {string} [subFleetList]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {string} [tripId]
         * @param {number} [lastTrip]
         * @param {string} [tripObjIn]
         * @param {string} [severity]
         * @param {string} [eventType]
         * @param {string} [eventTypeList]
         * @param {number} [lastEvent]
         * @param {string} [tag]
         * @param {string} [level]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventGet: function (licensePlate, licensePlateList, licensePlateContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, lastTrip, tripObjIn, severity, eventType, eventTypeList, lastEvent, tag, level, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EventGet(licensePlate, licensePlateList, licensePlateContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, lastTrip, tripObjIn, severity, eventType, eventTypeList, lastEvent, tag, level, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of policies
         * @param {string} [dateFrom]
         * @param {string} [date]
         * @param {string} [csv]
         * @param {string} [_long]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyGet: function (dateFrom, date, csv, _long, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PolicyGet(dateFrom, date, csv, _long, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send list of policies
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PolicyPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get array of trips for a vehicle
         * @param {string} licensePlate
         * @param {number} from
         * @param {number} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripGet: function (licensePlate, from, to, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TripGet(licensePlate, from, to, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get trip location data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {boolean} [csv]
         * @param {string} [tripId]
         * @param {number} [snapshots]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateGet: function (licensePlate, timeFrom, timeTo, csv, tripId, snapshots, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, snapshots, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get trip wellness data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateWellnessGet: function (licensePlate, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TripLicensePlateWellnessGet(licensePlate, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get users\' settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update user\'s settings
         * @param {UserProfile} [userProfile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPatch: function (userProfile, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserPatch(userProfile, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get device details
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [status]
         * @param {string} [versionName]
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2DeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get device location
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [versionName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceLocationGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, versionName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2DeviceLocationGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, versionName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate]
         * @param {string} [licensePlateList]
         * @param {string} [driverName]
         * @param {string} [driverNameList]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {string} [subFleetList]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {string} [tripId]
         * @param {string} [tripObjIn]
         * @param {string} [eventType]
         * @param {string} [eventTypeList]
         * @param {number} [severityFrom]
         * @param {number} [severityTo]
         * @param {string} [tag]
         * @param {string} [level]
         * @param {number} [limit]
         * @param {number} [searchAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EventGet: function (licensePlate, licensePlateList, driverName, driverNameList, licensePlateContains, driverNameContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, tripObjIn, eventType, eventTypeList, severityFrom, severityTo, tag, level, limit, searchAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2EventGet(licensePlate, licensePlateList, driverName, driverNameList, licensePlateContains, driverNameContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, tripObjIn, eventType, eventTypeList, severityFrom, severityTo, tag, level, limit, searchAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get trip location data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {boolean} [csv]
         * @param {string} [tripId]
         * @param {number} [driverTripId]
         * @param {number} [snapshots]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlateGet: function (licensePlate, timeFrom, timeTo, csv, tripId, driverTripId, snapshots, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, driverTripId, snapshots, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update trip details
         * @param {string} licensePlate
         * @param {TripUpdateRequest} [tripUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlatePost: function (licensePlate, tripUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2TripLicensePlatePost(licensePlate, tripUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get wellness image
         * @param {string} wellnessType
         * @param {string} [wellnessId]
         * @param {number} [timestamp]
         * @param {string} [licensePlate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessImageWellnessTypeGet: function (wellnessType, wellnessId, timestamp, licensePlate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2WellnessImageWellnessTypeGet(wellnessType, wellnessId, timestamp, licensePlate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Run wellness check
         * @param {RunWellnessRequest} [runWellnessRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessRunTaskPost: function (runWellnessRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2WellnessRunTaskPost(runWellnessRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get device details
         * @param {number} [cache]
         * @param {number} [timestamp]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3DeviceGet: function (cache, timestamp, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV3DeviceGet(cache, timestamp, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get customer drivers and home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsCustomerGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsCustomerGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementDelete: function (hosDriverRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsDriverManagementDelete(hosDriverRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get hos drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsDriverManagementGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPatch: function (hosDriverRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsDriverManagementPatch(hosDriverRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new hos driver
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPost: function (hosDriverRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsDriverManagementPost(hosDriverRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove home terminals
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementDelete: function (homeTerminal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsTerminalManagementDelete(homeTerminal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsTerminalManagementGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update home terminals
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPatch: function (homeTerminal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsTerminalManagementPatch(homeTerminal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new home terminal
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPost: function (homeTerminal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0SettingsTerminalManagementPost(homeTerminal, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
exports.ApiApiFp = ApiApiFp;
/**
 * ApiApi - factory interface
 * @export
 */
var ApiApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApiApiFp)(configuration);
    return {
        /**
         *
         * @summary Get device details
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [status]
         * @param {string} [versionName]
         * @param {number} [cache]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [country]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, page, pageSize, country, options) {
            return localVarFp.apiAdminDeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, page, pageSize, country, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get device operation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationGet: function (options) {
            return localVarFp.apiAdminDeviceOperationGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new device operation details
         * @param {DeviceOperationData} [deviceOperationData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationPost: function (deviceOperationData, options) {
            return localVarFp.apiAdminDeviceOperationPost(deviceOperationData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create overlay on event video
         * @param {EventOverlayRequest} [eventOverlayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOverlayPost: function (eventOverlayRequest, options) {
            return localVarFp.apiAdminOverlayPost(eventOverlayRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary get list of all wellness details
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [country]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessGet: function (page, pageSize, country, options) {
            return localVarFp.apiAdminWellnessGet(page, pageSize, country, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new wellness details
         * @param {WellnessUpdate} [wellnessUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessPost: function (wellnessUpdate, options) {
            return localVarFp.apiAdminWellnessPost(wellnessUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            return localVarFp.apiAuthOtpPost(oTPUserCredentials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            return localVarFp.apiAuthPost(userCredentials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            return localVarFp.apiAuthRefreshPost(refreshTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get accident overview data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewGet: function (options) {
            return localVarFp.apiV0AccidentOverviewGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get accident overview data
         * @param {number} timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewTimestampGet: function (timestamp, options) {
            return localVarFp.apiV0AccidentOverviewTimestampGet(timestamp, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send ICE candidate from browser to device
         * @param {number} sessionId
         * @param {BrowserStreamIceRequest} browserStreamIceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdIcePost: function (sessionId, browserStreamIceRequest, options) {
            return localVarFp.apiV0BrowserStreamSessionIdIcePost(sessionId, browserStreamIceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Poll for messages from device to browser (keep-alive)
         * @param {number} sessionId
         * @param {number} [after] Message ID to fetch messages after (defaults to 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdMessagesGet: function (sessionId, after, options) {
            return localVarFp.apiV0BrowserStreamSessionIdMessagesGet(sessionId, after, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send WebRTC offer (SDP) from browser to device
         * @param {number} sessionId
         * @param {BrowserStreamOfferRequest} browserStreamOfferRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0BrowserStreamSessionIdOfferPost: function (sessionId, browserStreamOfferRequest, options) {
            return localVarFp.apiV0BrowserStreamSessionIdOfferPost(sessionId, browserStreamOfferRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdGet: function (eventId, options) {
            return localVarFp.apiV0CoachEventEventIdGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get coaching event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdImageGet: function (eventId, options) {
            return localVarFp.apiV0CoachEventEventIdImageGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get event coaching status
         * @param {CoachEventStatus} [coachEventStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventPost: function (coachEventStatus, options) {
            return localVarFp.apiV0CoachEventPost(coachEventStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metrics data
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsGet: function (driverToken, options) {
            return localVarFp.apiV0CoachMetricsGet(driverToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new coaching metrics by driver token
         * @param {CoachMetricsSaveRequest} [coachMetricsSaveRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsPost: function (coachMetricsSaveRequest, options) {
            return localVarFp.apiV0CoachMetricsPost(coachMetricsSaveRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete event from coaching session
         * @param {number} sessionId
         * @param {number} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdDelete: function (sessionId, itemId, options) {
            return localVarFp.apiV0CoachSessionIdEventItemIdDelete(sessionId, itemId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update event in coaching session
         * @param {number} sessionId
         * @param {number} itemId
         * @param {UpdateCoachEvent} [updateCoachEvent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdPatch: function (sessionId, itemId, updateCoachEvent, options) {
            return localVarFp.apiV0CoachSessionIdEventItemIdPatch(sessionId, itemId, updateCoachEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get coaching session details
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdGet: function (sessionId, options) {
            return localVarFp.apiV0CoachSessionIdGet(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get coaching session image
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdImageGet: function (sessionId, options) {
            return localVarFp.apiV0CoachSessionIdImageGet(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete coach media file
         * @param {number} sessionId
         * @param {number} coachMediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete: function (sessionId, coachMediaFileId, options) {
            return localVarFp.apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(sessionId, coachMediaFileId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update coach media file
         * @param {number} sessionId
         * @param {number} coachMediaFileId
         * @param {CoachMediaFileRequest} [coachMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch: function (sessionId, coachMediaFileId, coachMediaFileRequest, options) {
            return localVarFp.apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(sessionId, coachMediaFileId, coachMediaFileRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new coach media file
         * @param {number} sessionId
         * @param {CoachMediaFileRequest} [coachMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFilePost: function (sessionId, coachMediaFileRequest, options) {
            return localVarFp.apiV0CoachSessionIdMediaFilePost(sessionId, coachMediaFileRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete coach metrics
         * @param {number} sessionId
         * @param {number} metricsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdDelete: function (sessionId, metricsId, options) {
            return localVarFp.apiV0CoachSessionIdMetricsMetricsIdDelete(sessionId, metricsId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update coach metrics
         * @param {number} sessionId
         * @param {number} metricsId
         * @param {CoachMetrics} [coachMetrics]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdPatch: function (sessionId, metricsId, coachMetrics, options) {
            return localVarFp.apiV0CoachSessionIdMetricsMetricsIdPatch(sessionId, metricsId, coachMetrics, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new coaching metrics
         * @param {number} sessionId
         * @param {CoachMetricsRequest} [coachMetricsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsPost: function (sessionId, coachMetricsRequest, options) {
            return localVarFp.apiV0CoachSessionIdMetricsPost(sessionId, coachMetricsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete manager notes
         * @param {number} sessionId
         * @param {number} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdDelete: function (sessionId, noteId, options) {
            return localVarFp.apiV0CoachSessionIdNotesNoteIdDelete(sessionId, noteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update manager notes
         * @param {number} sessionId
         * @param {number} noteId
         * @param {CoachManagerNotes} [coachManagerNotes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdPatch: function (sessionId, noteId, coachManagerNotes, options) {
            return localVarFp.apiV0CoachSessionIdNotesNoteIdPatch(sessionId, noteId, coachManagerNotes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new manager notes
         * @param {number} sessionId
         * @param {ManagerNotesRequest} [managerNotesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesPost: function (sessionId, managerNotesRequest, options) {
            return localVarFp.apiV0CoachSessionIdNotesPost(sessionId, managerNotesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} sessionId
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdPost: function (sessionId, updateCoachSession, options) {
            return localVarFp.apiV0CoachSessionIdPost(sessionId, updateCoachSession, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new driver response
         * @param {number} sessionId
         * @param {DriverResponseRequest} [driverResponseRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponsePost: function (sessionId, driverResponseRequest, options) {
            return localVarFp.apiV0CoachSessionIdResponsePost(sessionId, driverResponseRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete driver response
         * @param {number} sessionId
         * @param {number} responseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdDelete: function (sessionId, responseId, options) {
            return localVarFp.apiV0CoachSessionIdResponseResponseIdDelete(sessionId, responseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update driver response
         * @param {number} sessionId
         * @param {number} responseId
         * @param {CoachDriverResponse} [coachDriverResponse]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdPatch: function (sessionId, responseId, coachDriverResponse, options) {
            return localVarFp.apiV0CoachSessionIdResponseResponseIdPatch(sessionId, responseId, coachDriverResponse, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Remove wellness status from driver coaching session
         * @param {number} sessionId
         * @param {number} wellnessId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdDelete: function (sessionId, wellnessId, options) {
            return localVarFp.apiV0CoachSessionIdWellnessStatusWellnessIdDelete(sessionId, wellnessId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update wellness status from driver coaching session
         * @param {number} sessionId
         * @param {number} wellnessId
         * @param {UpdateCoachWellnessStatus} [updateCoachWellnessStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdPatch: function (sessionId, wellnessId, updateCoachWellnessStatus, options) {
            return localVarFp.apiV0CoachSessionIdWellnessStatusWellnessIdPatch(sessionId, wellnessId, updateCoachWellnessStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {number} commandId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdGet: function (commandId, options) {
            return localVarFp.apiV0CommandCommandIdGet(commandId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update remote command description
         * @summary Update remote command
         * @param {number} commandId
         * @param {Body} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPatch: function (commandId, body, options) {
            return localVarFp.apiV0CommandCommandIdPatch(commandId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create remote command
         * @summary Create remote command
         * @param {number} commandId
         * @param {RemoteCommand} [remoteCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPost: function (commandId, remoteCommand, options) {
            return localVarFp.apiV0CommandCommandIdPost(commandId, remoteCommand, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of remote commands (defaults to get_clip)
         * @summary Get list of remote commands
         * @param {number} [timeFrom]
         * @param {number} [timeTo]
         * @param {string} [command] Filter by command type(s). Comma-separated allowlist. If missing or invalid, defaults to get_clip. Allowed: get_clip, format_sd_card, installation_cleanup. Example: command&#x3D;get_clip,format_sd_card
         * @param {number} [accident]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandGet: function (timeFrom, timeTo, command, accident, options) {
            return localVarFp.apiV0CommandGet(timeFrom, timeTo, command, accident, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {Command} [command]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandPost: function (command, options) {
            return localVarFp.apiV0CommandPost(command, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerDelete: function (customerSubFleetData, options) {
            return localVarFp.apiV0CustomerDelete(customerSubFleetData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get customer details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerGet: function (options) {
            return localVarFp.apiV0CustomerGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerPost: function (customerSubFleetData, options) {
            return localVarFp.apiV0CustomerPost(customerSubFleetData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns S3 object keys directly under the authenticated customer prefix in the uniform-wellness export bucket (non-recursive). Requires get_clip permissions; customer must be in SSM allowlist UNIFORM_WELLNESS_IMAGES_CUSTOMERS (else 403).
         * @summary List uniform wellness image keys under the customer prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerUniformWellnessImagesGet: function (options) {
            return localVarFp.apiV0CustomerUniformWellnessImagesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists objects under {customer_name}/{since} in the export bucket and returns presigned download URLs. Same access rules as GET /api/v0/customer/uniform_wellness_images.
         * @summary List presigned URLs for uniform wellness images under a sub-prefix
         * @param {string} since Path segment(s) under the customer prefix (e.g. UTC folder from the copy job)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerUniformWellnessImagesSinceGet: function (since, options) {
            return localVarFp.apiV0CustomerUniformWellnessImagesSinceGet(since, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get daily dashboard issues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DailyDashboardGet: function (options) {
            return localVarFp.apiV0DailyDashboardGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get device snapshot
         * @param {string} deviceId
         * @param {number} [timestamp]
         * @param {number} [since]
         * @param {number} [exact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceDeviceIdSnapshotGet: function (deviceId, timestamp, since, exact, options) {
            return localVarFp.apiV0DeviceDeviceIdSnapshotGet(deviceId, timestamp, since, exact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get device location
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {number} [latitude]
         * @param {number} [longitude]
         * @param {number} [radius]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceLocateGet: function (timeFrom, timeTo, latitude, longitude, radius, options) {
            return localVarFp.apiV0DeviceLocateGet(timeFrom, timeTo, latitude, longitude, radius, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update device details
         * @param {Array<DeviceRequest>} [deviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceUpdatePatch: function (deviceRequest, options) {
            return localVarFp.apiV0DeviceUpdatePatch(deviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get driver badge
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgeDriverTokenGet: function (driverToken, options) {
            return localVarFp.apiV0DriverBadgeDriverTokenGet(driverToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get driver badges
         * @param {DriverBadgeRequest} [driverBadgeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgePost: function (driverBadgeRequest, options) {
            return localVarFp.apiV0DriverBadgePost(driverBadgeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get driver details
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenGet: function (driverToken, options) {
            return localVarFp.apiV0DriverDriverTokenGet(driverToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update driver details
         * @param {number} driverToken
         * @param {FleetDriverRequest} [fleetDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenPatch: function (driverToken, fleetDriverRequest, options) {
            return localVarFp.apiV0DriverDriverTokenPatch(driverToken, fleetDriverRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverGet: function (options) {
            return localVarFp.apiV0DriverGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update multiple drivers
         * @param {FleetDriverList} [fleetDriverList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPatch: function (fleetDriverList, options) {
            return localVarFp.apiV0DriverPatch(fleetDriverList, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new driver
         * @param {FleetDriverRequest} [fleetDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPost: function (fleetDriverRequest, options) {
            return localVarFp.apiV0DriverPost(fleetDriverRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * recalculate driver score
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenCalculatePatch: function (driverToken, options) {
            return localVarFp.apiV0DriverScoresDriverTokenCalculatePatch(driverToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get driver score with relevant events
         * @param {number} driverToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenGet: function (driverToken, options) {
            return localVarFp.apiV0DriverScoresDriverTokenGet(driverToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get driver scores
         * @param {number} [allDrivers]
         * @param {number} [page]
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresGet: function (allDrivers, page, cache, options) {
            return localVarFp.apiV0DriverScoresGet(allDrivers, page, cache, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new event from existing one
         * @param {number} eventId
         * @param {CloneEventDetails} [cloneEventDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdClonePost: function (eventId, cloneEventDetails, options) {
            return localVarFp.apiV0EventEventIdClonePost(eventId, cloneEventDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get event coaching data
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachGet: function (eventId, options) {
            return localVarFp.apiV0EventEventIdCoachGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add or dismiss event from driver coaching session
         * @param {number} eventId
         * @param {CoachEventDetails} [coachEventDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachPost: function (eventId, coachEventDetails, options) {
            return localVarFp.apiV0EventEventIdCoachPost(eventId, coachEventDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Download event video request
         * @param {number} eventId
         * @param {DownloadVideoEventRequest} [downloadVideoEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdDownloadPost: function (eventId, downloadVideoEventRequest, options) {
            return localVarFp.apiV0EventEventIdDownloadPost(eventId, downloadVideoEventRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId
         * @param {string} [bucket]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdGet: function (eventId, bucket, options) {
            return localVarFp.apiV0EventEventIdGet(eventId, bucket, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get event image
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdImageGet: function (eventId, options) {
            return localVarFp.apiV0EventEventIdImageGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update event details
         * @param {number} eventId
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdPatch: function (eventId, inlineObject, options) {
            return localVarFp.apiV0EventEventIdPatch(eventId, inlineObject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get related events
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdRelatedGet: function (eventId, options) {
            return localVarFp.apiV0EventEventIdRelatedGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send event
         * @param {number} eventId
         * @param {SendEventRequest} [sendEventRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdSendPost: function (eventId, sendEventRequest, options) {
            return localVarFp.apiV0EventEventIdSendPost(eventId, sendEventRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Change event tags
         * @summary Change event tags
         * @param {number} eventId
         * @param {EventTag} [eventTag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdTagPost: function (eventId, eventTag, options) {
            return localVarFp.apiV0EventEventIdTagPost(eventId, eventTag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add comment to feed event
         * @summary Add comment
         * @param {number} eventId
         * @param {FeedCommentRequest} [feedCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdCommentPost: function (eventId, feedCommentRequest, options) {
            return localVarFp.apiV0FeedEventIdCommentPost(eventId, feedCommentRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add or remove dislike from event
         * @summary Dislike event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdDislikePost: function (eventId, options) {
            return localVarFp.apiV0FeedEventIdDislikePost(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get feed event
         * @summary Get feed event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdGet: function (eventId, options) {
            return localVarFp.apiV0FeedEventIdGet(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add or remove like from event
         * @summary Like event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdLikePost: function (eventId, options) {
            return localVarFp.apiV0FeedEventIdLikePost(eventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update percent watched
         * @summary Update percent watched
         * @param {number} eventId
         * @param {EventWatchedRequest} [eventWatchedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdWatchedPost: function (eventId, eventWatchedRequest, options) {
            return localVarFp.apiV0FeedEventIdWatchedPost(eventId, eventWatchedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get events
         * @summary Get user feed
         * @param {number} [generatedAt]
         * @param {number} [size]
         * @param {number} [fromEvent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedGet: function (generatedAt, size, fromEvent, options) {
            return localVarFp.apiV0FeedGet(generatedAt, size, fromEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get sms with link to feed page
         * @summary Get sms with link to feed page
         * @param {FeedLinkRequest} [feedLinkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedLinkPost: function (feedLinkRequest, options) {
            return localVarFp.apiV0FeedLinkPost(feedLinkRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get fleet safety scores
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetSafetyScoresGet: function (options) {
            return localVarFp.apiV0FleetSafetyScoresGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get fleet score and fleet metric data
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreGet: function (cache, options) {
            return localVarFp.apiV0FleetScoreGet(cache, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get fleet scores and score distribution over time
         * @param {number} [cache]
         * @param {number} [endDate]
         * @param {number} [daysCount]
         * @param {number} [daysInterval]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreTrendGet: function (cache, endDate, daysCount, daysInterval, options) {
            return localVarFp.apiV0FleetScoreTrendGet(cache, endDate, daysCount, daysInterval, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get top and bottom drivers for the latest timestamp for each fleet
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetTopBottomDriversGet: function (cache, options) {
            return localVarFp.apiV0FleetTopBottomDriversGet(cache, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a geofence
         * @param {number} geofenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdDelete: function (geofenceId, options) {
            return localVarFp.apiV0GeofenceGeofenceIdDelete(geofenceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a geofence
         * @param {number} geofenceId
         * @param {Geofence} [geofence]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdPatch: function (geofenceId, geofence, options) {
            return localVarFp.apiV0GeofenceGeofenceIdPatch(geofenceId, geofence, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get geofence details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGet: function (options) {
            return localVarFp.apiV0GeofenceGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new geofence
         * @param {Geofence} [geofence]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofencePost: function (geofence, options) {
            return localVarFp.apiV0GeofencePost(geofence, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get help videos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HelpGet: function (options) {
            return localVarFp.apiV0HelpGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get aggregated data of malfunctions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionAggregatedGet: function (options) {
            return localVarFp.apiV0MalfunctionAggregatedGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get malfunction list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGet: function (options) {
            return localVarFp.apiV0MalfunctionGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create guest technician
         * @param {GuestTechnicianRequest} [guestTechnicianRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGuestPost: function (guestTechnicianRequest, options) {
            return localVarFp.apiV0MalfunctionGuestPost(guestTechnicianRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get malfunction comments
         * @param {number} malfunctionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentGet: function (malfunctionId, options) {
            return localVarFp.apiV0MalfunctionMalfunctionIdCommentGet(malfunctionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add new comment to malfunction
         * @param {number} malfunctionId
         * @param {MalfunctionCommentRequest} [malfunctionCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentPost: function (malfunctionId, malfunctionCommentRequest, options) {
            return localVarFp.apiV0MalfunctionMalfunctionIdCommentPost(malfunctionId, malfunctionCommentRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get malfunction image
         * @param {number} malfunctionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdImageGet: function (malfunctionId, options) {
            return localVarFp.apiV0MalfunctionMalfunctionIdImageGet(malfunctionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update malfunction assignee
         * @param {MalfunctionAssigneeRequest} [malfunctionAssigneeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionPatch: function (malfunctionAssigneeRequest, options) {
            return localVarFp.apiV0MalfunctionPatch(malfunctionAssigneeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Sync malfunctions with policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionUpdateGet: function (options) {
            return localVarFp.apiV0MalfunctionUpdateGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get media file library
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesGet: function (options) {
            return localVarFp.apiV0MediaFilesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete media file
         * @param {number} mediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdDelete: function (mediaFileId, options) {
            return localVarFp.apiV0MediaFilesMediaFileIdDelete(mediaFileId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get signed url for media file
         * @summary Get signed url for media file
         * @param {number} mediaFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdGet: function (mediaFileId, options) {
            return localVarFp.apiV0MediaFilesMediaFileIdGet(mediaFileId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update media file
         * @param {number} mediaFileId
         * @param {MediaFile} [mediaFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdPatch: function (mediaFileId, mediaFile, options) {
            return localVarFp.apiV0MediaFilesMediaFileIdPatch(mediaFileId, mediaFile, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get file upload url
         * @param {UploadMediaFileRequest} [uploadMediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPost: function (uploadMediaFileRequest, options) {
            return localVarFp.apiV0MediaFilesPost(uploadMediaFileRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add media file to database
         * @param {MediaFileRequest} [mediaFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPut: function (mediaFileRequest, options) {
            return localVarFp.apiV0MediaFilesPut(mediaFileRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new NPS
         * @param {Nps} [nps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0NpsPost: function (nps, options) {
            return localVarFp.apiV0NpsPost(nps, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove package to device list
         * @param {PackageTrackerData} [packageTrackerData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackageDelete: function (packageTrackerData, options) {
            return localVarFp.apiV0PackageDelete(packageTrackerData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove file from package
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdDelete: function (packageId, fileData, options) {
            return localVarFp.apiV0PackagePackageIdDelete(packageId, fileData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get file upload data
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPost: function (packageId, fileData, options) {
            return localVarFp.apiV0PackagePackageIdPost(packageId, fileData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add file to existing package
         * @param {number} packageId
         * @param {FileData} [fileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPut: function (packageId, fileData, options) {
            return localVarFp.apiV0PackagePackageIdPut(packageId, fileData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new package
         * @param {PackageName} [packageName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePost: function (packageName, options) {
            return localVarFp.apiV0PackagePost(packageName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Attach package to device list
         * @param {PackageTrackerData} [packageTrackerData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePut: function (packageTrackerData, options) {
            return localVarFp.apiV0PackagePut(packageTrackerData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get premium optimization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationGet: function (options) {
            return localVarFp.apiV0PremiumOptimizationGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new premium optimization details
         * @param {PremiumOptimizationRequest} [premiumOptimizationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationPost: function (premiumOptimizationRequest, options) {
            return localVarFp.apiV0PremiumOptimizationPost(premiumOptimizationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send reminder
         * @param {PremiumOptimizationReminderRequest} [premiumOptimizationReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationReminderPost: function (premiumOptimizationReminderRequest, options) {
            return localVarFp.apiV0PremiumOptimizationReminderPost(premiumOptimizationReminderRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get release notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReleaseNotesGet: function (options) {
            return localVarFp.apiV0ReleaseNotesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of reports and alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportGet: function (options) {
            return localVarFp.apiV0ReportGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary create new report or alert
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportPost: function (alertOrReport, options) {
            return localVarFp.apiV0ReportPost(alertOrReport, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary create new report or alert
         * @param {number} reportId
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdDelete: function (reportId, alertOrReport, options) {
            return localVarFp.apiV0ReportReportIdDelete(reportId, alertOrReport, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update report or alert
         * @param {number} reportId
         * @param {AlertOrReport} [alertOrReport]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdPatch: function (reportId, alertOrReport, options) {
            return localVarFp.apiV0ReportReportIdPatch(reportId, alertOrReport, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of report instances
         * @param {string} [reportType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunGet: function (reportType, options) {
            return localVarFp.apiV0ReportRunGet(reportType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get report instance
         * @param {number} instanceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdGet: function (instanceId, options) {
            return localVarFp.apiV0ReportRunInstanceIdGet(instanceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update report instance
         * @param {number} instanceId
         * @param {ReportInstanceUpdate} [reportInstanceUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdPatch: function (instanceId, reportInstanceUpdate, options) {
            return localVarFp.apiV0ReportRunInstanceIdPatch(instanceId, reportInstanceUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send report
         * @param {number} instanceId
         * @param {SendReportRequest} [sendReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdSendPost: function (instanceId, sendReportRequest, options) {
            return localVarFp.apiV0ReportRunInstanceIdSendPost(instanceId, sendReportRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate report
         * @param {ReportInstanceRequest} [reportInstanceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunPost: function (reportInstanceRequest, options) {
            return localVarFp.apiV0ReportRunPost(reportInstanceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update customer settings
         * @param {CustomerSettingsRequest} [customerSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerPatch: function (customerSettingsRequest, options) {
            return localVarFp.apiV0SettingsCustomerPatch(customerSettingsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get customer accident sticker
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerStickerPost: function (options) {
            return localVarFp.apiV0SettingsCustomerStickerPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Change user\'s email
         * @param {ChangeEmailRequest} [changeEmailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserEmailPatch: function (changeEmailRequest, options) {
            return localVarFp.apiV0SettingsUserEmailPatch(changeEmailRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove users
         * @param {Array<UserDetails>} [userDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementDelete: function (userDetails, options) {
            return localVarFp.apiV0SettingsUserManagementDelete(userDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get users\' permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementGet: function (options) {
            return localVarFp.apiV0SettingsUserManagementGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update users\' permissions
         * @param {Array<UserDetails>} [userDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPatch: function (userDetails, options) {
            return localVarFp.apiV0SettingsUserManagementPatch(userDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new user
         * @param {Array<UserCreationData>} [userCreationData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPost: function (userCreationData, options) {
            return localVarFp.apiV0SettingsUserManagementPost(userCreationData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Change user\'s password
         * @param {ChangePasswordRequest} [changePasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPasswordPatch: function (changePasswordRequest, options) {
            return localVarFp.apiV0SettingsUserPasswordPatch(changePasswordRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request permission change
         * @param {ChangePermissionsRequest} [changePermissionsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPermissionPost: function (changePermissionsRequest, options) {
            return localVarFp.apiV0SettingsUserPermissionPost(changePermissionsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request password reset
         * @param {ResetPasswordRequest} [resetPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserResetPasswordPost: function (resetPasswordRequest, options) {
            return localVarFp.apiV0SettingsUserResetPasswordPost(resetPasswordRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of existing tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TagGet: function (options) {
            return localVarFp.apiV0TagGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user notifications
         * @param {number} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationGet: function (from, options) {
            return localVarFp.apiV0UserNotificationGet(from, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update user notification
         * @param {number} notificationId
         * @param {UserNotificationRequest} [userNotificationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationNotificationIdPatch: function (notificationId, userNotificationRequest, options) {
            return localVarFp.apiV0UserNotificationNotificationIdPatch(notificationId, userNotificationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update last seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationPatch: function (options) {
            return localVarFp.apiV0UserNotificationPatch(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Save video preview as an event
         * @param {number} previewRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestEventPreviewRequestIdPost: function (previewRequestId, options) {
            return localVarFp.apiV0VideoPreviewRequestEventPreviewRequestIdPost(previewRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get video preview request details
         * @param {number} tripId
         * @param {number} [driverTripId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestGet: function (tripId, driverTripId, options) {
            return localVarFp.apiV0VideoPreviewRequestGet(tripId, driverTripId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new video preview request
         * @param {VideoPreviewRequestBody} [videoPreviewRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestPost: function (videoPreviewRequestBody, options) {
            return localVarFp.apiV0VideoPreviewRequestPost(videoPreviewRequestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get wellness score list
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresGet: function (cache, options) {
            return localVarFp.apiV0WellnessScoresGet(cache, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get wellness score details
         * @param {string} licensePlate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresLicensePlateGet: function (licensePlate, options) {
            return localVarFp.apiV0WellnessScoresLicensePlateGet(licensePlate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add or dismiss wellness status from driver coaching session
         * @param {number} wellnessId
         * @param {CoachWellnessDetails} [coachWellnessDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessStatusWellnessIdCoachPost: function (wellnessId, coachWellnessDetails, options) {
            return localVarFp.apiV0WellnessStatusWellnessIdCoachPost(wellnessId, coachWellnessDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get driver coaching session
         * @param {string} token
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverGet: function (token, code, options) {
            return localVarFp.apiV1CoachDriverGet(token, code, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update session metadata
         * @param {string} token
         * @param {string} [code]
         * @param {CoachSessionMetadata} [coachSessionMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPatch: function (token, code, coachSessionMetadata, options) {
            return localVarFp.apiV1CoachDriverPatch(token, code, coachSessionMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Complete driver coaching session
         * @param {string} token
         * @param {string} [code]
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPost: function (token, code, updateCoachSession, options) {
            return localVarFp.apiV1CoachDriverPost(token, code, updateCoachSession, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} [driverToken]
         * @param {number} [completedFrom]
         * @param {number} [completedTo]
         * @param {number} [additionalInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachGet: function (driverToken, completedFrom, completedTo, additionalInfo, options) {
            return localVarFp.apiV1CoachGet(driverToken, completedFrom, completedTo, additionalInfo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send coaching session link by sms
         * @param {CoachSessionMessageRequest} coachSessionMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSendPost: function (coachSessionMessageRequest, options) {
            return localVarFp.apiV1CoachSendPost(coachSessionMessageRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete coaching session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdDelete: function (sessionId, options) {
            return localVarFp.apiV1CoachSessionIdDelete(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get coaching session details
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdGet: function (sessionId, options) {
            return localVarFp.apiV1CoachSessionIdGet(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Change coaching session assignee or agenda
         * @param {number} sessionId
         * @param {CoachSession} [coachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPatch: function (sessionId, coachSession, options) {
            return localVarFp.apiV1CoachSessionIdPatch(sessionId, coachSession, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of coaching sessions
         * @param {number} sessionId
         * @param {UpdateCoachSession} [updateCoachSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPost: function (sessionId, updateCoachSession, options) {
            return localVarFp.apiV1CoachSessionIdPost(sessionId, updateCoachSession, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send the driver a reminder to complete session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdRemindPost: function (sessionId, options) {
            return localVarFp.apiV1CoachSessionIdRemindPost(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Save auto-generated coaching session
         * @param {number} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdSavePost: function (sessionId, options) {
            return localVarFp.apiV1CoachSessionIdSavePost(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get coaching overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachingOverviewGet: function (options) {
            return localVarFp.apiV1CoachingOverviewGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate]
         * @param {string} [licensePlateList]
         * @param {string} [licensePlateContains]
         * @param {string} [subFleet]
         * @param {string} [subFleetList]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {string} [tripId]
         * @param {number} [lastTrip]
         * @param {string} [tripObjIn]
         * @param {string} [severity]
         * @param {string} [eventType]
         * @param {string} [eventTypeList]
         * @param {number} [lastEvent]
         * @param {string} [tag]
         * @param {string} [level]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventGet: function (licensePlate, licensePlateList, licensePlateContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, lastTrip, tripObjIn, severity, eventType, eventTypeList, lastEvent, tag, level, limit, options) {
            return localVarFp.apiV1EventGet(licensePlate, licensePlateList, licensePlateContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, lastTrip, tripObjIn, severity, eventType, eventTypeList, lastEvent, tag, level, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of policies
         * @param {string} [dateFrom]
         * @param {string} [date]
         * @param {string} [csv]
         * @param {string} [_long]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyGet: function (dateFrom, date, csv, _long, options) {
            return localVarFp.apiV1PolicyGet(dateFrom, date, csv, _long, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send list of policies
         * @param {any} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyPost: function (body, options) {
            return localVarFp.apiV1PolicyPost(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get array of trips for a vehicle
         * @param {string} licensePlate
         * @param {number} from
         * @param {number} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripGet: function (licensePlate, from, to, options) {
            return localVarFp.apiV1TripGet(licensePlate, from, to, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get trip location data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {boolean} [csv]
         * @param {string} [tripId]
         * @param {number} [snapshots]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateGet: function (licensePlate, timeFrom, timeTo, csv, tripId, snapshots, options) {
            return localVarFp.apiV1TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, snapshots, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get trip wellness data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateWellnessGet: function (licensePlate, timeFrom, timeTo, options) {
            return localVarFp.apiV1TripLicensePlateWellnessGet(licensePlate, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get users\' settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGet: function (options) {
            return localVarFp.apiV1UserGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update user\'s settings
         * @param {UserProfile} [userProfile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPatch: function (userProfile, options) {
            return localVarFp.apiV1UserPatch(userProfile, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get device details
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [status]
         * @param {string} [versionName]
         * @param {number} [cache]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, options) {
            return localVarFp.apiV2DeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get device location
         * @param {string} [licensePlate]
         * @param {string} [driverName]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [deviceId]
         * @param {string} [deviceIdContains]
         * @param {string} [subFleet]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [version]
         * @param {string} [versionName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceLocationGet: function (licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, versionName, options) {
            return localVarFp.apiV2DeviceLocationGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, versionName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate]
         * @param {string} [licensePlateList]
         * @param {string} [driverName]
         * @param {string} [driverNameList]
         * @param {string} [licensePlateContains]
         * @param {string} [driverNameContains]
         * @param {string} [subFleet]
         * @param {string} [subFleetList]
         * @param {string} [date]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {string} [tripId]
         * @param {string} [tripObjIn]
         * @param {string} [eventType]
         * @param {string} [eventTypeList]
         * @param {number} [severityFrom]
         * @param {number} [severityTo]
         * @param {string} [tag]
         * @param {string} [level]
         * @param {number} [limit]
         * @param {number} [searchAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EventGet: function (licensePlate, licensePlateList, driverName, driverNameList, licensePlateContains, driverNameContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, tripObjIn, eventType, eventTypeList, severityFrom, severityTo, tag, level, limit, searchAfter, options) {
            return localVarFp.apiV2EventGet(licensePlate, licensePlateList, driverName, driverNameList, licensePlateContains, driverNameContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, tripObjIn, eventType, eventTypeList, severityFrom, severityTo, tag, level, limit, searchAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get trip location data
         * @param {string} licensePlate
         * @param {string} [timeFrom]
         * @param {string} [timeTo]
         * @param {boolean} [csv]
         * @param {string} [tripId]
         * @param {number} [driverTripId]
         * @param {number} [snapshots]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlateGet: function (licensePlate, timeFrom, timeTo, csv, tripId, driverTripId, snapshots, options) {
            return localVarFp.apiV2TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, driverTripId, snapshots, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update trip details
         * @param {string} licensePlate
         * @param {TripUpdateRequest} [tripUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlatePost: function (licensePlate, tripUpdateRequest, options) {
            return localVarFp.apiV2TripLicensePlatePost(licensePlate, tripUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get wellness image
         * @param {string} wellnessType
         * @param {string} [wellnessId]
         * @param {number} [timestamp]
         * @param {string} [licensePlate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessImageWellnessTypeGet: function (wellnessType, wellnessId, timestamp, licensePlate, options) {
            return localVarFp.apiV2WellnessImageWellnessTypeGet(wellnessType, wellnessId, timestamp, licensePlate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Run wellness check
         * @param {RunWellnessRequest} [runWellnessRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessRunTaskPost: function (runWellnessRequest, options) {
            return localVarFp.apiV2WellnessRunTaskPost(runWellnessRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get device details
         * @param {number} [cache]
         * @param {number} [timestamp]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3DeviceGet: function (cache, timestamp, options) {
            return localVarFp.apiV3DeviceGet(cache, timestamp, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get customer drivers and home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsCustomerGet: function (options) {
            return localVarFp.hosV0SettingsCustomerGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementDelete: function (hosDriverRequest, options) {
            return localVarFp.hosV0SettingsDriverManagementDelete(hosDriverRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get hos drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementGet: function (options) {
            return localVarFp.hosV0SettingsDriverManagementGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPatch: function (hosDriverRequest, options) {
            return localVarFp.hosV0SettingsDriverManagementPatch(hosDriverRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new hos driver
         * @param {Array<HosDriverRequest>} [hosDriverRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPost: function (hosDriverRequest, options) {
            return localVarFp.hosV0SettingsDriverManagementPost(hosDriverRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove home terminals
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementDelete: function (homeTerminal, options) {
            return localVarFp.hosV0SettingsTerminalManagementDelete(homeTerminal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementGet: function (options) {
            return localVarFp.hosV0SettingsTerminalManagementGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update home terminals
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPatch: function (homeTerminal, options) {
            return localVarFp.hosV0SettingsTerminalManagementPatch(homeTerminal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new home terminal
         * @param {Array<HomeTerminal>} [homeTerminal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPost: function (homeTerminal, options) {
            return localVarFp.hosV0SettingsTerminalManagementPost(homeTerminal, options).then(function (request) { return request(axios, basePath); });
        }
    };
};
exports.ApiApiFactory = ApiApiFactory;
/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
var ApiApi = /** @class */ (function (_super) {
    __extends(ApiApi, _super);
    function ApiApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get device details
     * @param {ApiApiApiAdminDeviceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAdminDeviceGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAdminDeviceGet(requestParameters.licensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.deviceId, requestParameters.deviceIdContains, requestParameters.subFleet, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.version, requestParameters.status, requestParameters.versionName, requestParameters.cache, requestParameters.page, requestParameters.pageSize, requestParameters.country, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get device operation details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAdminDeviceOperationGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiAdminDeviceOperationGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new device operation details
     * @param {ApiApiApiAdminDeviceOperationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAdminDeviceOperationPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAdminDeviceOperationPost(requestParameters.deviceOperationData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create overlay on event video
     * @param {ApiApiApiAdminOverlayPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAdminOverlayPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAdminOverlayPost(requestParameters.eventOverlayRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary get list of all wellness details
     * @param {ApiApiApiAdminWellnessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAdminWellnessGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAdminWellnessGet(requestParameters.page, requestParameters.pageSize, requestParameters.country, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new wellness details
     * @param {ApiApiApiAdminWellnessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAdminWellnessPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAdminWellnessPost(requestParameters.wellnessUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {ApiApiApiAuthOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAuthOtpPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAuthOtpPost(requestParameters.oTPUserCredentials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {ApiApiApiAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAuthPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAuthPost(requestParameters.userCredentials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {ApiApiApiAuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiAuthRefreshPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiAuthRefreshPost(requestParameters.refreshTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get accident overview data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0AccidentOverviewGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0AccidentOverviewGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get accident overview data
     * @param {ApiApiApiV0AccidentOverviewTimestampGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0AccidentOverviewTimestampGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0AccidentOverviewTimestampGet(requestParameters.timestamp, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send ICE candidate from browser to device
     * @param {ApiApiApiV0BrowserStreamSessionIdIcePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0BrowserStreamSessionIdIcePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0BrowserStreamSessionIdIcePost(requestParameters.sessionId, requestParameters.browserStreamIceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Poll for messages from device to browser (keep-alive)
     * @param {ApiApiApiV0BrowserStreamSessionIdMessagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0BrowserStreamSessionIdMessagesGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0BrowserStreamSessionIdMessagesGet(requestParameters.sessionId, requestParameters.after, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send WebRTC offer (SDP) from browser to device
     * @param {ApiApiApiV0BrowserStreamSessionIdOfferPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0BrowserStreamSessionIdOfferPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0BrowserStreamSessionIdOfferPost(requestParameters.sessionId, requestParameters.browserStreamOfferRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get event details
     * @summary Get event details
     * @param {ApiApiApiV0CoachEventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachEventEventIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachEventEventIdGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get coaching event image
     * @param {ApiApiApiV0CoachEventEventIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachEventEventIdImageGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachEventEventIdImageGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get event coaching status
     * @param {ApiApiApiV0CoachEventPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachEventPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachEventPost(requestParameters.coachEventStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metrics data
     * @param {ApiApiApiV0CoachMetricsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachMetricsGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachMetricsGet(requestParameters.driverToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new coaching metrics by driver token
     * @param {ApiApiApiV0CoachMetricsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachMetricsPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachMetricsPost(requestParameters.coachMetricsSaveRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete event from coaching session
     * @param {ApiApiApiV0CoachSessionIdEventItemIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdEventItemIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdEventItemIdDelete(requestParameters.sessionId, requestParameters.itemId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update event in coaching session
     * @param {ApiApiApiV0CoachSessionIdEventItemIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdEventItemIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdEventItemIdPatch(requestParameters.sessionId, requestParameters.itemId, requestParameters.updateCoachEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get coaching session details
     * @param {ApiApiApiV0CoachSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdGet(requestParameters.sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get coaching session image
     * @param {ApiApiApiV0CoachSessionIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdImageGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdImageGet(requestParameters.sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete coach media file
     * @param {ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(requestParameters.sessionId, requestParameters.coachMediaFileId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update coach media file
     * @param {ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(requestParameters.sessionId, requestParameters.coachMediaFileId, requestParameters.coachMediaFileRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new coach media file
     * @param {ApiApiApiV0CoachSessionIdMediaFilePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdMediaFilePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdMediaFilePost(requestParameters.sessionId, requestParameters.coachMediaFileRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete coach metrics
     * @param {ApiApiApiV0CoachSessionIdMetricsMetricsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdMetricsMetricsIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdMetricsMetricsIdDelete(requestParameters.sessionId, requestParameters.metricsId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update coach metrics
     * @param {ApiApiApiV0CoachSessionIdMetricsMetricsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdMetricsMetricsIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdMetricsMetricsIdPatch(requestParameters.sessionId, requestParameters.metricsId, requestParameters.coachMetrics, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new coaching metrics
     * @param {ApiApiApiV0CoachSessionIdMetricsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdMetricsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdMetricsPost(requestParameters.sessionId, requestParameters.coachMetricsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete manager notes
     * @param {ApiApiApiV0CoachSessionIdNotesNoteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdNotesNoteIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdNotesNoteIdDelete(requestParameters.sessionId, requestParameters.noteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update manager notes
     * @param {ApiApiApiV0CoachSessionIdNotesNoteIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdNotesNoteIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdNotesNoteIdPatch(requestParameters.sessionId, requestParameters.noteId, requestParameters.coachManagerNotes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new manager notes
     * @param {ApiApiApiV0CoachSessionIdNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdNotesPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdNotesPost(requestParameters.sessionId, requestParameters.managerNotesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of coaching sessions
     * @param {ApiApiApiV0CoachSessionIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdPost(requestParameters.sessionId, requestParameters.updateCoachSession, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new driver response
     * @param {ApiApiApiV0CoachSessionIdResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdResponsePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdResponsePost(requestParameters.sessionId, requestParameters.driverResponseRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete driver response
     * @param {ApiApiApiV0CoachSessionIdResponseResponseIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdResponseResponseIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdResponseResponseIdDelete(requestParameters.sessionId, requestParameters.responseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update driver response
     * @param {ApiApiApiV0CoachSessionIdResponseResponseIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdResponseResponseIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdResponseResponseIdPatch(requestParameters.sessionId, requestParameters.responseId, requestParameters.coachDriverResponse, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Remove wellness status from driver coaching session
     * @param {ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdWellnessStatusWellnessIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdWellnessStatusWellnessIdDelete(requestParameters.sessionId, requestParameters.wellnessId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update wellness status from driver coaching session
     * @param {ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CoachSessionIdWellnessStatusWellnessIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CoachSessionIdWellnessStatusWellnessIdPatch(requestParameters.sessionId, requestParameters.wellnessId, requestParameters.updateCoachWellnessStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get clip from device
     * @summary Get clip from device
     * @param {ApiApiApiV0CommandCommandIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CommandCommandIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CommandCommandIdGet(requestParameters.commandId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update remote command description
     * @summary Update remote command
     * @param {ApiApiApiV0CommandCommandIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CommandCommandIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CommandCommandIdPatch(requestParameters.commandId, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create remote command
     * @summary Create remote command
     * @param {ApiApiApiV0CommandCommandIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CommandCommandIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CommandCommandIdPost(requestParameters.commandId, requestParameters.remoteCommand, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of remote commands (defaults to get_clip)
     * @summary Get list of remote commands
     * @param {ApiApiApiV0CommandGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CommandGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0CommandGet(requestParameters.timeFrom, requestParameters.timeTo, requestParameters.command, requestParameters.accident, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get clip from device
     * @summary Get clip from device
     * @param {ApiApiApiV0CommandPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CommandPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0CommandPost(requestParameters.command, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove customer sub fleet
     * @param {ApiApiApiV0CustomerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CustomerDelete = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0CustomerDelete(requestParameters.customerSubFleetData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get customer details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CustomerGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CustomerGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new customer sub fleet
     * @param {ApiApiApiV0CustomerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CustomerPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0CustomerPost(requestParameters.customerSubFleetData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns S3 object keys directly under the authenticated customer prefix in the uniform-wellness export bucket (non-recursive). Requires get_clip permissions; customer must be in SSM allowlist UNIFORM_WELLNESS_IMAGES_CUSTOMERS (else 403).
     * @summary List uniform wellness image keys under the customer prefix
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CustomerUniformWellnessImagesGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CustomerUniformWellnessImagesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists objects under {customer_name}/{since} in the export bucket and returns presigned download URLs. Same access rules as GET /api/v0/customer/uniform_wellness_images.
     * @summary List presigned URLs for uniform wellness images under a sub-prefix
     * @param {ApiApiApiV0CustomerUniformWellnessImagesSinceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0CustomerUniformWellnessImagesSinceGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0CustomerUniformWellnessImagesSinceGet(requestParameters.since, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get daily dashboard issues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DailyDashboardGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DailyDashboardGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get device snapshot
     * @param {ApiApiApiV0DeviceDeviceIdSnapshotGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DeviceDeviceIdSnapshotGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DeviceDeviceIdSnapshotGet(requestParameters.deviceId, requestParameters.timestamp, requestParameters.since, requestParameters.exact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get device location
     * @param {ApiApiApiV0DeviceLocateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DeviceLocateGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0DeviceLocateGet(requestParameters.timeFrom, requestParameters.timeTo, requestParameters.latitude, requestParameters.longitude, requestParameters.radius, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update device details
     * @param {ApiApiApiV0DeviceUpdatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DeviceUpdatePatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0DeviceUpdatePatch(requestParameters.deviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get driver badge
     * @param {ApiApiApiV0DriverBadgeDriverTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverBadgeDriverTokenGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverBadgeDriverTokenGet(requestParameters.driverToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get driver badges
     * @param {ApiApiApiV0DriverBadgePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverBadgePost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverBadgePost(requestParameters.driverBadgeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get driver details
     * @param {ApiApiApiV0DriverDriverTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverDriverTokenGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverDriverTokenGet(requestParameters.driverToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update driver details
     * @param {ApiApiApiV0DriverDriverTokenPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverDriverTokenPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverDriverTokenPatch(requestParameters.driverToken, requestParameters.fleetDriverRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update multiple drivers
     * @param {ApiApiApiV0DriverPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverPatch(requestParameters.fleetDriverList, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new driver
     * @param {ApiApiApiV0DriverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverPost(requestParameters.fleetDriverRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * recalculate driver score
     * @param {ApiApiApiV0DriverScoresDriverTokenCalculatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverScoresDriverTokenCalculatePatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverScoresDriverTokenCalculatePatch(requestParameters.driverToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get driver score with relevant events
     * @param {ApiApiApiV0DriverScoresDriverTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverScoresDriverTokenGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverScoresDriverTokenGet(requestParameters.driverToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get driver scores
     * @param {ApiApiApiV0DriverScoresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0DriverScoresGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0DriverScoresGet(requestParameters.allDrivers, requestParameters.page, requestParameters.cache, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new event from existing one
     * @param {ApiApiApiV0EventEventIdClonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdClonePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdClonePost(requestParameters.eventId, requestParameters.cloneEventDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get event coaching data
     * @param {ApiApiApiV0EventEventIdCoachGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdCoachGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdCoachGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add or dismiss event from driver coaching session
     * @param {ApiApiApiV0EventEventIdCoachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdCoachPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdCoachPost(requestParameters.eventId, requestParameters.coachEventDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Download event video request
     * @param {ApiApiApiV0EventEventIdDownloadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdDownloadPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdDownloadPost(requestParameters.eventId, requestParameters.downloadVideoEventRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get event details
     * @summary Get event details
     * @param {ApiApiApiV0EventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdGet(requestParameters.eventId, requestParameters.bucket, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get event image
     * @param {ApiApiApiV0EventEventIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdImageGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdImageGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update event details
     * @param {ApiApiApiV0EventEventIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdPatch(requestParameters.eventId, requestParameters.inlineObject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get related events
     * @param {ApiApiApiV0EventEventIdRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdRelatedGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdRelatedGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send event
     * @param {ApiApiApiV0EventEventIdSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdSendPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdSendPost(requestParameters.eventId, requestParameters.sendEventRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Change event tags
     * @summary Change event tags
     * @param {ApiApiApiV0EventEventIdTagPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0EventEventIdTagPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0EventEventIdTagPost(requestParameters.eventId, requestParameters.eventTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add comment to feed event
     * @summary Add comment
     * @param {ApiApiApiV0FeedEventIdCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FeedEventIdCommentPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0FeedEventIdCommentPost(requestParameters.eventId, requestParameters.feedCommentRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add or remove dislike from event
     * @summary Dislike event
     * @param {ApiApiApiV0FeedEventIdDislikePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FeedEventIdDislikePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0FeedEventIdDislikePost(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get feed event
     * @summary Get feed event
     * @param {ApiApiApiV0FeedEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FeedEventIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0FeedEventIdGet(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add or remove like from event
     * @summary Like event
     * @param {ApiApiApiV0FeedEventIdLikePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FeedEventIdLikePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0FeedEventIdLikePost(requestParameters.eventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update percent watched
     * @summary Update percent watched
     * @param {ApiApiApiV0FeedEventIdWatchedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FeedEventIdWatchedPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0FeedEventIdWatchedPost(requestParameters.eventId, requestParameters.eventWatchedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get events
     * @summary Get user feed
     * @param {ApiApiApiV0FeedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FeedGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0FeedGet(requestParameters.generatedAt, requestParameters.size, requestParameters.fromEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get sms with link to feed page
     * @summary Get sms with link to feed page
     * @param {ApiApiApiV0FeedLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FeedLinkPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0FeedLinkPost(requestParameters.feedLinkRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get fleet safety scores
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FleetSafetyScoresGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0FleetSafetyScoresGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get fleet score and fleet metric data
     * @param {ApiApiApiV0FleetScoreGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FleetScoreGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0FleetScoreGet(requestParameters.cache, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get fleet scores and score distribution over time
     * @param {ApiApiApiV0FleetScoreTrendGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FleetScoreTrendGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0FleetScoreTrendGet(requestParameters.cache, requestParameters.endDate, requestParameters.daysCount, requestParameters.daysInterval, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get top and bottom drivers for the latest timestamp for each fleet
     * @param {ApiApiApiV0FleetTopBottomDriversGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0FleetTopBottomDriversGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0FleetTopBottomDriversGet(requestParameters.cache, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a geofence
     * @param {ApiApiApiV0GeofenceGeofenceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0GeofenceGeofenceIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0GeofenceGeofenceIdDelete(requestParameters.geofenceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a geofence
     * @param {ApiApiApiV0GeofenceGeofenceIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0GeofenceGeofenceIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0GeofenceGeofenceIdPatch(requestParameters.geofenceId, requestParameters.geofence, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get geofence details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0GeofenceGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0GeofenceGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new geofence
     * @param {ApiApiApiV0GeofencePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0GeofencePost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0GeofencePost(requestParameters.geofence, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get help videos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0HelpGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0HelpGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get aggregated data of malfunctions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionAggregatedGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionAggregatedGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get malfunction list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create guest technician
     * @param {ApiApiApiV0MalfunctionGuestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionGuestPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionGuestPost(requestParameters.guestTechnicianRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get malfunction comments
     * @param {ApiApiApiV0MalfunctionMalfunctionIdCommentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionMalfunctionIdCommentGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionMalfunctionIdCommentGet(requestParameters.malfunctionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add new comment to malfunction
     * @param {ApiApiApiV0MalfunctionMalfunctionIdCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionMalfunctionIdCommentPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionMalfunctionIdCommentPost(requestParameters.malfunctionId, requestParameters.malfunctionCommentRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get malfunction image
     * @param {ApiApiApiV0MalfunctionMalfunctionIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionMalfunctionIdImageGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionMalfunctionIdImageGet(requestParameters.malfunctionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update malfunction assignee
     * @param {ApiApiApiV0MalfunctionPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionPatch(requestParameters.malfunctionAssigneeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Sync malfunctions with policies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MalfunctionUpdateGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MalfunctionUpdateGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get media file library
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MediaFilesGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MediaFilesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete media file
     * @param {ApiApiApiV0MediaFilesMediaFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MediaFilesMediaFileIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MediaFilesMediaFileIdDelete(requestParameters.mediaFileId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get signed url for media file
     * @summary Get signed url for media file
     * @param {ApiApiApiV0MediaFilesMediaFileIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MediaFilesMediaFileIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MediaFilesMediaFileIdGet(requestParameters.mediaFileId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update media file
     * @param {ApiApiApiV0MediaFilesMediaFileIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MediaFilesMediaFileIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0MediaFilesMediaFileIdPatch(requestParameters.mediaFileId, requestParameters.mediaFile, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get file upload url
     * @param {ApiApiApiV0MediaFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MediaFilesPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0MediaFilesPost(requestParameters.uploadMediaFileRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add media file to database
     * @param {ApiApiApiV0MediaFilesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0MediaFilesPut = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0MediaFilesPut(requestParameters.mediaFileRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new NPS
     * @param {ApiApiApiV0NpsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0NpsPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0NpsPost(requestParameters.nps, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove package to device list
     * @param {ApiApiApiV0PackageDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PackageDelete = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0PackageDelete(requestParameters.packageTrackerData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove file from package
     * @param {ApiApiApiV0PackagePackageIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PackagePackageIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0PackagePackageIdDelete(requestParameters.packageId, requestParameters.fileData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get file upload data
     * @param {ApiApiApiV0PackagePackageIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PackagePackageIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0PackagePackageIdPost(requestParameters.packageId, requestParameters.fileData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add file to existing package
     * @param {ApiApiApiV0PackagePackageIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PackagePackageIdPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0PackagePackageIdPut(requestParameters.packageId, requestParameters.fileData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new package
     * @param {ApiApiApiV0PackagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PackagePost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0PackagePost(requestParameters.packageName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Attach package to device list
     * @param {ApiApiApiV0PackagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PackagePut = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0PackagePut(requestParameters.packageTrackerData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get premium optimization details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PremiumOptimizationGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0PremiumOptimizationGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new premium optimization details
     * @param {ApiApiApiV0PremiumOptimizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PremiumOptimizationPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0PremiumOptimizationPost(requestParameters.premiumOptimizationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send reminder
     * @param {ApiApiApiV0PremiumOptimizationReminderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0PremiumOptimizationReminderPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0PremiumOptimizationReminderPost(requestParameters.premiumOptimizationReminderRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get release notes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReleaseNotesGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReleaseNotesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of reports and alerts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary create new report or alert
     * @param {ApiApiApiV0ReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportPost(requestParameters.alertOrReport, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary create new report or alert
     * @param {ApiApiApiV0ReportReportIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportReportIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportReportIdDelete(requestParameters.reportId, requestParameters.alertOrReport, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update report or alert
     * @param {ApiApiApiV0ReportReportIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportReportIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportReportIdPatch(requestParameters.reportId, requestParameters.alertOrReport, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of report instances
     * @param {ApiApiApiV0ReportRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportRunGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportRunGet(requestParameters.reportType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get report instance
     * @param {ApiApiApiV0ReportRunInstanceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportRunInstanceIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportRunInstanceIdGet(requestParameters.instanceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update report instance
     * @param {ApiApiApiV0ReportRunInstanceIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportRunInstanceIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportRunInstanceIdPatch(requestParameters.instanceId, requestParameters.reportInstanceUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send report
     * @param {ApiApiApiV0ReportRunInstanceIdSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportRunInstanceIdSendPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportRunInstanceIdSendPost(requestParameters.instanceId, requestParameters.sendReportRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate report
     * @param {ApiApiApiV0ReportRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0ReportRunPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0ReportRunPost(requestParameters.reportInstanceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update customer settings
     * @param {ApiApiApiV0SettingsCustomerPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsCustomerPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsCustomerPatch(requestParameters.customerSettingsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get customer accident sticker
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsCustomerStickerPost = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsCustomerStickerPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Change user\'s email
     * @param {ApiApiApiV0SettingsUserEmailPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserEmailPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserEmailPatch(requestParameters.changeEmailRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove users
     * @param {ApiApiApiV0SettingsUserManagementDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserManagementDelete = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserManagementDelete(requestParameters.userDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get users\' permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserManagementGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserManagementGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update users\' permissions
     * @param {ApiApiApiV0SettingsUserManagementPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserManagementPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserManagementPatch(requestParameters.userDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new user
     * @param {ApiApiApiV0SettingsUserManagementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserManagementPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserManagementPost(requestParameters.userCreationData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Change user\'s password
     * @param {ApiApiApiV0SettingsUserPasswordPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserPasswordPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserPasswordPatch(requestParameters.changePasswordRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request permission change
     * @param {ApiApiApiV0SettingsUserPermissionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserPermissionPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserPermissionPost(requestParameters.changePermissionsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request password reset
     * @param {ApiApiApiV0SettingsUserResetPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0SettingsUserResetPasswordPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0SettingsUserResetPasswordPost(requestParameters.resetPasswordRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of existing tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0TagGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0TagGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user notifications
     * @param {ApiApiApiV0UserNotificationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0UserNotificationGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0UserNotificationGet(requestParameters.from, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update user notification
     * @param {ApiApiApiV0UserNotificationNotificationIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0UserNotificationNotificationIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0UserNotificationNotificationIdPatch(requestParameters.notificationId, requestParameters.userNotificationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update last seen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0UserNotificationPatch = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0UserNotificationPatch(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Save video preview as an event
     * @param {ApiApiApiV0VideoPreviewRequestEventPreviewRequestIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0VideoPreviewRequestEventPreviewRequestIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0VideoPreviewRequestEventPreviewRequestIdPost(requestParameters.previewRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get video preview request details
     * @param {ApiApiApiV0VideoPreviewRequestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0VideoPreviewRequestGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0VideoPreviewRequestGet(requestParameters.tripId, requestParameters.driverTripId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new video preview request
     * @param {ApiApiApiV0VideoPreviewRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0VideoPreviewRequestPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0VideoPreviewRequestPost(requestParameters.videoPreviewRequestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get wellness score list
     * @param {ApiApiApiV0WellnessScoresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0WellnessScoresGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV0WellnessScoresGet(requestParameters.cache, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get wellness score details
     * @param {ApiApiApiV0WellnessScoresLicensePlateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0WellnessScoresLicensePlateGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0WellnessScoresLicensePlateGet(requestParameters.licensePlate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add or dismiss wellness status from driver coaching session
     * @param {ApiApiApiV0WellnessStatusWellnessIdCoachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV0WellnessStatusWellnessIdCoachPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV0WellnessStatusWellnessIdCoachPost(requestParameters.wellnessId, requestParameters.coachWellnessDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get driver coaching session
     * @param {ApiApiApiV1CoachDriverGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachDriverGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachDriverGet(requestParameters.token, requestParameters.code, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update session metadata
     * @param {ApiApiApiV1CoachDriverPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachDriverPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachDriverPatch(requestParameters.token, requestParameters.code, requestParameters.coachSessionMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Complete driver coaching session
     * @param {ApiApiApiV1CoachDriverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachDriverPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachDriverPost(requestParameters.token, requestParameters.code, requestParameters.updateCoachSession, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of coaching sessions
     * @param {ApiApiApiV1CoachGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachGet(requestParameters.driverToken, requestParameters.completedFrom, requestParameters.completedTo, requestParameters.additionalInfo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send coaching session link by sms
     * @param {ApiApiApiV1CoachSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachSendPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachSendPost(requestParameters.coachSessionMessageRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete coaching session
     * @param {ApiApiApiV1CoachSessionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachSessionIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachSessionIdDelete(requestParameters.sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get coaching session details
     * @param {ApiApiApiV1CoachSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachSessionIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachSessionIdGet(requestParameters.sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Change coaching session assignee or agenda
     * @param {ApiApiApiV1CoachSessionIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachSessionIdPatch = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachSessionIdPatch(requestParameters.sessionId, requestParameters.coachSession, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of coaching sessions
     * @param {ApiApiApiV1CoachSessionIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachSessionIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachSessionIdPost(requestParameters.sessionId, requestParameters.updateCoachSession, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send the driver a reminder to complete session
     * @param {ApiApiApiV1CoachSessionIdRemindPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachSessionIdRemindPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachSessionIdRemindPost(requestParameters.sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Save auto-generated coaching session
     * @param {ApiApiApiV1CoachSessionIdSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachSessionIdSavePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachSessionIdSavePost(requestParameters.sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get coaching overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1CoachingOverviewGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1CoachingOverviewGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get events
     * @summary Get events
     * @param {ApiApiApiV1EventGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1EventGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV1EventGet(requestParameters.licensePlate, requestParameters.licensePlateList, requestParameters.licensePlateContains, requestParameters.subFleet, requestParameters.subFleetList, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.tripId, requestParameters.lastTrip, requestParameters.tripObjIn, requestParameters.severity, requestParameters.eventType, requestParameters.eventTypeList, requestParameters.lastEvent, requestParameters.tag, requestParameters.level, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of policies
     * @param {ApiApiApiV1PolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1PolicyGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV1PolicyGet(requestParameters.dateFrom, requestParameters.date, requestParameters.csv, requestParameters._long, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send list of policies
     * @param {ApiApiApiV1PolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1PolicyPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV1PolicyPost(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get array of trips for a vehicle
     * @param {ApiApiApiV1TripGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1TripGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1TripGet(requestParameters.licensePlate, requestParameters.from, requestParameters.to, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get trip location data
     * @param {ApiApiApiV1TripLicensePlateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1TripLicensePlateGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1TripLicensePlateGet(requestParameters.licensePlate, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.csv, requestParameters.tripId, requestParameters.snapshots, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get trip wellness data
     * @param {ApiApiApiV1TripLicensePlateWellnessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1TripLicensePlateWellnessGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1TripLicensePlateWellnessGet(requestParameters.licensePlate, requestParameters.timeFrom, requestParameters.timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get users\' settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1UserGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV1UserGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update user\'s settings
     * @param {ApiApiApiV1UserPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV1UserPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV1UserPatch(requestParameters.userProfile, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get device details
     * @param {ApiApiApiV2DeviceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV2DeviceGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV2DeviceGet(requestParameters.licensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.deviceId, requestParameters.deviceIdContains, requestParameters.subFleet, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.version, requestParameters.status, requestParameters.versionName, requestParameters.cache, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get device location
     * @param {ApiApiApiV2DeviceLocationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV2DeviceLocationGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV2DeviceLocationGet(requestParameters.licensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.deviceId, requestParameters.deviceIdContains, requestParameters.subFleet, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.version, requestParameters.versionName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get events
     * @summary Get events
     * @param {ApiApiApiV2EventGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV2EventGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV2EventGet(requestParameters.licensePlate, requestParameters.licensePlateList, requestParameters.driverName, requestParameters.driverNameList, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.subFleet, requestParameters.subFleetList, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.tripId, requestParameters.tripObjIn, requestParameters.eventType, requestParameters.eventTypeList, requestParameters.severityFrom, requestParameters.severityTo, requestParameters.tag, requestParameters.level, requestParameters.limit, requestParameters.searchAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get trip location data
     * @param {ApiApiApiV2TripLicensePlateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV2TripLicensePlateGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV2TripLicensePlateGet(requestParameters.licensePlate, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.csv, requestParameters.tripId, requestParameters.driverTripId, requestParameters.snapshots, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update trip details
     * @param {ApiApiApiV2TripLicensePlatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV2TripLicensePlatePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV2TripLicensePlatePost(requestParameters.licensePlate, requestParameters.tripUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get wellness image
     * @param {ApiApiApiV2WellnessImageWellnessTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV2WellnessImageWellnessTypeGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiV2WellnessImageWellnessTypeGet(requestParameters.wellnessType, requestParameters.wellnessId, requestParameters.timestamp, requestParameters.licensePlate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Run wellness check
     * @param {ApiApiApiV2WellnessRunTaskPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV2WellnessRunTaskPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV2WellnessRunTaskPost(requestParameters.runWellnessRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get device details
     * @param {ApiApiApiV3DeviceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiV3DeviceGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).apiV3DeviceGet(requestParameters.cache, requestParameters.timestamp, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get customer drivers and home terminals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsCustomerGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsCustomerGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove hos drivers
     * @param {ApiApiHosV0SettingsDriverManagementDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsDriverManagementDelete = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsDriverManagementDelete(requestParameters.hosDriverRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get hos drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsDriverManagementGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsDriverManagementGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update hos drivers
     * @param {ApiApiHosV0SettingsDriverManagementPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsDriverManagementPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsDriverManagementPatch(requestParameters.hosDriverRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new hos driver
     * @param {ApiApiHosV0SettingsDriverManagementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsDriverManagementPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsDriverManagementPost(requestParameters.hosDriverRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove home terminals
     * @param {ApiApiHosV0SettingsTerminalManagementDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsTerminalManagementDelete = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsTerminalManagementDelete(requestParameters.homeTerminal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get home terminals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsTerminalManagementGet = function (options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsTerminalManagementGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update home terminals
     * @param {ApiApiHosV0SettingsTerminalManagementPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsTerminalManagementPatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsTerminalManagementPatch(requestParameters.homeTerminal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new home terminal
     * @param {ApiApiHosV0SettingsTerminalManagementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.hosV0SettingsTerminalManagementPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ApiApiFp)(this.configuration).hosV0SettingsTerminalManagementPost(requestParameters.homeTerminal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApiApi;
}(base_1.BaseAPI));
exports.ApiApi = ApiApi;
/**
 * ControlApi - axios parameter creator
 * @export
 */
var ControlApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Clean device VSC configuration
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdCleanVscPost: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('controlV0ConfigStatusDeviceIdCleanVscPost', 'deviceId', deviceId);
                    localVarPath = "/control/v0/config_status/{deviceId}/clean_vsc"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Resend failed device configuration
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdResendPost: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('controlV0ConfigStatusDeviceIdResendPost', 'deviceId', deviceId);
                    localVarPath = "/control/v0/config_status/{deviceId}/resend"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all config status
         * @param {string} [customer]
         * @param {string} [deviceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusGet: function (customer, deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/config_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (customer !== undefined) {
                        localVarQueryParameter['customer'] = customer;
                    }
                    if (deviceId !== undefined) {
                        localVarQueryParameter['device_id'] = deviceId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns a list of event type names that can be customized per customer. These are the keys from DEFAULT_CONFIGURABLE_EVENT_SETTINGS.
         * @summary Get list of configurable event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigurableEventsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/configurable_events";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get customer config
         * @param {string} customerName
         * @param {string} subFleetName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigCustomerNameSubFleetNameGet: function (customerName, subFleetName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'customerName' is not null or undefined
                    (0, common_1.assertParamExists)('controlV0CustomerConfigCustomerNameSubFleetNameGet', 'customerName', customerName);
                    // verify required parameter 'subFleetName' is not null or undefined
                    (0, common_1.assertParamExists)('controlV0CustomerConfigCustomerNameSubFleetNameGet', 'subFleetName', subFleetName);
                    localVarPath = "/control/v0/customer_config/{customerName}/{subFleetName}"
                        .replace("{".concat("customerName", "}"), encodeURIComponent(String(customerName)))
                        .replace("{".concat("subFleetName", "}"), encodeURIComponent(String(subFleetName)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all customer config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/customer_config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Change customer config
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/customer_config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all event settings groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0EventSettingsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/event_settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create or update event settings group
         * @param {EventSettingsGroupRequest} [eventSettingsGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0EventSettingsPost: function (eventSettingsGroupRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/event_settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventSettingsGroupRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all experiment config
         * @param {number} experimentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdGet: function (experimentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'experimentId' is not null or undefined
                    (0, common_1.assertParamExists)('controlV0ExperimentConfigExperimentIdGet', 'experimentId', experimentId);
                    localVarPath = "/control/v0/experiment_config/{ExperimentId}"
                        .replace("{".concat("ExperimentId", "}"), encodeURIComponent(String(experimentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Change experiment config
         * @param {number} experimentId
         * @param {ExperimentDeviceRequest} [experimentDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdPost: function (experimentId, experimentDeviceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'experimentId' is not null or undefined
                    (0, common_1.assertParamExists)('controlV0ExperimentConfigExperimentIdPost', 'experimentId', experimentId);
                    localVarPath = "/control/v0/experiment_config/{ExperimentId}"
                        .replace("{".concat("ExperimentId", "}"), encodeURIComponent(String(experimentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(experimentDeviceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all experiment config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/experiment_config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get all overlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/control/v0/overlay";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary change an overlay
         * @param {number} overlayId
         * @param {OverlayRequest} [overlayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayOverlayIdPost: function (overlayId, overlayRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'overlayId' is not null or undefined
                    (0, common_1.assertParamExists)('controlV0OverlayOverlayIdPost', 'overlayId', overlayId);
                    localVarPath = "/control/v0/overlay/{overlayId}"
                        .replace("{".concat("overlayId", "}"), encodeURIComponent(String(overlayId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(overlayRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        }
    };
};
exports.ControlApiAxiosParamCreator = ControlApiAxiosParamCreator;
/**
 * ControlApi - functional programming interface
 * @export
 */
var ControlApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ControlApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Clean device VSC configuration
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdCleanVscPost: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0ConfigStatusDeviceIdCleanVscPost(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Resend failed device configuration
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdResendPost: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0ConfigStatusDeviceIdResendPost(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all config status
         * @param {string} [customer]
         * @param {string} [deviceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusGet: function (customer, deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0ConfigStatusGet(customer, deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of event type names that can be customized per customer. These are the keys from DEFAULT_CONFIGURABLE_EVENT_SETTINGS.
         * @summary Get list of configurable event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigurableEventsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0ConfigurableEventsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get customer config
         * @param {string} customerName
         * @param {string} subFleetName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigCustomerNameSubFleetNameGet: function (customerName, subFleetName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0CustomerConfigCustomerNameSubFleetNameGet(customerName, subFleetName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all customer config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0CustomerConfigGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Change customer config
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0CustomerConfigPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all event settings groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0EventSettingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0EventSettingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create or update event settings group
         * @param {EventSettingsGroupRequest} [eventSettingsGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0EventSettingsPost: function (eventSettingsGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0EventSettingsPost(eventSettingsGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all experiment config
         * @param {number} experimentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdGet: function (experimentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0ExperimentConfigExperimentIdGet(experimentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Change experiment config
         * @param {number} experimentId
         * @param {ExperimentDeviceRequest} [experimentDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdPost: function (experimentId, experimentDeviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0ExperimentConfigExperimentIdPost(experimentId, experimentDeviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all experiment config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0ExperimentConfigGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all overlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0OverlayGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary change an overlay
         * @param {number} overlayId
         * @param {OverlayRequest} [overlayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayOverlayIdPost: function (overlayId, overlayRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.controlV0OverlayOverlayIdPost(overlayId, overlayRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
exports.ControlApiFp = ControlApiFp;
/**
 * ControlApi - factory interface
 * @export
 */
var ControlApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ControlApiFp)(configuration);
    return {
        /**
         *
         * @summary Clean device VSC configuration
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdCleanVscPost: function (deviceId, options) {
            return localVarFp.controlV0ConfigStatusDeviceIdCleanVscPost(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Resend failed device configuration
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdResendPost: function (deviceId, options) {
            return localVarFp.controlV0ConfigStatusDeviceIdResendPost(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all config status
         * @param {string} [customer]
         * @param {string} [deviceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusGet: function (customer, deviceId, options) {
            return localVarFp.controlV0ConfigStatusGet(customer, deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of event type names that can be customized per customer. These are the keys from DEFAULT_CONFIGURABLE_EVENT_SETTINGS.
         * @summary Get list of configurable event types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigurableEventsGet: function (options) {
            return localVarFp.controlV0ConfigurableEventsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get customer config
         * @param {string} customerName
         * @param {string} subFleetName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigCustomerNameSubFleetNameGet: function (customerName, subFleetName, options) {
            return localVarFp.controlV0CustomerConfigCustomerNameSubFleetNameGet(customerName, subFleetName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all customer config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigGet: function (options) {
            return localVarFp.controlV0CustomerConfigGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Change customer config
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigPost: function (body, options) {
            return localVarFp.controlV0CustomerConfigPost(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all event settings groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0EventSettingsGet: function (options) {
            return localVarFp.controlV0EventSettingsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create or update event settings group
         * @param {EventSettingsGroupRequest} [eventSettingsGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0EventSettingsPost: function (eventSettingsGroupRequest, options) {
            return localVarFp.controlV0EventSettingsPost(eventSettingsGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all experiment config
         * @param {number} experimentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdGet: function (experimentId, options) {
            return localVarFp.controlV0ExperimentConfigExperimentIdGet(experimentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Change experiment config
         * @param {number} experimentId
         * @param {ExperimentDeviceRequest} [experimentDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdPost: function (experimentId, experimentDeviceRequest, options) {
            return localVarFp.controlV0ExperimentConfigExperimentIdPost(experimentId, experimentDeviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all experiment config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigGet: function (options) {
            return localVarFp.controlV0ExperimentConfigGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all overlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayGet: function (options) {
            return localVarFp.controlV0OverlayGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary change an overlay
         * @param {number} overlayId
         * @param {OverlayRequest} [overlayRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayOverlayIdPost: function (overlayId, overlayRequest, options) {
            return localVarFp.controlV0OverlayOverlayIdPost(overlayId, overlayRequest, options).then(function (request) { return request(axios, basePath); });
        }
    };
};
exports.ControlApiFactory = ControlApiFactory;
/**
 * ControlApi - object-oriented interface
 * @export
 * @class ControlApi
 * @extends {BaseAPI}
 */
var ControlApi = /** @class */ (function (_super) {
    __extends(ControlApi, _super);
    function ControlApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Clean device VSC configuration
     * @param {ControlApiControlV0ConfigStatusDeviceIdCleanVscPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0ConfigStatusDeviceIdCleanVscPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0ConfigStatusDeviceIdCleanVscPost(requestParameters.deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Resend failed device configuration
     * @param {ControlApiControlV0ConfigStatusDeviceIdResendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0ConfigStatusDeviceIdResendPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0ConfigStatusDeviceIdResendPost(requestParameters.deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all config status
     * @param {ControlApiControlV0ConfigStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0ConfigStatusGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ControlApiFp)(this.configuration).controlV0ConfigStatusGet(requestParameters.customer, requestParameters.deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of event type names that can be customized per customer. These are the keys from DEFAULT_CONFIGURABLE_EVENT_SETTINGS.
     * @summary Get list of configurable event types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0ConfigurableEventsGet = function (options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0ConfigurableEventsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get customer config
     * @param {ControlApiControlV0CustomerConfigCustomerNameSubFleetNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0CustomerConfigCustomerNameSubFleetNameGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0CustomerConfigCustomerNameSubFleetNameGet(requestParameters.customerName, requestParameters.subFleetName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all customer config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0CustomerConfigGet = function (options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0CustomerConfigGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Change customer config
     * @param {ControlApiControlV0CustomerConfigPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0CustomerConfigPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ControlApiFp)(this.configuration).controlV0CustomerConfigPost(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all event settings groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0EventSettingsGet = function (options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0EventSettingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create or update event settings group
     * @param {ControlApiControlV0EventSettingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0EventSettingsPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ControlApiFp)(this.configuration).controlV0EventSettingsPost(requestParameters.eventSettingsGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all experiment config
     * @param {ControlApiControlV0ExperimentConfigExperimentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0ExperimentConfigExperimentIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0ExperimentConfigExperimentIdGet(requestParameters.experimentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Change experiment config
     * @param {ControlApiControlV0ExperimentConfigExperimentIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0ExperimentConfigExperimentIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0ExperimentConfigExperimentIdPost(requestParameters.experimentId, requestParameters.experimentDeviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all experiment config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0ExperimentConfigGet = function (options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0ExperimentConfigGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all overlays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0OverlayGet = function (options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0OverlayGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary change an overlay
     * @param {ControlApiControlV0OverlayOverlayIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    ControlApi.prototype.controlV0OverlayOverlayIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ControlApiFp)(this.configuration).controlV0OverlayOverlayIdPost(requestParameters.overlayId, requestParameters.overlayRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ControlApi;
}(base_1.BaseAPI));
exports.ControlApi = ControlApi;
/**
 * EventApi - axios parameter creator
 * @export
 */
var EventApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Send event link by sms
         * @param {number} eventId
         * @param {ShareEventRequest} shareEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventV0EventEventIdSharePost: function (eventId, shareEventRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'eventId' is not null or undefined
                    (0, common_1.assertParamExists)('eventV0EventEventIdSharePost', 'eventId', eventId);
                    // verify required parameter 'shareEventRequest' is not null or undefined
                    (0, common_1.assertParamExists)('eventV0EventEventIdSharePost', 'shareEventRequest', shareEventRequest);
                    localVarPath = "/event/v0/event/{eventId}/share"
                        .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shareEventRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        }
    };
};
exports.EventApiAxiosParamCreator = EventApiAxiosParamCreator;
/**
 * EventApi - functional programming interface
 * @export
 */
var EventApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EventApiAxiosParamCreator)(configuration);
    return {
        /**
         * Send event link by sms
         * @param {number} eventId
         * @param {ShareEventRequest} shareEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventV0EventEventIdSharePost: function (eventId, shareEventRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.eventV0EventEventIdSharePost(eventId, shareEventRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
exports.EventApiFp = EventApiFp;
/**
 * EventApi - factory interface
 * @export
 */
var EventApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EventApiFp)(configuration);
    return {
        /**
         * Send event link by sms
         * @param {number} eventId
         * @param {ShareEventRequest} shareEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventV0EventEventIdSharePost: function (eventId, shareEventRequest, options) {
            return localVarFp.eventV0EventEventIdSharePost(eventId, shareEventRequest, options).then(function (request) { return request(axios, basePath); });
        }
    };
};
exports.EventApiFactory = EventApiFactory;
/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
var EventApi = /** @class */ (function (_super) {
    __extends(EventApi, _super);
    function EventApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Send event link by sms
     * @param {EventApiEventV0EventEventIdSharePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    EventApi.prototype.eventV0EventEventIdSharePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EventApiFp)(this.configuration).eventV0EventEventIdSharePost(requestParameters.eventId, requestParameters.shareEventRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EventApi;
}(base_1.BaseAPI));
exports.EventApi = EventApi;
/**
 * HosApi - axios parameter creator
 * @export
 */
var HosApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/otp";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(oTPUserCredentials, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCredentials, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokenRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update device details
         * @param {string} deviceId
         * @param {EldDeviceDetails} [eldDeviceDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosDeviceIdV0DetailsPost: function (deviceId, eldDeviceDetails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('hosDeviceIdV0DetailsPost', 'deviceId', deviceId);
                    localVarPath = "/hos/{deviceId}/v0/details"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eldDeviceDetails, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * List of devices
         * @param {string} deviceId
         * @param {'login' | 'logout'} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceDeviceIdActionPost: function (deviceId, action, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0DeviceDeviceIdActionPost', 'deviceId', deviceId);
                    // verify required parameter 'action' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0DeviceDeviceIdActionPost', 'action', action);
                    localVarPath = "/hos/v0/device/{deviceId}/{action}"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)))
                        .replace("{".concat("action", "}"), encodeURIComponent(String(action)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * List of devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Records list
         * @param {number} driverId
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverDriverIdRecordDateFromDateToGet: function (driverId, dateFrom, dateTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverId' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0DriverDriverIdRecordDateFromDateToGet', 'driverId', driverId);
                    // verify required parameter 'dateFrom' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0DriverDriverIdRecordDateFromDateToGet', 'dateFrom', dateFrom);
                    // verify required parameter 'dateTo' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0DriverDriverIdRecordDateFromDateToGet', 'dateTo', dateTo);
                    localVarPath = "/hos/v0/driver/{driverId}/record/{dateFrom}/{dateTo}"
                        .replace("{".concat("driverId", "}"), encodeURIComponent(String(driverId)))
                        .replace("{".concat("dateFrom", "}"), encodeURIComponent(String(dateFrom)))
                        .replace("{".concat("dateTo", "}"), encodeURIComponent(String(dateTo)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/driver";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Approve driver amend request
         * @param {EventEntryApproval} [eventEntryApproval]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendApprovalPost: function (eventEntryApproval, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/driver/record/amend/approval";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventEntryApproval, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update driver records
         * @param {Array<EventEntry>} [eventEntry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendPost: function (eventEntry, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/driver/record/amend";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventEntry, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Records list
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDateGet: function (date, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'date' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0DriverRecordDateGet', 'date', date);
                    localVarPath = "/hos/v0/driver/record/{date}"
                        .replace("{".concat("date", "}"), encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Certify records of day
         * @param {string} date
         * @param {Certification} [certification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDatePost: function (date, certification, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'date' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0DriverRecordDatePost', 'date', date);
                    localVarPath = "/hos/v0/driver/record/{date}"
                        .replace("{".concat("date", "}"), encodeURIComponent(String(date)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(certification, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Update driver status
         * @param {EventEntry} [eventEntry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordPost: function (eventEntry, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/driver/record";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventEntry, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * List of amend records
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordAmendDateFromDateToGet: function (dateFrom, dateTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dateFrom' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0RecordAmendDateFromDateToGet', 'dateFrom', dateFrom);
                    // verify required parameter 'dateTo' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0RecordAmendDateFromDateToGet', 'dateTo', dateTo);
                    localVarPath = "/hos/v0/record/amend/{dateFrom}/{dateTo}"
                        .replace("{".concat("dateFrom", "}"), encodeURIComponent(String(dateFrom)))
                        .replace("{".concat("dateTo", "}"), encodeURIComponent(String(dateTo)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * List of unassigned records groups
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedDateFromDateToGet: function (dateFrom, dateTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'dateFrom' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0RecordUnassignedDateFromDateToGet', 'dateFrom', dateFrom);
                    // verify required parameter 'dateTo' is not null or undefined
                    (0, common_1.assertParamExists)('hosV0RecordUnassignedDateFromDateToGet', 'dateTo', dateTo);
                    localVarPath = "/hos/v0/record/unassigned/{dateFrom}/{dateTo}"
                        .replace("{".concat("dateFrom", "}"), encodeURIComponent(String(dateFrom)))
                        .replace("{".concat("dateTo", "}"), encodeURIComponent(String(dateTo)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * assign unassigned records
         * @param {Array<HosUnassignedAssignmentRequest>} [hosUnassignedAssignmentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedPost: function (hosUnassignedAssignmentRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/record/unassigned";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hosUnassignedAssignmentRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Transfer hos data
         * @param {HosTransferRequest} [hosTransferRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0TransferPost: function (hosTransferRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hos/v0/transfer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hosTransferRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        }
    };
};
exports.HosApiAxiosParamCreator = HosApiAxiosParamCreator;
/**
 * HosApi - functional programming interface
 * @export
 */
var HosApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HosApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthOtpPost(oTPUserCredentials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthPost(userCredentials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAuthRefreshPost(refreshTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update device details
         * @param {string} deviceId
         * @param {EldDeviceDetails} [eldDeviceDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosDeviceIdV0DetailsPost: function (deviceId, eldDeviceDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosDeviceIdV0DetailsPost(deviceId, eldDeviceDetails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List of devices
         * @param {string} deviceId
         * @param {'login' | 'logout'} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceDeviceIdActionPost: function (deviceId, action, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DeviceDeviceIdActionPost(deviceId, action, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List of devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DeviceGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Records list
         * @param {number} driverId
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverDriverIdRecordDateFromDateToGet: function (driverId, dateFrom, dateTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DriverDriverIdRecordDateFromDateToGet(driverId, dateFrom, dateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DriverGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Approve driver amend request
         * @param {EventEntryApproval} [eventEntryApproval]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendApprovalPost: function (eventEntryApproval, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DriverRecordAmendApprovalPost(eventEntryApproval, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update driver records
         * @param {Array<EventEntry>} [eventEntry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendPost: function (eventEntry, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DriverRecordAmendPost(eventEntry, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Records list
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDateGet: function (date, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DriverRecordDateGet(date, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Certify records of day
         * @param {string} date
         * @param {Certification} [certification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDatePost: function (date, certification, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DriverRecordDatePost(date, certification, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update driver status
         * @param {EventEntry} [eventEntry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordPost: function (eventEntry, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0DriverRecordPost(eventEntry, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List of amend records
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordAmendDateFromDateToGet: function (dateFrom, dateTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0RecordAmendDateFromDateToGet(dateFrom, dateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List of unassigned records groups
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedDateFromDateToGet: function (dateFrom, dateTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0RecordUnassignedDateFromDateToGet(dateFrom, dateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * assign unassigned records
         * @param {Array<HosUnassignedAssignmentRequest>} [hosUnassignedAssignmentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedPost: function (hosUnassignedAssignmentRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0RecordUnassignedPost(hosUnassignedAssignmentRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Transfer hos data
         * @param {HosTransferRequest} [hosTransferRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0TransferPost: function (hosTransferRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hosV0TransferPost(hosTransferRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
exports.HosApiFp = HosApiFp;
/**
 * HosApi - factory interface
 * @export
 */
var HosApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HosApiFp)(configuration);
    return {
        /**
         *
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: function (oTPUserCredentials, options) {
            return localVarFp.apiAuthOtpPost(oTPUserCredentials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {UserCredentials} [userCredentials]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: function (userCredentials, options) {
            return localVarFp.apiAuthPost(userCredentials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: function (refreshTokenRequest, options) {
            return localVarFp.apiAuthRefreshPost(refreshTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update device details
         * @param {string} deviceId
         * @param {EldDeviceDetails} [eldDeviceDetails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosDeviceIdV0DetailsPost: function (deviceId, eldDeviceDetails, options) {
            return localVarFp.hosDeviceIdV0DetailsPost(deviceId, eldDeviceDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of devices
         * @param {string} deviceId
         * @param {'login' | 'logout'} action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceDeviceIdActionPost: function (deviceId, action, options) {
            return localVarFp.hosV0DeviceDeviceIdActionPost(deviceId, action, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceGet: function (options) {
            return localVarFp.hosV0DeviceGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Records list
         * @param {number} driverId
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverDriverIdRecordDateFromDateToGet: function (driverId, dateFrom, dateTo, options) {
            return localVarFp.hosV0DriverDriverIdRecordDateFromDateToGet(driverId, dateFrom, dateTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverGet: function (options) {
            return localVarFp.hosV0DriverGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Approve driver amend request
         * @param {EventEntryApproval} [eventEntryApproval]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendApprovalPost: function (eventEntryApproval, options) {
            return localVarFp.hosV0DriverRecordAmendApprovalPost(eventEntryApproval, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update driver records
         * @param {Array<EventEntry>} [eventEntry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendPost: function (eventEntry, options) {
            return localVarFp.hosV0DriverRecordAmendPost(eventEntry, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Records list
         * @param {string} date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDateGet: function (date, options) {
            return localVarFp.hosV0DriverRecordDateGet(date, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Certify records of day
         * @param {string} date
         * @param {Certification} [certification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDatePost: function (date, certification, options) {
            return localVarFp.hosV0DriverRecordDatePost(date, certification, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update driver status
         * @param {EventEntry} [eventEntry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordPost: function (eventEntry, options) {
            return localVarFp.hosV0DriverRecordPost(eventEntry, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of amend records
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordAmendDateFromDateToGet: function (dateFrom, dateTo, options) {
            return localVarFp.hosV0RecordAmendDateFromDateToGet(dateFrom, dateTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List of unassigned records groups
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedDateFromDateToGet: function (dateFrom, dateTo, options) {
            return localVarFp.hosV0RecordUnassignedDateFromDateToGet(dateFrom, dateTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * assign unassigned records
         * @param {Array<HosUnassignedAssignmentRequest>} [hosUnassignedAssignmentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedPost: function (hosUnassignedAssignmentRequest, options) {
            return localVarFp.hosV0RecordUnassignedPost(hosUnassignedAssignmentRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Transfer hos data
         * @param {HosTransferRequest} [hosTransferRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0TransferPost: function (hosTransferRequest, options) {
            return localVarFp.hosV0TransferPost(hosTransferRequest, options).then(function (request) { return request(axios, basePath); });
        }
    };
};
exports.HosApiFactory = HosApiFactory;
/**
 * HosApi - object-oriented interface
 * @export
 * @class HosApi
 * @extends {BaseAPI}
 */
var HosApi = /** @class */ (function (_super) {
    __extends(HosApi, _super);
    function HosApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get user token
     * @param {HosApiApiAuthOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.apiAuthOtpPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).apiAuthOtpPost(requestParameters.oTPUserCredentials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {HosApiApiAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.apiAuthPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).apiAuthPost(requestParameters.userCredentials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get user token
     * @param {HosApiApiAuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.apiAuthRefreshPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).apiAuthRefreshPost(requestParameters.refreshTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update device details
     * @param {HosApiHosDeviceIdV0DetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosDeviceIdV0DetailsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosDeviceIdV0DetailsPost(requestParameters.deviceId, requestParameters.eldDeviceDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of devices
     * @param {HosApiHosV0DeviceDeviceIdActionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DeviceDeviceIdActionPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0DeviceDeviceIdActionPost(requestParameters.deviceId, requestParameters.action, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DeviceGet = function (options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0DeviceGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Records list
     * @param {HosApiHosV0DriverDriverIdRecordDateFromDateToGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DriverDriverIdRecordDateFromDateToGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0DriverDriverIdRecordDateFromDateToGet(requestParameters.driverId, requestParameters.dateFrom, requestParameters.dateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get list of drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DriverGet = function (options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0DriverGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Approve driver amend request
     * @param {HosApiHosV0DriverRecordAmendApprovalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DriverRecordAmendApprovalPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).hosV0DriverRecordAmendApprovalPost(requestParameters.eventEntryApproval, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update driver records
     * @param {HosApiHosV0DriverRecordAmendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DriverRecordAmendPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).hosV0DriverRecordAmendPost(requestParameters.eventEntry, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Records list
     * @param {HosApiHosV0DriverRecordDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DriverRecordDateGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0DriverRecordDateGet(requestParameters.date, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Certify records of day
     * @param {HosApiHosV0DriverRecordDatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DriverRecordDatePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0DriverRecordDatePost(requestParameters.date, requestParameters.certification, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update driver status
     * @param {HosApiHosV0DriverRecordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0DriverRecordPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).hosV0DriverRecordPost(requestParameters.eventEntry, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of amend records
     * @param {HosApiHosV0RecordAmendDateFromDateToGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0RecordAmendDateFromDateToGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0RecordAmendDateFromDateToGet(requestParameters.dateFrom, requestParameters.dateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List of unassigned records groups
     * @param {HosApiHosV0RecordUnassignedDateFromDateToGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0RecordUnassignedDateFromDateToGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.HosApiFp)(this.configuration).hosV0RecordUnassignedDateFromDateToGet(requestParameters.dateFrom, requestParameters.dateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * assign unassigned records
     * @param {HosApiHosV0RecordUnassignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0RecordUnassignedPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).hosV0RecordUnassignedPost(requestParameters.hosUnassignedAssignmentRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Transfer hos data
     * @param {HosApiHosV0TransferPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    HosApi.prototype.hosV0TransferPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.HosApiFp)(this.configuration).hosV0TransferPost(requestParameters.hosTransferRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HosApi;
}(base_1.BaseAPI));
exports.HosApi = HosApi;
/**
 * InstallApi - axios parameter creator
 * @export
 */
var InstallApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Change VIN/license plate for a device
         * @param {ChangeVINRequest} [changeVINRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installChangeVinPost: function (changeVINRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install/change-vin";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeVINRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Create installation command
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installConnectDeviceIdPost: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('installConnectDeviceIdPost', 'deviceId', deviceId);
                    localVarPath = "/install/connect/{deviceId}"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get device installation params
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installParamsDeviceIdGet: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'deviceId' is not null or undefined
                    (0, common_1.assertParamExists)('installParamsDeviceIdGet', 'deviceId', deviceId);
                    localVarPath = "/install/params/{deviceId}"
                        .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Install new device
         * @param {InstallDeviceRequest} [installDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installPost: function (installDeviceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(installDeviceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Remove installed device
         * @param {RemoveDeviceRequest} [removeDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installRemovePost: function (removeDeviceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install/remove";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(removeDeviceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Generate installation report
         * @param {InstallationReportRequest} [installationReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installReportPost: function (installationReportRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install/report";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(installationReportRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Check old device and get installation params
         * @param {CheckDeviceRequest} [checkDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installSwitchPost: function (checkDeviceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install/switch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(checkDeviceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Request upload url for installation file
         * @param {string} fileType
         * @param {InstallationFileRequest} [installationFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installUploadFileTypePost: function (fileType, installationFileRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'fileType' is not null or undefined
                    (0, common_1.assertParamExists)('installUploadFileTypePost', 'fileType', fileType);
                    localVarPath = "/install/upload/{fileType}"
                        .replace("{".concat("fileType", "}"), encodeURIComponent(String(fileType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(installationFileRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2Get: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install/v2";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Request upload url for installation file
         * @param {InstallationFileRequestV2} [installationFileRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2UploadPost: function (installationFileRequestV2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install/v2/upload";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(installationFileRequestV2, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @summary Verify installed cameras
         * @param {VerifyCamerasRequest} [verifyCamerasRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installVerifyPost: function (verifyCamerasRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/install/verify";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyCamerasRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions
                        }];
                });
            });
        }
    };
};
exports.InstallApiAxiosParamCreator = InstallApiAxiosParamCreator;
/**
 * InstallApi - functional programming interface
 * @export
 */
var InstallApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InstallApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Change VIN/license plate for a device
         * @param {ChangeVINRequest} [changeVINRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installChangeVinPost: function (changeVINRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installChangeVinPost(changeVINRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create installation command
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installConnectDeviceIdPost: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installConnectDeviceIdPost(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get device installation params
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installParamsDeviceIdGet: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installParamsDeviceIdGet(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Install new device
         * @param {InstallDeviceRequest} [installDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installPost: function (installDeviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installPost(installDeviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove installed device
         * @param {RemoveDeviceRequest} [removeDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installRemovePost: function (removeDeviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installRemovePost(removeDeviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate installation report
         * @param {InstallationReportRequest} [installationReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installReportPost: function (installationReportRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installReportPost(installationReportRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Check old device and get installation params
         * @param {CheckDeviceRequest} [checkDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installSwitchPost: function (checkDeviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installSwitchPost(checkDeviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Request upload url for installation file
         * @param {string} fileType
         * @param {InstallationFileRequest} [installationFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installUploadFileTypePost: function (fileType, installationFileRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installUploadFileTypePost(fileType, installationFileRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2Get: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installV2Get(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Request upload url for installation file
         * @param {InstallationFileRequestV2} [installationFileRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2UploadPost: function (installationFileRequestV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installV2UploadPost(installationFileRequestV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Verify installed cameras
         * @param {VerifyCamerasRequest} [verifyCamerasRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installVerifyPost: function (verifyCamerasRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.installVerifyPost(verifyCamerasRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1["default"], base_1.BASE_PATH, configuration)];
                    }
                });
            });
        }
    };
};
exports.InstallApiFp = InstallApiFp;
/**
 * InstallApi - factory interface
 * @export
 */
var InstallApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InstallApiFp)(configuration);
    return {
        /**
         *
         * @summary Change VIN/license plate for a device
         * @param {ChangeVINRequest} [changeVINRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installChangeVinPost: function (changeVINRequest, options) {
            return localVarFp.installChangeVinPost(changeVINRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create installation command
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installConnectDeviceIdPost: function (deviceId, options) {
            return localVarFp.installConnectDeviceIdPost(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installGet: function (options) {
            return localVarFp.installGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get device installation params
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installParamsDeviceIdGet: function (deviceId, options) {
            return localVarFp.installParamsDeviceIdGet(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Install new device
         * @param {InstallDeviceRequest} [installDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installPost: function (installDeviceRequest, options) {
            return localVarFp.installPost(installDeviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove installed device
         * @param {RemoveDeviceRequest} [removeDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installRemovePost: function (removeDeviceRequest, options) {
            return localVarFp.installRemovePost(removeDeviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate installation report
         * @param {InstallationReportRequest} [installationReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installReportPost: function (installationReportRequest, options) {
            return localVarFp.installReportPost(installationReportRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Check old device and get installation params
         * @param {CheckDeviceRequest} [checkDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installSwitchPost: function (checkDeviceRequest, options) {
            return localVarFp.installSwitchPost(checkDeviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request upload url for installation file
         * @param {string} fileType
         * @param {InstallationFileRequest} [installationFileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installUploadFileTypePost: function (fileType, installationFileRequest, options) {
            return localVarFp.installUploadFileTypePost(fileType, installationFileRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2Get: function (options) {
            return localVarFp.installV2Get(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request upload url for installation file
         * @param {InstallationFileRequestV2} [installationFileRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2UploadPost: function (installationFileRequestV2, options) {
            return localVarFp.installV2UploadPost(installationFileRequestV2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Verify installed cameras
         * @param {VerifyCamerasRequest} [verifyCamerasRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installVerifyPost: function (verifyCamerasRequest, options) {
            return localVarFp.installVerifyPost(verifyCamerasRequest, options).then(function (request) { return request(axios, basePath); });
        }
    };
};
exports.InstallApiFactory = InstallApiFactory;
/**
 * InstallApi - object-oriented interface
 * @export
 * @class InstallApi
 * @extends {BaseAPI}
 */
var InstallApi = /** @class */ (function (_super) {
    __extends(InstallApi, _super);
    function InstallApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Change VIN/license plate for a device
     * @param {InstallApiInstallChangeVinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installChangeVinPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InstallApiFp)(this.configuration).installChangeVinPost(requestParameters.changeVINRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create installation command
     * @param {InstallApiInstallConnectDeviceIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installConnectDeviceIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InstallApiFp)(this.configuration).installConnectDeviceIdPost(requestParameters.deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of new devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installGet = function (options) {
        var _this = this;
        return (0, exports.InstallApiFp)(this.configuration).installGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get device installation params
     * @param {InstallApiInstallParamsDeviceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installParamsDeviceIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InstallApiFp)(this.configuration).installParamsDeviceIdGet(requestParameters.deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Install new device
     * @param {InstallApiInstallPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InstallApiFp)(this.configuration).installPost(requestParameters.installDeviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove installed device
     * @param {InstallApiInstallRemovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installRemovePost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InstallApiFp)(this.configuration).installRemovePost(requestParameters.removeDeviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate installation report
     * @param {InstallApiInstallReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installReportPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InstallApiFp)(this.configuration).installReportPost(requestParameters.installationReportRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Check old device and get installation params
     * @param {InstallApiInstallSwitchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installSwitchPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InstallApiFp)(this.configuration).installSwitchPost(requestParameters.checkDeviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request upload url for installation file
     * @param {InstallApiInstallUploadFileTypePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installUploadFileTypePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InstallApiFp)(this.configuration).installUploadFileTypePost(requestParameters.fileType, requestParameters.installationFileRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get list of new devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installV2Get = function (options) {
        var _this = this;
        return (0, exports.InstallApiFp)(this.configuration).installV2Get(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request upload url for installation file
     * @param {InstallApiInstallV2UploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installV2UploadPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InstallApiFp)(this.configuration).installV2UploadPost(requestParameters.installationFileRequestV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Verify installed cameras
     * @param {InstallApiInstallVerifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    InstallApi.prototype.installVerifyPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InstallApiFp)(this.configuration).installVerifyPost(requestParameters.verifyCamerasRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InstallApi;
}(base_1.BaseAPI));
exports.InstallApi = InstallApi;
